





// import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
// import Select, { components } from 'react-select';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   LineElement,
//   PointElement,
// } from 'chart.js';
// import { Pie, Bar, Line } from 'react-chartjs-2';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Report.css';

// // Register Chart.js components
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   LineElement,
//   PointElement,
//   ChartDataLabels
// );

// // --- Constants from Environment Variables ---
// // Using environment variables to avoid hardcoding URLs
// const API_BASE_URL = process.env.REACT_APP_REPORTS_API_URL;
// const MAIL_API_URL = process.env.REACT_APP_MAIL_API_URL;
// const NODE_SERVICE_BASE_URL = process.env.REACT_APP_NODE_SERVICE_BASE_URL;
// const COMMON_MASTER_API_URL = `${NODE_SERVICE_BASE_URL}/api/get-column/common_master`;


// const GRAPH_TYPES = [
//   { value: 'Pie', label: 'Pie Chart' },
//   { value: 'Bar', label: 'Bar Chart' },
// ];

// const parseJwt = (token) => {
//   try {
//     return JSON.parse(atob(token.split('.')[1]));
//   } catch (e) {
//     console.error("Failed to parse JWT:", e);
//     return null;
//   }
// };

// const createOptions = (data, key) => {
//   if (!data || data.length === 0 || !key) return [];
//   const uniqueValues = [...new Set(data.map(item => item[key]).filter(Boolean))];
//   return uniqueValues.sort().map(value => ({ value, label: value }));
// };

// const formatHeader = (header) => {
//   if (!header) return '';
//   return header
//     .replace(/_/g, ' ')
//     .replace(/id/g, 'ID')
//     .replace(/\b\w/g, char => char.toUpperCase());
// };

// const findValueColumn = (columns) => {
//   const commonValueNames = ['total', 'count', 'sum', 'amount', 'value'];
//   return columns.find(col =>
//     commonValueNames.some(name => col.toLowerCase().includes(name))
//   ) || null;
// };

// const generateDynamicColors = (numColors) => {
//   const colors = [];
//   for (let i = 0; i < numColors; i++) {
//     const hue = (i * 137.508) % 360;
//     colors.push(`hsla(${hue}, 70%, 60%, 0.8)`);
//   }
//   return colors;
// };

// const exportToCSV = (tasks, columns, filename) => {
//   if (!tasks || tasks.length === 0 || !columns || columns.length === 0) {
//     alert("No data available to export.");
//     return;
//   }

//   const headers = columns.map(formatHeader);
//   const csvRows = [
//     headers.join(','),
//     ...tasks.map(task =>
//       columns.map(column => {
//         let cellData = task[column];
//         if (cellData === null || cellData === undefined) return '""';
//         if (Array.isArray(cellData)) {
//           cellData = cellData.filter(item => item).join('; ');
//         }
//         const stringData = String(cellData).replace(/"/g, '""');
//         return `"${stringData}"`;
//       }).join(',')
//     )
//   ];

//   const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
//   const link = document.createElement('a');
//   const url = URL.createObjectURL(blob);
//   link.setAttribute('href', url);
//   link.setAttribute('download', filename);
//   link.style.visibility = 'hidden';
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };

// const generateCSVFile = (tasks, columns, filename) => {
//   if (!tasks || tasks.length === 0 || !columns || columns.length === 0) {
//     return null;
//   }

//   const headers = columns.map(formatHeader);
//   const csvRows = [
//     headers.join(','),
//     ...tasks.map(task =>
//       columns.map(column => {
//         let cellData = task[column];
//         if (cellData === null || cellData === undefined) return '""';
//         if (Array.isArray(cellData)) {
//           cellData = cellData.filter(item => item).join('; ');
//         }
//         const stringData = String(cellData).replace(/"/g, '""');
//         return `"${stringData}"`;
//       }).join(',')
//     )
//   ];

//   const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
//   return new File([blob], filename, { type: 'text/csv;charset=utf-8;' });
// };


// const CheckboxOption = (props) => {
//   return (
//     <components.Option {...props}>
//       <input
//         type="checkbox"
//         checked={props.isSelected}
//         onChange={() => null}
//         style={{ marginRight: '10px' }}
//       />
//       <label>{props.label}</label>
//     </components.Option>
//   );
// };


// const ReportPage = () => {
//   // --- State for authentication token ---
//   const [authToken, setAuthToken] = useState(null);
//   const bearerToken = useMemo(() => authToken ? `Bearer ${authToken}` : null, [authToken]);

//   // State management
//   const [allReports, setAllReports] = useState([]);
//   const [selectedReport, setSelectedReport] = useState('');
//   const [allTasks, setAllTasks] = useState([]);
//   const [tableColumns, setTableColumns] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewMode, setViewMode] = useState('list');
//   const [reportPermissions, setReportPermissions] = useState({
//     canPrint: false,
//     canExport: false
//   });

//   // Filter state
//   const [users, setUsers] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedGraphType, setSelectedGraphType] = useState('Pie');
//   const [selectedUser, setSelectedUser] = useState('');
//   const [selectedProject, setSelectedProject] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState('');

//   // State for dynamic filters
//   const [years, setYears] = useState([]);
//   const [months, setMonths] = useState([]);
//   const [selectedYear, setSelectedYear] = useState('');
//   const [selectedMonth, setSelectedMonth] = useState('');

//   // State for available options based on data
//   const [availableYears, setAvailableYears] = useState([]);
//   const [availableMonths, setAvailableMonths] = useState([]);

//   // Dynamic column names for filtering
//   const [filterColumnNames, setFilterColumnNames] = useState({
//     user: null,
//     project: null,
//     category: null,
//     date: null
//   });

//   const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
//   const [emailTo, setEmailTo] = useState([]);
//   const [emailCc, setEmailCc] = useState('');
//   const [emailBcc, setEmailBcc] = useState('');
//   const [emailSubject, setEmailSubject] = useState('');
//   const [emailBody, setEmailBody] = useState('');
//   const [emailAttachments, setEmailAttachments] = useState([]);
//   const [emailSending, setEmailSending] = useState(false);
//   const [emailStatus, setEmailStatus] = useState({ message: '', type: '' });
//   const [emailRecipients, setEmailRecipients] = useState([]);
//   const [isFetchingRecipients, setIsFetchingRecipients] = useState(false);

//   // Refs
//   const printableRef = useRef();
//   const fileInputRef = useRef(null);
//   const customSelectStyles = {
//     menu: (provided) => ({ ...provided, zIndex: 9999 }),
//   };

//   // --- Get User ID from Token ---
//   const currentUserId = useMemo(() => {
//     if (!authToken) return null;
//     const parsedToken = parseJwt(authToken);
//     return parsedToken?.claims?.user_ID;
//   }, [authToken]);

//   const currentReportObject = useMemo(() =>
//     allReports.find(report => report.report_name === selectedReport),
//     [allReports, selectedReport]
//   );

//   const isGraphEnabled = useMemo(() =>
//     currentReportObject?.graph === 'yes',
//     [currentReportObject]
//   );

//   // --- API Call Functions using dynamic token ---
//   const fetchMonths = useCallback(async () => {
//     if (!bearerToken) return;
//     try {
//       const response = await fetch(`${COMMON_MASTER_API_URL}/month_name`, {
//         headers: { accept: 'application/json', Authorization: bearerToken },
//       });
//       if (response.ok) {
//         const monthData = await response.json();
//         const sortedMonths = monthData.sort((a, b) => a.id - b.id);
//         setMonths(sortedMonths);
//       } else {
//         throw new Error(`Failed to fetch months: ${response.status}`);
//       }
//     } catch (error) {
//       console.error('fetchMonths error:', error);
//       setMonths([]);
//     }
//   }, [bearerToken]);

//   const fetchYears = useCallback(async () => {
//     if (!bearerToken) return;
//     try {
//       const [fromResponse, toResponse] = await Promise.all([
//         fetch(`${COMMON_MASTER_API_URL}/from_date`, {
//           headers: { accept: 'application/json', Authorization: bearerToken },
//         }),
//         fetch(`${COMMON_MASTER_API_URL}/to_date`, {
//           headers: { accept: 'application/json', Authorization: bearerToken },
//         }),
//       ]);

//       if (!fromResponse.ok || !toResponse.ok) {
//         throw new Error('Failed to fetch financial years');
//       }

//       const fromData = await fromResponse.json();
//       const toData = await toResponse.json();

//       const yearOptions = fromData.map((from) => {
//         const to = toData.find((t) => t.id === from.id);
//         const fromYear = new Date(from.value).getFullYear();
//         const toYear = new Date(to.value).getFullYear();
//         return {
//           id: from.id,
//           label: `${fromYear}-${toYear.toString().slice(-2)}`,
//           from_date: from.value,
//           to_date: to.value,
//         };
//       }).sort((a, b) => b.id - a.id);

//       setYears(yearOptions);
//     } catch (error) {
//       console.error('fetchYears error:', error);
//       setYears([]);
//     }
//   }, [bearerToken]);


//   const fetchReportList = useCallback(async () => {
//     if (!bearerToken) return;
//     setLoading(true);
//     try {
//       const response = await fetch(`${API_BASE_URL}/reports`, {
//         method: 'GET',
//         headers: {
//           'Accept': 'application/json',
//           'Authorization': bearerToken,
//         },
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       const result = await response.json();
//       const reports = result || [];
//       setAllReports(reports);

//       if (reports.length > 0) {
//         setSelectedReport(reports[0].report_name);
//       } else {
//         setLoading(false);
//       }
//     } catch (err) {
//       console.error("Failed to fetch report list:", err);
//       setError("Could not load report options.");
//       setLoading(false);
//     }
//   }, [bearerToken]);

//   const fetchReportData = useCallback(async (reportName) => {
//     if (!reportName || !bearerToken) {
//       // Clear data if no report is selected or not authenticated
//       setAllTasks([]);
//       setTableColumns([]);
//       setReportPermissions({ canPrint: false, canExport: false });
//       if (allReports.length > 0) setLoading(false);
//       return;
//     }

//     setLoading(true);
//     setError(null);
//     // Reset filters on new report selection
//     setSelectedUser('');
//     setSelectedYear('');
//     setSelectedMonth('');
//     setSelectedProject('');
//     setSelectedCategory('');
//     setSearchTerm('');

//     try {
//       const response = await fetch(`${API_BASE_URL}/reports/run`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json',
//           'Authorization': bearerToken,
//         },
//         body: JSON.stringify({
//           report_name: reportName,
//           module_name: 'ZTask'
//         }),
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       const result = await response.json();
//       const data = result.data || [];
//       const columns = result.columns || [];

//       setTableColumns(columns);
//       setAllTasks(data);

//       const findColumn = (possibleNames) =>
//         columns.find(c => possibleNames.includes(c.toLowerCase()));

//       const newFilterColumns = {
//         user: findColumn(['assignee_name', 'user_name', 'user', 'assignee', 'task assignee']),
//         project: findColumn(['project_name', 'project']),
//         category: findColumn(['category', 'task_category']),
//         date: findColumn(['due_date', 'report date', 'report_date', 'created_at', 'task open dt'])
//       };

//       setFilterColumnNames(newFilterColumns);

//       setUsers(createOptions(data, newFilterColumns.user));
//       setProjects(createOptions(data, newFilterColumns.project));
//       setCategories(createOptions(data, newFilterColumns.category));

//     } catch (err) {
//       console.error("Failed to fetch report data:", err);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   }, [allReports.length, bearerToken]);

//   const fetchEmailRecipients = useCallback(async () => {
//     if (!bearerToken) return;
//     setIsFetchingRecipients(true);
//     setEmailStatus({ message: '', type: '' });

//     try {
//       const response = await fetch(`${API_BASE_URL}/reports/get-columns`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json',
//           'Authorization': bearerToken
//         },
//         body: JSON.stringify({
//           table_name: "users",
//           column_names: ["email"]
//         })
//       });

//       if (!response.ok) {
//         throw new Error(`Failed to fetch email recipients. Status: ${response.status}`);
//       }

//       const result = await response.json();
//       if (result.data && Array.isArray(result.data)) {
//         const formattedRecipients = result.data
//           .map(user => ({ value: user.email, label: user.email }))
//           .sort((a, b) => a.label.localeCompare(b.label));
//         setEmailRecipients(formattedRecipients);
//       } else {
//         throw new Error("Invalid data format for email recipients.");
//       }
//     } catch (err) {
//       console.error(err);
//       setEmailStatus({
//         message: 'Could not load email recipients.',
//         type: 'error'
//       });
//       setEmailRecipients([]);
//     } finally {
//       setIsFetchingRecipients(false);
//     }
//   }, [bearerToken]);

//   // --- Effects ---

//   // Effect to get token from Local Storage on component mount
//   useEffect(() => {
//     const token = localStorage.getItem('zTaskAuthToken');
//     if (token) {
//       setAuthToken(token);
//     } else {
//       console.error("Authentication token not found in local storage.");
//       setError("You are not authenticated. Please log in.");
//       setLoading(false);
//     }
//   }, []);

//   // Effect to fetch initial master data once authenticated
//   useEffect(() => {
//     if (bearerToken) {
//       fetchReportList();
//       fetchMonths();
//       fetchYears();
//     }
//   }, [bearerToken, fetchReportList, fetchMonths, fetchYears]);

//   // Effect to fetch report data when selection changes
//   useEffect(() => {
//     if (selectedReport && bearerToken) {
//         fetchReportData(selectedReport);
//     }

//     if (currentReportObject) {
//       setViewMode(isGraphEnabled ? 'both' : 'list');
//       if (currentUserId) {
//         const canPrint = currentReportObject.print?.includes(currentUserId) ?? false;
//         const canExport = currentReportObject.export?.includes(currentUserId) ?? false;
//         setReportPermissions({ canPrint, canExport });
//       } else {
//         setReportPermissions({ canPrint: false, canExport: false });
//       }
//     }
//   }, [selectedReport, bearerToken, fetchReportData, currentReportObject, isGraphEnabled, currentUserId]);

//   // Effect to derive available filter options from data
//   useEffect(() => {
//     if (!allTasks.length || !filterColumnNames.date || !months.length || !years.length) {
//       setAvailableMonths([]);
//       setAvailableYears([]);
//       return;
//     }

//     const dateCol = filterColumnNames.date;
//     const presentMonthIds = new Set();
//     const presentYearIds = new Set();

//     allTasks.forEach(task => {
//       const taskDateValue = task[dateCol];
//       if (!taskDateValue) return;

//       const taskDate = new Date(taskDateValue);
//       if (isNaN(taskDate.getTime())) return;

//       const monthId = (taskDate.getMonth() + 1).toString();
//       presentMonthIds.add(monthId);

//       for (const yearOption of years) {
//         const fromDate = new Date(yearOption.from_date);
//         const toDate = new Date(yearOption.to_date);
//         toDate.setHours(23, 59, 59, 999);

//         if (taskDate >= fromDate && taskDate <= toDate) {
//           presentYearIds.add(yearOption.id);
//           break;
//         }
//       }
//     });

//     const filteredMonths = months
//       .filter(month => presentMonthIds.has(month.id.toString()))
//       .sort((a, b) => a.id - b.id);

//     const filteredYears = years
//       .filter(year => presentYearIds.has(year.id))
//       .sort((a, b) => b.id - a.id);

//     setAvailableMonths(filteredMonths);
//     setAvailableYears(filteredYears);

//   }, [allTasks, filterColumnNames.date, months, years]);


//   // Filtered data
//   const filteredAndSearchedTasks = useMemo(() => {
//     let tempTasks = [...allTasks];
//     const { user, project, category, date } = filterColumnNames;

//     if (selectedUser && user) tempTasks = tempTasks.filter(t => t[user] === selectedUser);
//     if (selectedProject && project) tempTasks = tempTasks.filter(t => t[project] === selectedProject);
//     if (selectedCategory && category) tempTasks = tempTasks.filter(t => t[category] === selectedCategory);

//     if (date) {
//       if (selectedYear) {
//         const selectedYearData = years.find(y => y.id.toString() === selectedYear);
//         if (selectedYearData) {
//           const fromDate = new Date(selectedYearData.from_date);
//           const toDate = new Date(selectedYearData.to_date);
//           tempTasks = tempTasks.filter(t => {
//             const taskDate = new Date(t[date]);
//             return taskDate >= fromDate && taskDate <= toDate;
//           });
//         }
//       }

//       if (selectedMonth) {
//         tempTasks = tempTasks.filter(t =>
//           (new Date(t[date]).getMonth() + 1).toString() === selectedMonth
//         );
//       }
//     }

//     if (searchTerm.trim() !== '') {
//       const lowercasedTerm = searchTerm.toLowerCase();
//       tempTasks = tempTasks.filter(task =>
//         tableColumns.some(col =>
//           String(task[col]).toLowerCase().includes(lowercasedTerm)
//         )
//       );
//     }

//     return tempTasks;
//   }, [
//     allTasks,
//     tableColumns,
//     selectedUser,
//     selectedProject,
//     selectedCategory,
//     searchTerm,
//     filterColumnNames,
//     selectedYear,
//     selectedMonth,
//     years,
//   ]);

//   const dynamicTableTitle = useMemo(() => {
//     const activeFilters = [selectedReport];
//     if (selectedUser) activeFilters.push(selectedUser);
//     if (selectedProject) activeFilters.push(selectedProject);
//     if (selectedCategory) activeFilters.push(selectedCategory);

//     if (selectedYear) {
//       const yearLabel = years.find(y => y.id.toString() === selectedYear)?.label;
//       if (yearLabel) activeFilters.push(`Year: ${yearLabel}`);
//     }
//     if (selectedMonth) {
//       const monthLabel = months.find(m => m.id.toString() === selectedMonth)?.value;
//       if (monthLabel) activeFilters.push(monthLabel);
//     }
//     return activeFilters.length > 1 ? activeFilters.join(' - ') : selectedReport;
//   }, [selectedUser, selectedProject, selectedCategory, selectedYear, selectedMonth, selectedReport, years, months]);

//   const chartData = useMemo(() => {
//     const dataToChart = filteredAndSearchedTasks;
//     if (!dataToChart || dataToChart.length === 0 || tableColumns.length === 0) {
//       return { labels: [], datasets: [] };
//     }

//     const valueColumn = findValueColumn(tableColumns);
//     if (valueColumn) {
//       const labelColumns = tableColumns.filter(c => c !== valueColumn);

//       if (labelColumns.length >= 2) {
//         const primaryLabelCol = labelColumns[0];
//         const seriesCol = labelColumns[1];
//         const labels = [...new Set(dataToChart.map(item => item[primaryLabelCol]))].sort();
//         const seriesNames = [...new Set(dataToChart.map(item => item[seriesCol]))].sort();
//         const colors = generateDynamicColors(seriesNames.length);

//         const datasets = seriesNames.map((seriesName, index) => ({
//           label: seriesName,
//           data: labels.map(label => {
//             const dataPoint = dataToChart.find(item =>
//               item[primaryLabelCol] === label && item[seriesCol] === seriesName
//             );
//             return dataPoint ? parseFloat(dataPoint[valueColumn]) || 0 : 0;
//           }),
//           backgroundColor: colors[index],
//           borderColor: colors[index].replace('0.8', '1'),
//           borderWidth: 1,
//         }));

//         return { labels, datasets };
//       }

//       if (labelColumns.length === 1) {
//         const labelCol = labelColumns[0];
//         const labels = dataToChart.map(item => item[labelCol]);
//         const data = dataToChart.map(item => parseFloat(item[valueColumn]) || 0);
//         return {
//           labels,
//           datasets: [{
//             label: formatHeader(valueColumn),
//             data,
//             backgroundColor: generateDynamicColors(labels.length),
//             borderColor: '#fff',
//             borderWidth: 1
//           }]
//         };
//       }
//     }

//     const statusCounts = dataToChart.reduce((acc, task) => {
//       const status = task.status || 'Unknown';
//       acc[status] = (acc[status] || 0) + 1;
//       return acc;
//     }, {});

//     const labels = Object.keys(statusCounts);
//     const data = Object.values(statusCounts);

//     return {
//       labels,
//       datasets: [{
//         label: 'Number of Items',
//         data,
//         backgroundColor: generateDynamicColors(labels.length),
//         borderColor: '#fff',
//         borderWidth: 1
//       }]
//     };
//   }, [filteredAndSearchedTasks, tableColumns]);

//   // Event handlers
//   const handlePrint = useCallback(() => {
//     window.print();
//   }, []);

//   const handleOpenEmailModal = useCallback(() => {
//     fetchEmailRecipients();
//     setEmailSubject(dynamicTableTitle);
//     setEmailBody(``);

//     const reportFile = generateCSVFile(
//       filteredAndSearchedTasks,
//       tableColumns,
//       `${selectedReport}_report.csv`
//     );

//     if (reportFile) {
//       setEmailAttachments([reportFile]);
//     } else {
//       setEmailAttachments([]);
//     }

//     setEmailTo([]);
//     setEmailCc('');
//     setEmailBcc('');
//     setEmailStatus({ message: '', type: '' });
//     setEmailSending(false);
//     setIsEmailModalOpen(true);
//   }, [dynamicTableTitle, filteredAndSearchedTasks, tableColumns, selectedReport, fetchEmailRecipients]);

//   const handleAddAttachment = useCallback((e) => {
//     if (e.target.files) {
//       setEmailAttachments(prev => [...prev, ...Array.from(e.target.files)]);
//     }
//   }, []);

//   const handleRemoveAttachment = useCallback((indexToRemove) => {
//     setEmailAttachments(prev => prev.filter((_, index) => index !== indexToRemove));
//   }, []);

//   const handleSendEmail = useCallback(async (e) => {
//     e.preventDefault();

//     if (emailTo.length === 0 || !emailSubject || !emailBody) {
//       setEmailStatus({
//         message: 'Please select at least one recipient and fill in Subject and Body.',
//         type: 'error'
//       });
//       return;
//     }

//     setEmailSending(true);
//     setEmailStatus({ message: '', type: '' });

//     try {
//       const params = new URLSearchParams();
//       emailTo.forEach(option => params.append('to', option.value));

//       const processEmails = (emailString) =>
//         emailString.split(',').map(e => e.trim()).filter(e => e && e.includes('@'));

//       processEmails(emailCc).forEach(email => params.append('cc', email));
//       processEmails(emailBcc).forEach(email => params.append('bcc', email));
//       params.append('subject', emailSubject);
//       params.append('body', emailBody);

//       const attachmentFormData = new FormData();
//       emailAttachments.forEach(file => {
//         attachmentFormData.append('attachment', file, file.name);
//       });

//       const fullUrl = `${MAIL_API_URL}?${params.toString()}`;

//       const requestOptions = {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//         },
//         body: attachmentFormData,
//       };

//       const response = await fetch(fullUrl, requestOptions);

//       if (!response.ok) {
//         let errorMsg;
//         try {
//           const errorResult = await response.json();
//           errorMsg = errorResult.error || errorResult.message || JSON.stringify(errorResult);
//         } catch (jsonError) {
//           const textResponse = await response.text();
//           errorMsg = textResponse || `Request failed with status: ${response.status}`;
//         }
//         throw new Error(errorMsg);
//       }

//       const result = await response.json();
//       setEmailStatus({
//         message: result.message || 'Email sent successfully!',
//         type: 'success'
//       });
//       setTimeout(() => setIsEmailModalOpen(false), 2000);

//     } catch (error) {
//       console.error('Failed to send email:', error);
//       setEmailStatus({
//         message: error.message || 'An unexpected error occurred.',
//         type: 'error'
//       });
//     } finally {
//       setEmailSending(false);
//     }
//   }, [emailTo, emailSubject, emailBody, emailCc, emailBcc, emailAttachments]);

//   const renderCell = useCallback((task, column) => {
//     let value = task[column];
//     if (value === null || value === undefined) {
//       return <span className="cell-na">N/A</span>;
//     }

//     if (column === 'status') {
//       return <span className={`status-badge status-${String(value).toLowerCase()}`}>{value}</span>;
//     }

//     if (column === 'priority') {
//       return <span className={`priority-badge priority-${String(value).toLowerCase()}`}>{value}</span>;
//     }

//     if (['due_date', 'created_at', 'updated_at', 'completed_at', 'Report Date', 'TASK OPEN DT'].includes(column)) {
//       const date = new Date(value);
//       return !isNaN(date.getTime()) ? date.toLocaleString() : String(value);
//     }

//     if (Array.isArray(value)) {
//       const displayValue = value.filter(item => item != null).join(', ');
//       return displayValue || <span className="cell-na">N/A</span>;
//     }

//     const stringValue = String(value);
//     if (column === 'description' && stringValue.length > 100) {
//       return <span title={stringValue}>{stringValue.substring(0, 100)}...</span>;
//     }

//     return stringValue;
//   }, []);

//   const renderChart = useCallback(() => {
//     if (filteredAndSearchedTasks.length === 0 && selectedReport) {
//       return <p className="status-message">No data matches the current filters.</p>;
//     }

//     if (!selectedReport || !chartData.datasets.length) return null;

//     const chartOptions = {
//       responsive: true,
//       maintainAspectRatio: false,
//       plugins: {
//         legend: { position: 'top' },
//         title: {
//           display: true,
//           text: selectedReport || 'Report',
//           font: { size: 18 }
//         },
//         datalabels: selectedGraphType === 'Pie' ? {
//           formatter: (value) => value,
//           color: '#fff',
//           font: { weight: 'bold', size: 16 }
//         } : {
//           display: false
//         }
//       },
//       ...(selectedGraphType !== 'Pie' && {
//         scales: { y: { beginAtZero: true } }
//       })
//     };

//     switch (selectedGraphType) {
//       case 'Pie':
//         return <Pie options={chartOptions} data={chartData} />;
//       case 'Line':
//         return <Line options={chartOptions} data={chartData} />;
//       case 'Bar':
//       default:
//         return <Bar options={chartOptions} data={chartData} />;
//     }
//   }, [filteredAndSearchedTasks, selectedReport, chartData, selectedGraphType]);

//   // --- Render Logic ---
//   if (error) {
//     return <div className="status-message error">Error: {error}</div>;
//   }

//   // Remainder of the return statement is identical...
//   return (
//     <div className="report-container">
//       <div className="non-printable-header">
//         <h1>Reports</h1>
//         <div className="filters-container">
//           <select
//             className="filter-select report-name-select"
//             value={selectedReport}
//             onChange={e => setSelectedReport(e.target.value)}
//             disabled={!bearerToken || allReports.length === 0}
//           >
//             {allReports.map(report => (
//               <option key={report.id} value={report.report_name}>
//                 {report.report_name}
//               </option>
//             ))}
//           </select>

//           {isGraphEnabled && (
//             <select
//               className="filter-select"
//               value={selectedGraphType}
//               onChange={e => setSelectedGraphType(e.target.value)}
//               disabled={!selectedReport}
//             >
//               {GRAPH_TYPES.map(opt => (
//                 <option key={opt.value} value={opt.value}>
//                   {opt.label}
//                 </option>
//               ))}
//             </select>
//           )}

//           <select
//             className="filter-select"
//             value={selectedUser}
//             onChange={e => setSelectedUser(e.target.value)}
//             disabled={!selectedReport || !filterColumnNames.user}
//           >
//             <option value="">All Users</option>
//             {users.map(opt => (
//               <option key={opt.value} value={opt.value}>
//                 {opt.label}
//               </option>
//             ))}
//           </select>

//           <select
//             className="filter-select"
//             value={selectedYear}
//             onChange={e => setSelectedYear(e.target.value)}
//             disabled={!selectedReport || availableYears.length === 0}
//           >
//             <option value="">All Years</option>
//             {availableYears.map(opt => (
//               <option key={opt.id} value={opt.id}>
//                 {opt.label}
//               </option>
//             ))}
//           </select>

//           <select
//             className="filter-select"
//             value={selectedMonth}
//             onChange={e => setSelectedMonth(e.target.value)}
//             disabled={!selectedReport || availableMonths.length === 0}
//           >
//             <option value="">All Months</option>
//             {availableMonths.map(opt => (
//               <option key={opt.id} value={opt.id}>
//                 {opt.value}
//               </option>
//             ))}
//           </select>

//           <select
//             className="filter-select"
//             value={selectedProject}
//             onChange={e => setSelectedProject(e.target.value)}
//             disabled={!selectedReport || !filterColumnNames.project}
//           >
//             <option value="">All Projects</option>
//             {projects.map(opt => (
//               <option key={opt.value} value={opt.value}>
//                 {opt.label}
//               </option>
//             ))}
//           </select>

//           <select
//             className="filter-select"
//             value={selectedCategory}
//             onChange={e => setSelectedCategory(e.target.value)}
//             disabled={!selectedReport || !filterColumnNames.category}
//           >
//             <option value="">All Categories</option>
//             {categories.map(opt => (
//               <option key={opt.value} value={opt.value}>
//                 {opt.label}
//               </option>
//             ))}
//           </select>
//         </div>
//       </div>

//       {loading && <div className="status-message">Loading Report...</div>}

//       {!loading && !selectedReport && allReports.length > 0 && (
//         <div className="status-message">Please select a report to view data.</div>
//       )}

//       {!loading && allReports.length === 0 && !error && (
//         <div className="status-message">No reports available.</div>
//       )}

//       <div ref={printableRef} className="printable-content">
//         {!loading && selectedReport && (
//           <>
//             {isGraphEnabled && (
//               <div className="view-toggle-wrapper non-printable">
//                 <button
//                   className={`view-toggle-button ${viewMode === 'graph' ? 'active' : ''}`}
//                   onClick={() => setViewMode('graph')}
//                 >
//                   Graph
//                 </button>
//                 <button
//                   className={`view-toggle-button ${viewMode === 'list' ? 'active' : ''}`}
//                   onClick={() => setViewMode('list')}
//                 >
//                   List
//                 </button>
//                 <button
//                   className={`view-toggle-button ${viewMode === 'both' ? 'active' : ''}`}
//                   onClick={() => setViewMode('both')}
//                 >
//                   Both
//                 </button>
//               </div>
//             )}

//             {isGraphEnabled && (viewMode === 'graph' || viewMode === 'both') && (
//               <div className="chart-container">
//                 {renderChart()}
//               </div>
//             )}

//             {(viewMode === 'list' || viewMode === 'both' || !isGraphEnabled) && (
//               <div className="table-container">
//                 <div className="table-header-controls non-printable">
//                   <input
//                     type="text"
//                     placeholder="Search across all columns..."
//                     className="search-input"
//                     value={searchTerm}
//                     onChange={e => setSearchTerm(e.target.value)}
//                   />
//                   <div className="export-buttons">
//                     {reportPermissions.canExport && (
//                       <>
//                         <button
//                           className="export-button"
//                           onClick={() => exportToCSV(
//                             filteredAndSearchedTasks,
//                             tableColumns,
//                             `${dynamicTableTitle.replace(/\s/g, '_')}_filtered.csv`
//                           )}
//                         >
//                           Export Filtered
//                         </button>
//                         <button
//                           className="export-button"
//                           onClick={() => exportToCSV(
//                             allTasks,
//                             tableColumns,
//                             `${selectedReport.replace(/\s/g, '_')}_all.csv`
//                           )}
//                         >
//                           Export All
//                         </button>
//                       </>
//                     )}
//                     <button className="export-button" onClick={handleOpenEmailModal}>
//                       Email
//                     </button>
//                     {reportPermissions.canPrint && (
//                       <button className="export-button" onClick={handlePrint}>
//                         Print
//                       </button>
//                     )}
//                   </div>
//                 </div>

//                 <div className="printable-area">
//                   <h2>{dynamicTableTitle}</h2>
//                   <div className="table-responsive-wrapper">
//                     <table>
//                       <thead>
//                         <tr>
//                           {tableColumns.map(column => (
//                             <th key={column}>{formatHeader(column)}</th>
//                           ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {filteredAndSearchedTasks.length > 0 ? (
//                           filteredAndSearchedTasks.map((task, index) => (
//                             <tr key={task.task_id || `row-${index}`}>
//                               {tableColumns.map(column => (
//                                 <td key={`${task.task_id || index}-${column}`}>
//                                   {renderCell(task, column)}
//                                 </td>
//                               ))}
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan={tableColumns.length || 1} className="status-message">
//                               No items found for the current selection.
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       {isEmailModalOpen && (
//         <div className="email-modal-overlay">
//           <div className="email-modal-content">
//             <form onSubmit={handleSendEmail}>
//               <div className="email-modal-header">
//                 <h3>Send Report via Email</h3>
//                 <button
//                   type="button"
//                   className="close-button"
//                   onClick={() => setIsEmailModalOpen(false)}
//                 >
//                   ×
//                 </button>
//               </div>

//               <div className="email-modal-body">
//                 <div className="form-group">
//                   <label htmlFor="email-to-select">To *</label>
//                   <Select
//                     id="email-to-select"
//                     isMulti
//                     options={emailRecipients}
//                     value={emailTo}
//                     onChange={(selectedOptions) => setEmailTo(selectedOptions || [])}
//                     isLoading={isFetchingRecipients}
//                     placeholder="Search or select recipients..."
//                     closeMenuOnSelect={false}
//                     hideSelectedOptions={false}
//                     components={{ Option: CheckboxOption }}
//                     className="email-select-container"
//                     classNamePrefix="email-select"
//                     styles={customSelectStyles}
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="email-cc">CC</label>
//                   <input
//                     id="email-cc"
//                     type="text"
//                     value={emailCc}
//                     onChange={(e) => setEmailCc(e.target.value)}
//                     placeholder="Comma-separated emails"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="email-bcc">BCC</label>
//                   <input
//                     id="email-bcc"
//                     type="text"
//                     value={emailBcc}
//                     onChange={(e) => setEmailBcc(e.target.value)}
//                     placeholder="Comma-separated emails"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="email-subject">Subject *</label>
//                   <input
//                     id="email-subject"
//                     type="text"
//                     value={emailSubject}
//                     onChange={(e) => setEmailSubject(e.target.value)}
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="email-body">Body *</label>
//                   <textarea
//                     id="email-body"
//                     value={emailBody}
//                     onChange={(e) => setEmailBody(e.target.value)}
//                     rows="5"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>Attachments</label>
//                   <div className="attachment-list">
//                     {emailAttachments.map((file, index) => (
//                       <div key={index} className="attachment-item">
//                         <span>{file.name} ({Math.round(file.size / 1024)} KB)</span>
//                         <button
//                           type="button"
//                           className="remove-attachment-btn"
//                           onClick={() => handleRemoveAttachment(index)}
//                         >
//                           ×
//                         </button>
//                       </div>
//                     ))}
//                   </div>
//                   <input
//                     type="file"
//                     ref={fileInputRef}
//                     onChange={handleAddAttachment}
//                     style={{ display: 'none' }}
//                     multiple
//                   />

//                 </div>

//                 {emailStatus.message && (
//                   <div className={`email-status-message ${emailStatus.type}`}>
//                     {emailStatus.message}
//                   </div>
//                 )}
//               </div>

//               <div className="email-modal-footer">
//                 <button
//                   type="button"
//                   className="cancel-btn"
//                   onClick={() => setIsEmailModalOpen(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="send-btn"
//                   disabled={emailSending}
//                 >
//                   {emailSending ? 'Sending...' : 'Send Email'}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default ReportPage;




// import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
// import Select, { components } from 'react-select';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   LineElement,
//   PointElement,
// } from 'chart.js';
// import { Pie, Bar, Line } from 'react-chartjs-2';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Report.css';

// // Register Chart.js components
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   LineElement,
//   PointElement,
//   ChartDataLabels
// );

// // --- Constants from Environment Variables ---
// // Using environment variables to avoid hardcoding URLs
// const API_BASE_URL = process.env.REACT_APP_REPORTS_API_URL;
// const MAIL_API_URL = process.env.REACT_APP_MAIL_API_URL;
// const NODE_SERVICE_BASE_URL = process.env.REACT_APP_NODE_SERVICE_BASE_URL;
// const COMMON_MASTER_API_URL = `${NODE_SERVICE_BASE_URL}/api/get-column/common_master`;


// const GRAPH_TYPES = [
//   { value: 'Pie', label: 'Pie Chart' },
//   { value: 'Bar', label: 'Bar Chart' },
// ];

// const parseJwt = (token) => {
//   try {
//     return JSON.parse(atob(token.split('.')[1]));
//   } catch (e) {
//     console.error("Failed to parse JWT:", e);
//     return null;
//   }
// };

// const createOptions = (data, key) => {
//   if (!data || data.length === 0 || !key) return [];
//   const uniqueValues = [...new Set(data.map(item => item[key]).filter(Boolean))];
//   return uniqueValues.sort().map(value => ({ value, label: value }));
// };

// const formatHeader = (header) => {
//   if (!header) return '';
//   return header
//     .replace(/_/g, ' ')
//     .replace(/id/g, 'ID')
//     .replace(/\b\w/g, char => char.toUpperCase());
// };

// const findValueColumn = (columns) => {
//   const commonValueNames = ['total', 'count', 'sum', 'amount', 'value'];
//   return columns.find(col =>
//     commonValueNames.some(name => col.toLowerCase().includes(name))
//   ) || null;
// };

// const generateDynamicColors = (numColors) => {
//   const colors = [];
//   for (let i = 0; i < numColors; i++) {
//     const hue = (i * 137.508) % 360;
//     colors.push(`hsla(${hue}, 70%, 60%, 0.8)`);
//   }
//   return colors;
// };

// const exportToCSV = (tasks, columns, filename) => {
//   if (!tasks || tasks.length === 0 || !columns || columns.length === 0) {
//     alert("No data available to export.");
//     return;
//   }

//   const headers = columns.map(formatHeader);
//   const csvRows = [
//     headers.join(','),
//     ...tasks.map(task =>
//       columns.map(column => {
//         let cellData = task[column];
//         if (cellData === null || cellData === undefined) return '""';
//         if (Array.isArray(cellData)) {
//           cellData = cellData.filter(item => item).join('; ');
//         }
//         const stringData = String(cellData).replace(/"/g, '""');
//         return `"${stringData}"`;
//       }).join(',')
//     )
//   ];

//   const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
//   const link = document.createElement('a');
//   const url = URL.createObjectURL(blob);
//   link.setAttribute('href', url);
//   link.setAttribute('download', filename);
//   link.style.visibility = 'hidden';
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };

// const generateCSVFile = (tasks, columns, filename) => {
//   if (!tasks || tasks.length === 0 || !columns || columns.length === 0) {
//     return null;
//   }

//   const headers = columns.map(formatHeader);
//   const csvRows = [
//     headers.join(','),
//     ...tasks.map(task =>
//       columns.map(column => {
//         let cellData = task[column];
//         if (cellData === null || cellData === undefined) return '""';
//         if (Array.isArray(cellData)) {
//           cellData = cellData.filter(item => item).join('; ');
//         }
//         const stringData = String(cellData).replace(/"/g, '""');
//         return `"${stringData}"`;
//       }).join(',')
//     )
//   ];

//   const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
//   return new File([blob], filename, { type: 'text/csv;charset=utf-8;' });
// };


// const CheckboxOption = (props) => {
//   return (
//     <components.Option {...props}>
//       <input
//         type="checkbox"
//         checked={props.isSelected}
//         onChange={() => null}
//         style={{ marginRight: '10px' }}
//       />
//       <label>{props.label}</label>
//     </components.Option>
//   );
// };


// const ReportPage = () => {
//   // --- State for authentication token ---
//   const [authToken, setAuthToken] = useState(null);
//   const bearerToken = useMemo(() => authToken ? `Bearer ${authToken}` : null, [authToken]);

//   // State management
//   const [allReports, setAllReports] = useState([]);
//   const [selectedReport, setSelectedReport] = useState('');
//   const [allTasks, setAllTasks] = useState([]);
//   const [tableColumns, setTableColumns] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewMode, setViewMode] = useState('list');
//   const [reportPermissions, setReportPermissions] = useState({
//     canPrint: false,
//     canExport: false
//   });

//   // Filter state
//   const [users, setUsers] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedGraphType, setSelectedGraphType] = useState('Pie');
//   const [selectedUser, setSelectedUser] = useState('');
//   const [selectedProject, setSelectedProject] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState('');

//   // State for dynamic filters
//   const [years, setYears] = useState([]);
//   const [months, setMonths] = useState([]);
//   const [selectedYear, setSelectedYear] = useState('');
//   const [selectedMonth, setSelectedMonth] = useState('');

//   // State for available options based on data
//   const [availableYears, setAvailableYears] = useState([]);
//   const [availableMonths, setAvailableMonths] = useState([]);

//   // Dynamic column names for filtering
//   const [filterColumnNames, setFilterColumnNames] = useState({
//     user: null,
//     project: null,
//     category: null,
//     date: null
//   });

//   const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
//   const [emailTo, setEmailTo] = useState([]);
//   const [emailCc, setEmailCc] = useState('');
//   const [emailBcc, setEmailBcc] = useState('');
//   const [emailSubject, setEmailSubject] = useState('');
//   const [emailBody, setEmailBody] = useState('');
//   const [emailAttachments, setEmailAttachments] = useState([]);
//   const [emailSending, setEmailSending] = useState(false);
//   const [emailStatus, setEmailStatus] = useState({ message: '', type: '' });
//   const [emailRecipients, setEmailRecipients] = useState([]);
//   const [isFetchingRecipients, setIsFetchingRecipients] = useState(false);

//   // Refs
//   const printableRef = useRef();
//   const fileInputRef = useRef(null);
//   const customSelectStyles = {
//     menu: (provided) => ({ ...provided, zIndex: 9999 }),
//   };

//   // --- Get User ID from Token ---
//   const currentUserId = useMemo(() => {
//     if (!authToken) return null;
//     const parsedToken = parseJwt(authToken);
//     return parsedToken?.claims?.user_ID;
//   }, [authToken]);

//   const currentReportObject = useMemo(() =>
//     allReports.find(report => report.report_name === selectedReport),
//     [allReports, selectedReport]
//   );

//   const isGraphEnabled = useMemo(() =>
//     currentReportObject?.graph === 'yes',
//     [currentReportObject]
//   );

//   // --- API Call Functions using dynamic token ---
//   const fetchMonths = useCallback(async () => {
//     if (!bearerToken) return;
//     try {
//       const response = await fetch(`${COMMON_MASTER_API_URL}/month_name`, {
//         headers: { accept: 'application/json', Authorization: bearerToken },
//       });
//       if (response.ok) {
//         const monthData = await response.json();
//         const sortedMonths = monthData.sort((a, b) => a.id - b.id);
//         setMonths(sortedMonths);
//       } else {
//         throw new Error(`Failed to fetch months: ${response.status}`);
//       }
//     } catch (error) {
//       console.error('fetchMonths error:', error);
//       setMonths([]);
//     }
//   }, [bearerToken]);

//   const fetchYears = useCallback(async () => {
//     if (!bearerToken) return;
//     try {
//       const [fromResponse, toResponse] = await Promise.all([
//         fetch(`${COMMON_MASTER_API_URL}/from_date`, {
//           headers: { accept: 'application/json', Authorization: bearerToken },
//         }),
//         fetch(`${COMMON_MASTER_API_URL}/to_date`, {
//           headers: { accept: 'application/json', Authorization: bearerToken },
//         }),
//       ]);

//       if (!fromResponse.ok || !toResponse.ok) {
//         throw new Error('Failed to fetch financial years');
//       }

//       const fromData = await fromResponse.json();
//       const toData = await toResponse.json();

//       const yearOptions = fromData.map((from) => {
//         const to = toData.find((t) => t.id === from.id);
//         const fromYear = new Date(from.value).getFullYear();
//         const toYear = new Date(to.value).getFullYear();
//         return {
//           id: from.id,
//           label: `${fromYear}-${toYear.toString().slice(-2)}`,
//           from_date: from.value,
//           to_date: to.value,
//         };
//       }).sort((a, b) => b.id - a.id);

//       setYears(yearOptions);
//     } catch (error) {
//       console.error('fetchYears error:', error);
//       setYears([]);
//     }
//   }, [bearerToken]);


//   const fetchReportList = useCallback(async () => {
//     if (!bearerToken) return;
//     setLoading(true);
//     try {
//       // UPDATED: Added /api/ to the URL path
//       const response = await fetch(`${API_BASE_URL}/api/reports`, {
//         method: 'GET',
//         headers: {
//           'Accept': 'application/json',
//           'Authorization': bearerToken,
//         },
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       const result = await response.json();
//       const reports = result || [];
//       setAllReports(reports);

//       if (reports.length > 0) {
//         setSelectedReport(reports[0].report_name);
//       } else {
//         setLoading(false);
//       }
//     } catch (err) {
//       console.error("Failed to fetch report list:", err);
//       setError("Could not load report options.");
//       setLoading(false);
//     }
//   }, [bearerToken]);

//   const fetchReportData = useCallback(async (reportName) => {
//     if (!reportName || !bearerToken) {
//       // Clear data if no report is selected or not authenticated
//       setAllTasks([]);
//       setTableColumns([]);
//       setReportPermissions({ canPrint: false, canExport: false });
//       if (allReports.length > 0) setLoading(false);
//       return;
//     }

//     setLoading(true);
//     setError(null);
//     // Reset filters on new report selection
//     setSelectedUser('');
//     setSelectedYear('');
//     setSelectedMonth('');
//     setSelectedProject('');
//     setSelectedCategory('');
//     setSearchTerm('');

//     try {
//       // UPDATED: Added /api/ to the URL path
//       const response = await fetch(`${API_BASE_URL}/api/reports/run`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json',
//           'Authorization': bearerToken,
//         },
//         body: JSON.stringify({
//           report_name: reportName,
//           module_name: 'ZTask'
//         }),
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       const result = await response.json();
//       const data = result.data || [];
//       const columns = result.columns || [];

//       setTableColumns(columns);
//       setAllTasks(data);

//       const findColumn = (possibleNames) =>
//         columns.find(c => possibleNames.includes(c.toLowerCase()));

//       const newFilterColumns = {
//         user: findColumn(['assignee_name', 'user_name', 'user', 'assignee', 'task assignee']),
//         project: findColumn(['project_name', 'project']),
//         category: findColumn(['category', 'task_category']),
//         date: findColumn(['due_date', 'report date', 'report_date', 'created_at', 'task open dt'])
//       };

//       setFilterColumnNames(newFilterColumns);

//       setUsers(createOptions(data, newFilterColumns.user));
//       setProjects(createOptions(data, newFilterColumns.project));
//       setCategories(createOptions(data, newFilterColumns.category));

//     } catch (err) {
//       console.error("Failed to fetch report data:", err);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   }, [allReports.length, bearerToken]);

//   const fetchEmailRecipients = useCallback(async () => {
//     if (!bearerToken) return;
//     setIsFetchingRecipients(true);
//     setEmailStatus({ message: '', type: '' });

//     try {
//       // UPDATED: Added /api/ to the URL path
//       const response = await fetch(`${API_BASE_URL}/api/reports/get-columns`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json',
//           'Authorization': bearerToken
//         },
//         body: JSON.stringify({
//           table_name: "users",
//           column_names: ["email"]
//         })
//       });

//       if (!response.ok) {
//         throw new Error(`Failed to fetch email recipients. Status: ${response.status}`);
//       }

//       const result = await response.json();
//       if (result.data && Array.isArray(result.data)) {
//         const formattedRecipients = result.data
//           .map(user => ({ value: user.email, label: user.email }))
//           .sort((a, b) => a.label.localeCompare(b.label));
//         setEmailRecipients(formattedRecipients);
//       } else {
//         throw new Error("Invalid data format for email recipients.");
//       }
//     } catch (err) {
//       console.error(err);
//       setEmailStatus({
//         message: 'Could not load email recipients.',
//         type: 'error'
//       });
//       setEmailRecipients([]);
//     } finally {
//       setIsFetchingRecipients(false);
//     }
//   }, [bearerToken]);

//   // --- Effects ---

//   // Effect to get token from Local Storage on component mount
//   useEffect(() => {
//     const token = localStorage.getItem('zTaskAuthToken');
//     if (token) {
//       setAuthToken(token);
//     } else {
//       console.error("Authentication token not found in local storage.");
//       setError("You are not authenticated. Please log in.");
//       setLoading(false);
//     }
//   }, []);

//   // Effect to fetch initial master data once authenticated
//   useEffect(() => {
//     if (bearerToken) {
//       fetchReportList();
//       fetchMonths();
//       fetchYears();
//     }
//   }, [bearerToken, fetchReportList, fetchMonths, fetchYears]);

//   // Effect to fetch report data when selection changes
//   useEffect(() => {
//     if (selectedReport && bearerToken) {
//         fetchReportData(selectedReport);
//     }

//     if (currentReportObject) {
//       setViewMode(isGraphEnabled ? 'both' : 'list');
//       if (currentUserId) {
//         const canPrint = currentReportObject.print?.includes(currentUserId) ?? false;
//         const canExport = currentReportObject.export?.includes(currentUserId) ?? false;
//         setReportPermissions({ canPrint, canExport });
//       } else {
//         setReportPermissions({ canPrint: false, canExport: false });
//       }
//     }
//   }, [selectedReport, bearerToken, fetchReportData, currentReportObject, isGraphEnabled, currentUserId]);

//   // Effect to derive available filter options from data
//   useEffect(() => {
//     if (!allTasks.length || !filterColumnNames.date || !months.length || !years.length) {
//       setAvailableMonths([]);
//       setAvailableYears([]);
//       return;
//     }

//     const dateCol = filterColumnNames.date;
//     const presentMonthIds = new Set();
//     const presentYearIds = new Set();

//     allTasks.forEach(task => {
//       const taskDateValue = task[dateCol];
//       if (!taskDateValue) return;

//       const taskDate = new Date(taskDateValue);
//       if (isNaN(taskDate.getTime())) return;

//       const monthId = (taskDate.getMonth() + 1).toString();
//       presentMonthIds.add(monthId);

//       for (const yearOption of years) {
//         const fromDate = new Date(yearOption.from_date);
//         const toDate = new Date(yearOption.to_date);
//         toDate.setHours(23, 59, 59, 999);

//         if (taskDate >= fromDate && taskDate <= toDate) {
//           presentYearIds.add(yearOption.id);
//           break;
//         }
//       }
//     });

//     const filteredMonths = months
//       .filter(month => presentMonthIds.has(month.id.toString()))
//       .sort((a, b) => a.id - b.id);

//     const filteredYears = years
//       .filter(year => presentYearIds.has(year.id))
//       .sort((a, b) => b.id - a.id);

//     setAvailableMonths(filteredMonths);
//     setAvailableYears(filteredYears);

//   }, [allTasks, filterColumnNames.date, months, years]);


//   // Filtered data
//   const filteredAndSearchedTasks = useMemo(() => {
//     let tempTasks = [...allTasks];
//     const { user, project, category, date } = filterColumnNames;

//     if (selectedUser && user) tempTasks = tempTasks.filter(t => t[user] === selectedUser);
//     if (selectedProject && project) tempTasks = tempTasks.filter(t => t[project] === selectedProject);
//     if (selectedCategory && category) tempTasks = tempTasks.filter(t => t[category] === selectedCategory);

//     if (date) {
//       if (selectedYear) {
//         const selectedYearData = years.find(y => y.id.toString() === selectedYear);
//         if (selectedYearData) {
//           const fromDate = new Date(selectedYearData.from_date);
//           const toDate = new Date(selectedYearData.to_date);
//           tempTasks = tempTasks.filter(t => {
//             const taskDate = new Date(t[date]);
//             return taskDate >= fromDate && taskDate <= toDate;
//           });
//         }
//       }

//       if (selectedMonth) {
//         tempTasks = tempTasks.filter(t =>
//           (new Date(t[date]).getMonth() + 1).toString() === selectedMonth
//         );
//       }
//     }

//     if (searchTerm.trim() !== '') {
//       const lowercasedTerm = searchTerm.toLowerCase();
//       tempTasks = tempTasks.filter(task =>
//         tableColumns.some(col =>
//           String(task[col]).toLowerCase().includes(lowercasedTerm)
//         )
//       );
//     }

//     return tempTasks;
//   }, [
//     allTasks,
//     tableColumns,
//     selectedUser,
//     selectedProject,
//     selectedCategory,
//     searchTerm,
//     filterColumnNames,
//     selectedYear,
//     selectedMonth,
//     years,
//   ]);

//   const dynamicTableTitle = useMemo(() => {
//     const activeFilters = [selectedReport];
//     if (selectedUser) activeFilters.push(selectedUser);
//     if (selectedProject) activeFilters.push(selectedProject);
//     if (selectedCategory) activeFilters.push(selectedCategory);

//     if (selectedYear) {
//       const yearLabel = years.find(y => y.id.toString() === selectedYear)?.label;
//       if (yearLabel) activeFilters.push(`Year: ${yearLabel}`);
//     }
//     if (selectedMonth) {
//       const monthLabel = months.find(m => m.id.toString() === selectedMonth)?.value;
//       if (monthLabel) activeFilters.push(monthLabel);
//     }
//     return activeFilters.length > 1 ? activeFilters.join(' - ') : selectedReport;
//   }, [selectedUser, selectedProject, selectedCategory, selectedYear, selectedMonth, selectedReport, years, months]);

//   const chartData = useMemo(() => {
//     const dataToChart = filteredAndSearchedTasks;
//     if (!dataToChart || dataToChart.length === 0 || tableColumns.length === 0) {
//       return { labels: [], datasets: [] };
//     }

//     const valueColumn = findValueColumn(tableColumns);
//     if (valueColumn) {
//       const labelColumns = tableColumns.filter(c => c !== valueColumn);

//       if (labelColumns.length >= 2) {
//         const primaryLabelCol = labelColumns[0];
//         const seriesCol = labelColumns[1];
//         const labels = [...new Set(dataToChart.map(item => item[primaryLabelCol]))].sort();
//         const seriesNames = [...new Set(dataToChart.map(item => item[seriesCol]))].sort();
//         const colors = generateDynamicColors(seriesNames.length);

//         const datasets = seriesNames.map((seriesName, index) => ({
//           label: seriesName,
//           data: labels.map(label => {
//             const dataPoint = dataToChart.find(item =>
//               item[primaryLabelCol] === label && item[seriesCol] === seriesName
//             );
//             return dataPoint ? parseFloat(dataPoint[valueColumn]) || 0 : 0;
//           }),
//           backgroundColor: colors[index],
//           borderColor: colors[index].replace('0.8', '1'),
//           borderWidth: 1,
//         }));

//         return { labels, datasets };
//       }

//       if (labelColumns.length === 1) {
//         const labelCol = labelColumns[0];
//         const labels = dataToChart.map(item => item[labelCol]);
//         const data = dataToChart.map(item => parseFloat(item[valueColumn]) || 0);
//         return {
//           labels,
//           datasets: [{
//             label: formatHeader(valueColumn),
//             data,
//             backgroundColor: generateDynamicColors(labels.length),
//             borderColor: '#fff',
//             borderWidth: 1
//           }]
//         };
//       }
//     }

//     const statusCounts = dataToChart.reduce((acc, task) => {
//       const status = task.status || 'Unknown';
//       acc[status] = (acc[status] || 0) + 1;
//       return acc;
//     }, {});

//     const labels = Object.keys(statusCounts);
//     const data = Object.values(statusCounts);

//     return {
//       labels,
//       datasets: [{
//         label: 'Number of Items',
//         data,
//         backgroundColor: generateDynamicColors(labels.length),
//         borderColor: '#fff',
//         borderWidth: 1
//       }]
//     };
//   }, [filteredAndSearchedTasks, tableColumns]);

//   // Event handlers
//   const handlePrint = useCallback(() => {
//     window.print();
//   }, []);

//   const handleOpenEmailModal = useCallback(() => {
//     fetchEmailRecipients();
//     setEmailSubject(dynamicTableTitle);
//     setEmailBody(``);

//     const reportFile = generateCSVFile(
//       filteredAndSearchedTasks,
//       tableColumns,
//       `${selectedReport}_report.csv`
//     );

//     if (reportFile) {
//       setEmailAttachments([reportFile]);
//     } else {
//       setEmailAttachments([]);
//     }

//     setEmailTo([]);
//     setEmailCc('');
//     setEmailBcc('');
//     setEmailStatus({ message: '', type: '' });
//     setEmailSending(false);
//     setIsEmailModalOpen(true);
//   }, [dynamicTableTitle, filteredAndSearchedTasks, tableColumns, selectedReport, fetchEmailRecipients]);

//   const handleAddAttachment = useCallback((e) => {
//     if (e.target.files) {
//       setEmailAttachments(prev => [...prev, ...Array.from(e.target.files)]);
//     }
//   }, []);

//   const handleRemoveAttachment = useCallback((indexToRemove) => {
//     setEmailAttachments(prev => prev.filter((_, index) => index !== indexToRemove));
//   }, []);

//   const handleSendEmail = useCallback(async (e) => {
//     e.preventDefault();

//     if (emailTo.length === 0 || !emailSubject || !emailBody) {
//       setEmailStatus({
//         message: 'Please select at least one recipient and fill in Subject and Body.',
//         type: 'error'
//       });
//       return;
//     }

//     setEmailSending(true);
//     setEmailStatus({ message: '', type: '' });

//     try {
//       const params = new URLSearchParams();
//       emailTo.forEach(option => params.append('to', option.value));

//       const processEmails = (emailString) =>
//         emailString.split(',').map(e => e.trim()).filter(e => e && e.includes('@'));

//       processEmails(emailCc).forEach(email => params.append('cc', email));
//       processEmails(emailBcc).forEach(email => params.append('bcc', email));
//       params.append('subject', emailSubject);
//       params.append('body', emailBody);

//       const attachmentFormData = new FormData();
//       emailAttachments.forEach(file => {
//         attachmentFormData.append('attachment', file, file.name);
//       });

//       const fullUrl = `${MAIL_API_URL}?${params.toString()}`;

//       const requestOptions = {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//         },
//         body: attachmentFormData,
//       };

//       const response = await fetch(fullUrl, requestOptions);

//       if (!response.ok) {
//         let errorMsg;
//         try {
//           const errorResult = await response.json();
//           errorMsg = errorResult.error || errorResult.message || JSON.stringify(errorResult);
//         } catch (jsonError) {
//           const textResponse = await response.text();
//           errorMsg = textResponse || `Request failed with status: ${response.status}`;
//         }
//         throw new Error(errorMsg);
//       }

//       const result = await response.json();
//       setEmailStatus({
//         message: result.message || 'Email sent successfully!',
//         type: 'success'
//       });
//       setTimeout(() => setIsEmailModalOpen(false), 2000);

//     } catch (error) {
//       console.error('Failed to send email:', error);
//       setEmailStatus({
//         message: error.message || 'An unexpected error occurred.',
//         type: 'error'
//       });
//     } finally {
//       setEmailSending(false);
//     }
//   }, [emailTo, emailSubject, emailBody, emailCc, emailBcc, emailAttachments]);

//   const renderCell = useCallback((task, column) => {
//     let value = task[column];
//     if (value === null || value === undefined) {
//       return <span className="cell-na">N/A</span>;
//     }

//     if (column === 'status') {
//       return <span className={`status-badge status-${String(value).toLowerCase()}`}>{value}</span>;
//     }

//     if (column === 'priority') {
//       return <span className={`priority-badge priority-${String(value).toLowerCase()}`}>{value}</span>;
//     }

//     if (['due_date', 'created_at', 'updated_at', 'completed_at', 'Report Date', 'TASK OPEN DT'].includes(column)) {
//       const date = new Date(value);
//       return !isNaN(date.getTime()) ? date.toLocaleString() : String(value);
//     }

//     if (Array.isArray(value)) {
//       const displayValue = value.filter(item => item != null).join(', ');
//       return displayValue || <span className="cell-na">N/A</span>;
//     }

//     const stringValue = String(value);
//     if (column === 'description' && stringValue.length > 100) {
//       return <span title={stringValue}>{stringValue.substring(0, 100)}...</span>;
//     }

//     return stringValue;
//   }, []);

//   const renderChart = useCallback(() => {
//     if (filteredAndSearchedTasks.length === 0 && selectedReport) {
//       return <p className="status-message">No data matches the current filters.</p>;
//     }

//     if (!selectedReport || !chartData.datasets.length) return null;

//     const chartOptions = {
//       responsive: true,
//       maintainAspectRatio: false,
//       plugins: {
//         legend: { position: 'top' },
//         title: {
//           display: true,
//           text: selectedReport || 'Report',
//           font: { size: 18 }
//         },
//         datalabels: selectedGraphType === 'Pie' ? {
//           formatter: (value) => value,
//           color: '#fff',
//           font: { weight: 'bold', size: 16 }
//         } : {
//           display: false
//         }
//       },
//       ...(selectedGraphType !== 'Pie' && {
//         scales: { y: { beginAtZero: true } }
//       })
//     };

//     switch (selectedGraphType) {
//       case 'Pie':
//         return <Pie options={chartOptions} data={chartData} />;
//       case 'Line':
//         return <Line options={chartOptions} data={chartData} />;
//       case 'Bar':
//       default:
//         return <Bar options={chartOptions} data={chartData} />;
//     }
//   }, [filteredAndSearchedTasks, selectedReport, chartData, selectedGraphType]);

//   // --- Render Logic ---
//   if (error) {
//     return <div className="status-message error">Error: {error}</div>;
//   }

//   // Remainder of the return statement is identical...
//   return (
//     <div className="report-container">
//       <div className="non-printable-header">
//         <h1>Reports</h1>
//         <div className="filters-container">
//           <select
//             className="filter-select report-name-select"
//             value={selectedReport}
//             onChange={e => setSelectedReport(e.target.value)}
//             disabled={!bearerToken || allReports.length === 0}
//           >
//             {allReports.map(report => (
//               <option key={report.id} value={report.report_name}>
//                 {report.report_name}
//               </option>
//             ))}
//           </select>

//           {isGraphEnabled && (
//             <select
//               className="filter-select"
//               value={selectedGraphType}
//               onChange={e => setSelectedGraphType(e.target.value)}
//               disabled={!selectedReport}
//             >
//               {GRAPH_TYPES.map(opt => (
//                 <option key={opt.value} value={opt.value}>
//                   {opt.label}
//                 </option>
//               ))}
//             </select>
//           )}

//           <select
//             className="filter-select"
//             value={selectedUser}
//             onChange={e => setSelectedUser(e.target.value)}
//             disabled={!selectedReport || !filterColumnNames.user}
//           >
//             <option value="">All Users</option>
//             {users.map(opt => (
//               <option key={opt.value} value={opt.value}>
//                 {opt.label}
//               </option>
//             ))}
//           </select>

//           <select
//             className="filter-select"
//             value={selectedYear}
//             onChange={e => setSelectedYear(e.target.value)}
//             disabled={!selectedReport || availableYears.length === 0}
//           >
//             <option value="">All Years</option>
//             {availableYears.map(opt => (
//               <option key={opt.id} value={opt.id}>
//                 {opt.label}
//               </option>
//             ))}
//           </select>

//           <select
//             className="filter-select"
//             value={selectedMonth}
//             onChange={e => setSelectedMonth(e.target.value)}
//             disabled={!selectedReport || availableMonths.length === 0}
//           >
//             <option value="">All Months</option>
//             {availableMonths.map(opt => (
//               <option key={opt.id} value={opt.id}>
//                 {opt.value}
//               </option>
//             ))}
//           </select>

//           <select
//             className="filter-select"
//             value={selectedProject}
//             onChange={e => setSelectedProject(e.target.value)}
//             disabled={!selectedReport || !filterColumnNames.project}
//           >
//             <option value="">All Projects</option>
//             {projects.map(opt => (
//               <option key={opt.value} value={opt.value}>
//                 {opt.label}
//               </option>
//             ))}
//           </select>

//           <select
//             className="filter-select"
//             value={selectedCategory}
//             onChange={e => setSelectedCategory(e.target.value)}
//             disabled={!selectedReport || !filterColumnNames.category}
//           >
//             <option value="">All Categories</option>
//             {categories.map(opt => (
//               <option key={opt.value} value={opt.value}>
//                 {opt.label}
//               </option>
//             ))}
//           </select>
//         </div>
//       </div>

//       {loading && <div className="status-message">Loading Report...</div>}

//       {!loading && !selectedReport && allReports.length > 0 && (
//         <div className="status-message">Please select a report to view data.</div>
//       )}

//       {!loading && allReports.length === 0 && !error && (
//         <div className="status-message">No reports available.</div>
//       )}

//       <div ref={printableRef} className="printable-content">
//         {!loading && selectedReport && (
//           <>
//             {isGraphEnabled && (
//               <div className="view-toggle-wrapper non-printable">
//                 <button
//                   className={`view-toggle-button ${viewMode === 'graph' ? 'active' : ''}`}
//                   onClick={() => setViewMode('graph')}
//                 >
//                   Graph
//                 </button>
//                 <button
//                   className={`view-toggle-button ${viewMode === 'list' ? 'active' : ''}`}
//                   onClick={() => setViewMode('list')}
//                 >
//                   List
//                 </button>
//                 <button
//                   className={`view-toggle-button ${viewMode === 'both' ? 'active' : ''}`}
//                   onClick={() => setViewMode('both')}
//                 >
//                   Both
//                 </button>
//               </div>
//             )}

//             {isGraphEnabled && (viewMode === 'graph' || viewMode === 'both') && (
//               <div className="chart-container">
//                 {renderChart()}
//               </div>
//             )}

//             {(viewMode === 'list' || viewMode === 'both' || !isGraphEnabled) && (
//               <div className="table-container">
//                 <div className="table-header-controls non-printable">
//                   <input
//                     type="text"
//                     placeholder="Search across all columns..."
//                     className="search-input"
//                     value={searchTerm}
//                     onChange={e => setSearchTerm(e.target.value)}
//                   />
//                   <div className="export-buttons">
//                     {reportPermissions.canExport && (
//                       <>
//                         <button
//                           className="export-button"
//                           onClick={() => exportToCSV(
//                             filteredAndSearchedTasks,
//                             tableColumns,
//                             `${dynamicTableTitle.replace(/\s/g, '_')}_filtered.csv`
//                           )}
//                         >
//                           Export Filtered
//                         </button>
//                         <button
//                           className="export-button"
//                           onClick={() => exportToCSV(
//                             allTasks,
//                             tableColumns,
//                             `${selectedReport.replace(/\s/g, '_')}_all.csv`
//                           )}
//                         >
//                           Export All
//                         </button>
//                       </>
//                     )}
//                     <button className="export-button" onClick={handleOpenEmailModal}>
//                       Email
//                     </button>
//                     {reportPermissions.canPrint && (
//                       <button className="export-button" onClick={handlePrint}>
//                         Print
//                       </button>
//                     )}
//                   </div>
//                 </div>

//                 <div className="printable-area">
//                   <h2>{dynamicTableTitle}</h2>
//                   <div className="table-responsive-wrapper">
//                     <table>
//                       <thead>
//                         <tr>
//                           {tableColumns.map(column => (
//                             <th key={column}>{formatHeader(column)}</th>
//                           ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {filteredAndSearchedTasks.length > 0 ? (
//                           filteredAndSearchedTasks.map((task, index) => (
//                             <tr key={task.task_id || `row-${index}`}>
//                               {tableColumns.map(column => (
//                                 <td key={`${task.task_id || index}-${column}`}>
//                                   {renderCell(task, column)}
//                                 </td>
//                               ))}
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan={tableColumns.length || 1} className="status-message">
//                               No items found for the current selection.
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       {isEmailModalOpen && (
//         <div className="email-modal-overlay">
//           <div className="email-modal-content">
//             <form onSubmit={handleSendEmail}>
//               <div className="email-modal-header">
//                 <h3>Send Report via Email</h3>
//                 <button
//                   type="button"
//                   className="close-button"
//                   onClick={() => setIsEmailModalOpen(false)}
//                 >
//                   ×
//                 </button>
//               </div>

//               <div className="email-modal-body">
//                 <div className="form-group">
//                   <label htmlFor="email-to-select">To *</label>
//                   <Select
//                     id="email-to-select"
//                     isMulti
//                     options={emailRecipients}
//                     value={emailTo}
//                     onChange={(selectedOptions) => setEmailTo(selectedOptions || [])}
//                     isLoading={isFetchingRecipients}
//                     placeholder="Search or select recipients..."
//                     closeMenuOnSelect={false}
//                     hideSelectedOptions={false}
//                     components={{ Option: CheckboxOption }}
//                     className="email-select-container"
//                     classNamePrefix="email-select"
//                     styles={customSelectStyles}
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="email-cc">CC</label>
//                   <input
//                     id="email-cc"
//                     type="text"
//                     value={emailCc}
//                     onChange={(e) => setEmailCc(e.target.value)}
//                     placeholder="Comma-separated emails"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="email-bcc">BCC</label>
//                   <input
//                     id="email-bcc"
//                     type="text"
//                     value={emailBcc}
//                     onChange={(e) => setEmailBcc(e.target.value)}
//                     placeholder="Comma-separated emails"
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="email-subject">Subject *</label>
//                   <input
//                     id="email-subject"
//                     type="text"
//                     value={emailSubject}
//                     onChange={(e) => setEmailSubject(e.target.value)}
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label htmlFor="email-body">Body *</label>
//                   <textarea
//                     id="email-body"
//                     value={emailBody}
//                     onChange={(e) => setEmailBody(e.target.value)}
//                     rows="5"
//                     required
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>Attachments</label>
//                   <div className="attachment-list">
//                     {emailAttachments.map((file, index) => (
//                       <div key={index} className="attachment-item">
//                         <span>{file.name} ({Math.round(file.size / 1024)} KB)</span>
//                         <button
//                           type="button"
//                           className="remove-attachment-btn"
//                           onClick={() => handleRemoveAttachment(index)}
//                         >
//                           ×
//                         </button>
//                       </div>
//                     ))}
//                   </div>
//                   <input
//                     type="file"
//                     ref={fileInputRef}
//                     onChange={handleAddAttachment}
//                     style={{ display: 'none' }}
//                     multiple
//                   />

//                 </div>

//                 {emailStatus.message && (
//                   <div className={`email-status-message ${emailStatus.type}`}>
//                     {emailStatus.message}
//                   </div>
//                 )}
//               </div>

//               <div className="email-modal-footer">
//                 <button
//                   type="button"
//                   className="cancel-btn"
//                   onClick={() => setIsEmailModalOpen(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="send-btn"
//                   disabled={emailSending}
//                 >
//                   {emailSending ? 'Sending...' : 'Send Email'}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default ReportPage;















// import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
// import Select, { components } from 'react-select';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   LineElement,
//   PointElement,
// } from 'chart.js';
// import { Pie, Bar, Line } from 'react-chartjs-2';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Report.css';

// // Register Chart.js components
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   LineElement,
//   PointElement,
//   ChartDataLabels
// );

// // --- Constants from Environment Variables ---
// const API_BASE_URL = process.env.REACT_APP_REPORTS_API_URL || 'http://localhost:3000'; // Fallback for local dev
// const MAIL_API_URL = process.env.REACT_APP_MAIL_API_URL;
// const NODE_SERVICE_BASE_URL = process.env.REACT_APP_NODE_SERVICE_BASE_URL;
// const COMMON_MASTER_API_URL = `${NODE_SERVICE_BASE_URL}/api/get-column/common_master`;

// // NEW: Constant for pagination
// const ROWS_PER_PAGE = 10;

// const GRAPH_TYPES = [
//   { value: 'Pie', label: 'Pie Chart' },
//   { value: 'Bar', label: 'Bar Chart' },
// ];

// const parseJwt = (token) => {
//   try {
//     return JSON.parse(atob(token.split('.')[1]));
//   } catch (e) {
//     console.error("Failed to parse JWT:", e);
//     return null;
//   }
// };

// const createOptions = (data, key) => {
//   if (!data || data.length === 0 || !key) return [];
//   const uniqueValues = [...new Set(data.map(item => item[key]).filter(Boolean))];
//   return uniqueValues.sort().map(value => ({ value, label: value }));
// };

// const formatHeader = (header) => {
//   if (!header) return '';
//   return header
//     .replace(/_/g, ' ')
//     .replace(/id/g, 'ID')
//     .replace(/\b\w/g, char => char.toUpperCase());
// };

// const findValueColumn = (columns) => {
//   const commonValueNames = ['total', 'count', 'sum', 'amount', 'value'];
//   return columns.find(col =>
//     commonValueNames.some(name => col.toLowerCase().includes(name))
//   ) || null;
// };

// const generateDynamicColors = (numColors) => {
//   const colors = [];
//   for (let i = 0; i < numColors; i++) {
//     const hue = (i * 137.508) % 360;
//     colors.push(`hsla(${hue}, 70%, 60%, 0.8)`);
//   }
//   return colors;
// };

// const exportToCSV = (tasks, columns, filename) => {
//   if (!tasks || tasks.length === 0 || !columns || columns.length === 0) {
//     alert("No data available to export.");
//     return;
//   }

//   const headers = columns.map(formatHeader);
//   const csvRows = [
//     headers.join(','),
//     ...tasks.map(task =>
//       columns.map(column => {
//         let cellData = task[column];
//         if (cellData === null || cellData === undefined) return '""';
//         if (Array.isArray(cellData)) {
//           cellData = cellData.filter(item => item).join('; ');
//         }
//         const stringData = String(cellData).replace(/"/g, '""');
//         return `"${stringData}"`;
//       }).join(',')
//     )
//   ];

//   const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
//   const link = document.createElement('a');
//   const url = URL.createObjectURL(blob);
//   link.setAttribute('href', url);
//   link.setAttribute('download', filename);
//   link.style.visibility = 'hidden';
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };

// const generateCSVFile = (tasks, columns, filename) => {
//   if (!tasks || tasks.length === 0 || !columns || columns.length === 0) {
//     return null;
//   }

//   const headers = columns.map(formatHeader);
//   const csvRows = [
//     headers.join(','),
//     ...tasks.map(task =>
//       columns.map(column => {
//         let cellData = task[column];
//         if (cellData === null || cellData === undefined) return '""';
//         if (Array.isArray(cellData)) {
//           cellData = cellData.filter(item => item).join('; ');
//         }
//         const stringData = String(cellData).replace(/"/g, '""');
//         return `"${stringData}"`;
//       }).join(',')
//     )
//   ];

//   const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
//   return new File([blob], filename, { type: 'text/csv;charset=utf-8;' });
// };


// const CheckboxOption = (props) => {
//   return (
//     <components.Option {...props}>
//       <input
//         type="checkbox"
//         checked={props.isSelected}
//         onChange={() => null}
//         style={{ marginRight: '10px' }}
//       />
//       <label>{props.label}</label>
//     </components.Option>
//   );
// };


// const ReportPage = () => {
//   const [authToken, setAuthToken] = useState(null);
//   const bearerToken = useMemo(() => authToken ? `Bearer ${authToken}` : null, [authToken]);

//   const [allReports, setAllReports] = useState([]);
//   const [selectedReport, setSelectedReport] = useState('');
//   const [allTasks, setAllTasks] = useState([]);
//   const [tableColumns, setTableColumns] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewMode, setViewMode] = useState('list');
//   const [reportPermissions, setReportPermissions] = useState({ canPrint: false, canExport: false });

//   // NEW: Pagination State
//   const [currentPage, setCurrentPage] = useState(1);

//   const [users, setUsers] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedGraphType, setSelectedGraphType] = useState('Pie');
//   const [selectedUser, setSelectedUser] = useState('');
//   const [selectedProject, setSelectedProject] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState('');

//   const [years, setYears] = useState([]);
//   const [months, setMonths] = useState([]);
//   const [selectedYear, setSelectedYear] = useState('');
//   const [selectedMonth, setSelectedMonth] = useState('');

//   const [availableYears, setAvailableYears] = useState([]);
//   const [availableMonths, setAvailableMonths] = useState([]);

//   const [filterColumnNames, setFilterColumnNames] = useState({ user: null, project: null, category: null, date: null });

//   const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
//   const [emailTo, setEmailTo] = useState([]);
//   const [emailCc, setEmailCc] = useState('');
//   const [emailBcc, setEmailBcc] = useState('');
//   const [emailSubject, setEmailSubject] = useState('');
//   const [emailBody, setEmailBody] = useState('');
//   const [emailAttachments, setEmailAttachments] = useState([]);
//   const [emailSending, setEmailSending] = useState(false);
//   const [emailStatus, setEmailStatus] = useState({ message: '', type: '' });
//   const [emailRecipients, setEmailRecipients] = useState([]);
//   const [isFetchingRecipients, setIsFetchingRecipients] = useState(false);

//   const printableRef = useRef();
//   const fileInputRef = useRef(null);
//   const customSelectStyles = {
//     menu: (provided) => ({ ...provided, zIndex: 9999 }),
//   };

//   const currentUserId = useMemo(() => {
//     if (!authToken) return null;
//     const parsedToken = parseJwt(authToken);
//     return parsedToken?.claims?.user_ID;
//   }, [authToken]);

//   const currentReportObject = useMemo(() =>
//     allReports.find(report => report.report_name === selectedReport),
//     [allReports, selectedReport]
//   );

//   const isGraphEnabled = useMemo(() =>
//     currentReportObject?.graph === 'yes',
//     [currentReportObject]
//   );

//   const fetchMonths = useCallback(async () => {
//     if (!bearerToken) return;
//     try {
//       const response = await fetch(`${COMMON_MASTER_API_URL}/month_name`, {
//         headers: { accept: 'application/json', Authorization: bearerToken },
//       });
//       if (response.ok) {
//         const monthData = await response.json();
//         const sortedMonths = monthData.sort((a, b) => a.id - b.id);
//         setMonths(sortedMonths);
//       } else {
//         throw new Error(`Failed to fetch months: ${response.status}`);
//       }
//     } catch (error) {
//       console.error('fetchMonths error:', error);
//       setMonths([]);
//     }
//   }, [bearerToken]);

//   const fetchYears = useCallback(async () => {
//     if (!bearerToken) return;
//     try {
//       const [fromResponse, toResponse] = await Promise.all([
//         fetch(`${COMMON_MASTER_API_URL}/from_date`, { headers: { accept: 'application/json', Authorization: bearerToken } }),
//         fetch(`${COMMON_MASTER_API_URL}/to_date`, { headers: { accept: 'application/json', Authorization: bearerToken } }),
//       ]);

//       if (!fromResponse.ok || !toResponse.ok) throw new Error('Failed to fetch financial years');

//       const fromData = await fromResponse.json();
//       const toData = await toResponse.json();

//       const yearOptions = fromData.map((from) => {
//         const to = toData.find((t) => t.id === from.id);
//         const fromYear = new Date(from.value).getFullYear();
//         const toYear = new Date(to.value).getFullYear();
//         return {
//           id: from.id,
//           label: `${fromYear}-${toYear.toString().slice(-2)}`,
//           from_date: from.value,
//           to_date: to.value,
//         };
//       }).sort((a, b) => b.id - a.id);

//       setYears(yearOptions);
//     } catch (error) {
//       console.error('fetchYears error:', error);
//       setYears([]);
//     }
//   }, [bearerToken]);

//   const fetchReportList = useCallback(async () => {
//     if (!bearerToken) return;
//     setLoading(true);
//     try {
//       const response = await fetch(`${API_BASE_URL}/api/reports`, {
//         method: 'GET',
//         headers: { 'Accept': 'application/json', 'Authorization': bearerToken },
//       });

//       if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

//       const result = await response.json();
//       const allFetchedReports = result || [];
//       // MODIFIED: Filter reports to only show those for the 'ZTask' module
//       const reports = allFetchedReports.filter(report => report.module_name === 'ZTask');
      
//       setAllReports(reports);

//       if (reports.length > 0) {
//         setSelectedReport(reports[0].report_name);
//       } else {
//         setLoading(false);
//       }
//     } catch (err) {
//       console.error("Failed to fetch report list:", err);
//       setError("Could not load report options.");
//       setLoading(false);
//     }
//   }, [bearerToken]);

//   const fetchReportData = useCallback(async (reportName) => {
//     if (!reportName || !bearerToken) {
//       setAllTasks([]);
//       setTableColumns([]);
//       setReportPermissions({ canPrint: false, canExport: false });
//       if (allReports.length > 0) setLoading(false);
//       return;
//     }

//     setLoading(true);
//     setError(null);
//     setSelectedUser('');
//     setSelectedYear('');
//     setSelectedMonth('');
//     setSelectedProject('');
//     setSelectedCategory('');
//     setSearchTerm('');

//     try {
//       const response = await fetch(`${API_BASE_URL}/api/reports/run`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': bearerToken },
//         body: JSON.stringify({ report_name: reportName, module_name: 'ZTask' }),
//       });

//       if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

//       const result = await response.json();
//       const data = result.data || [];
//       const columns = result.columns || [];

//       setTableColumns(columns);
//       setAllTasks(data);

//       const findColumn = (possibleNames) => columns.find(c => possibleNames.includes(c.toLowerCase()));

//       const newFilterColumns = {
//         user: findColumn(['assignee_name', 'user_name', 'user', 'assignee', 'task assignee']),
//         project: findColumn(['project_name', 'project']),
//         category: findColumn(['category', 'task_category']),
//         date: findColumn(['due_date', 'report date', 'report_date', 'created_at', 'task open dt'])
//       };

//       setFilterColumnNames(newFilterColumns);
//       setUsers(createOptions(data, newFilterColumns.user));
//       setProjects(createOptions(data, newFilterColumns.project));
//       setCategories(createOptions(data, newFilterColumns.category));

//     } catch (err) {
//       console.error("Failed to fetch report data:", err);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   }, [allReports.length, bearerToken]);

//   const fetchEmailRecipients = useCallback(async () => {
//     if (!bearerToken) return;
//     setIsFetchingRecipients(true);
//     setEmailStatus({ message: '', type: '' });

//     try {
//       const response = await fetch(`${API_BASE_URL}/api/reports/get-columns`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': bearerToken },
//         body: JSON.stringify({ table_name: "users", column_names: ["email"] }),
//       });

//       if (!response.ok) throw new Error(`Failed to fetch email recipients. Status: ${response.status}`);

//       const result = await response.json();
//       if (result.data && Array.isArray(result.data)) {
//         const formattedRecipients = result.data
//           .map(user => ({ value: user.email, label: user.email }))
//           .sort((a, b) => a.label.localeCompare(b.label));
//         setEmailRecipients(formattedRecipients);
//       } else {
//         throw new Error("Invalid data format for email recipients.");
//       }
//     } catch (err) {
//       console.error(err);
//       setEmailStatus({ message: 'Could not load email recipients.', type: 'error' });
//       setEmailRecipients([]);
//     } finally {
//       setIsFetchingRecipients(false);
//     }
//   }, [bearerToken]);

//   useEffect(() => {
//     const token = localStorage.getItem('zTaskAuthToken');
//     if (token) {
//       setAuthToken(token);
//     } else {
//       console.error("Authentication token not found in local storage.");
//       setError("You are not authenticated. Please log in.");
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     if (bearerToken) {
//       fetchReportList();
//       fetchMonths();
//       fetchYears();
//     }
//   }, [bearerToken, fetchReportList, fetchMonths, fetchYears]);

//   useEffect(() => {
//     if (selectedReport && bearerToken) {
//         fetchReportData(selectedReport);
//     }

//     if (currentReportObject) {
//       setViewMode(isGraphEnabled ? 'both' : 'list');
//       if (currentUserId) {
//         const canPrint = currentReportObject.print?.includes(currentUserId) ?? false;
//         const canExport = currentReportObject.export?.includes(currentUserId) ?? false;
//         setReportPermissions({ canPrint, canExport });
//       } else {
//         setReportPermissions({ canPrint: false, canExport: false });
//       }
//     }
//   }, [selectedReport, bearerToken, fetchReportData, currentReportObject, isGraphEnabled, currentUserId]);

//   useEffect(() => {
//     if (!allTasks.length || !filterColumnNames.date || !months.length || !years.length) {
//       setAvailableMonths([]);
//       setAvailableYears([]);
//       return;
//     }
//     const dateCol = filterColumnNames.date;
//     const presentMonthIds = new Set();
//     const presentYearIds = new Set();
//     allTasks.forEach(task => {
//       const taskDateValue = task[dateCol];
//       if (!taskDateValue) return;
//       const taskDate = new Date(taskDateValue);
//       if (isNaN(taskDate.getTime())) return;
//       const monthId = (taskDate.getMonth() + 1).toString();
//       presentMonthIds.add(monthId);
//       for (const yearOption of years) {
//         const fromDate = new Date(yearOption.from_date);
//         const toDate = new Date(yearOption.to_date);
//         toDate.setHours(23, 59, 59, 999);
//         if (taskDate >= fromDate && taskDate <= toDate) {
//           presentYearIds.add(yearOption.id);
//           break;
//         }
//       }
//     });
//     const filteredMonths = months
//       .filter(month => presentMonthIds.has(month.id.toString()))
//       .sort((a, b) => a.id - b.id);
//     const filteredYears = years
//       .filter(year => presentYearIds.has(year.id))
//       .sort((a, b) => b.id - a.id);
//     setAvailableMonths(filteredMonths);
//     setAvailableYears(filteredYears);
//   }, [allTasks, filterColumnNames.date, months, years]);

//   // NEW: Effect to reset current page to 1 when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [selectedUser, selectedProject, selectedCategory, selectedYear, selectedMonth, searchTerm, selectedReport]);

//   const filteredAndSearchedTasks = useMemo(() => {
//     let tempTasks = [...allTasks];
//     const { user, project, category, date } = filterColumnNames;

//     if (selectedUser && user) tempTasks = tempTasks.filter(t => t[user] === selectedUser);
//     if (selectedProject && project) tempTasks = tempTasks.filter(t => t[project] === selectedProject);
//     if (selectedCategory && category) tempTasks = tempTasks.filter(t => t[category] === selectedCategory);

//     if (date) {
//       if (selectedYear) {
//         const selectedYearData = years.find(y => y.id.toString() === selectedYear);
//         if (selectedYearData) {
//           const fromDate = new Date(selectedYearData.from_date);
//           const toDate = new Date(selectedYearData.to_date);
//           tempTasks = tempTasks.filter(t => {
//             const taskDate = new Date(t[date]);
//             return taskDate >= fromDate && taskDate <= toDate;
//           });
//         }
//       }
//       if (selectedMonth) {
//         tempTasks = tempTasks.filter(t => (new Date(t[date]).getMonth() + 1).toString() === selectedMonth);
//       }
//     }

//     if (searchTerm.trim() !== '') {
//       const lowercasedTerm = searchTerm.toLowerCase();
//       tempTasks = tempTasks.filter(task =>
//         tableColumns.some(col => String(task[col]).toLowerCase().includes(lowercasedTerm))
//       );
//     }
//     return tempTasks;
//   }, [allTasks, tableColumns, selectedUser, selectedProject, selectedCategory, searchTerm, filterColumnNames, selectedYear, selectedMonth, years]);

//   // NEW: Calculate total pages and slice data for the current page
//   const { totalPages, paginatedTasks } = useMemo(() => {
//     const total = Math.ceil(filteredAndSearchedTasks.length / ROWS_PER_PAGE);
//     const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
//     const paginated = filteredAndSearchedTasks.slice(startIndex, startIndex + ROWS_PER_PAGE);
//     return {
//       totalPages: total > 0 ? total : 1, // Ensure totalPages is at least 1
//       paginatedTasks: paginated,
//     };
//   }, [filteredAndSearchedTasks, currentPage]);

//   const dynamicTableTitle = useMemo(() => {
//     const activeFilters = [selectedReport];
//     if (selectedUser) activeFilters.push(selectedUser);
//     if (selectedProject) activeFilters.push(selectedProject);
//     if (selectedCategory) activeFilters.push(selectedCategory);

//     if (selectedYear) {
//       const yearLabel = years.find(y => y.id.toString() === selectedYear)?.label;
//       if (yearLabel) activeFilters.push(`Year: ${yearLabel}`);
//     }
//     if (selectedMonth) {
//       const monthLabel = months.find(m => m.id.toString() === selectedMonth)?.value;
//       if (monthLabel) activeFilters.push(monthLabel);
//     }
//     return activeFilters.length > 1 ? activeFilters.join(' - ') : selectedReport;
//   }, [selectedUser, selectedProject, selectedCategory, selectedYear, selectedMonth, selectedReport, years, months]);

//   const chartData = useMemo(() => {
//     const dataToChart = filteredAndSearchedTasks;
//     if (!dataToChart || dataToChart.length === 0 || tableColumns.length === 0) {
//       return { labels: [], datasets: [] };
//     }
//     const valueColumn = findValueColumn(tableColumns);
//     if (valueColumn) {
//       const labelColumns = tableColumns.filter(c => c !== valueColumn);
//       if (labelColumns.length >= 2) {
//         const primaryLabelCol = labelColumns[0];
//         const seriesCol = labelColumns[1];
//         const labels = [...new Set(dataToChart.map(item => item[primaryLabelCol]))].sort();
//         const seriesNames = [...new Set(dataToChart.map(item => item[seriesCol]))].sort();
//         const colors = generateDynamicColors(seriesNames.length);
//         const datasets = seriesNames.map((seriesName, index) => ({
//           label: seriesName,
//           data: labels.map(label => {
//             const dataPoint = dataToChart.find(item => item[primaryLabelCol] === label && item[seriesCol] === seriesName);
//             return dataPoint ? parseFloat(dataPoint[valueColumn]) || 0 : 0;
//           }),
//           backgroundColor: colors[index],
//           borderColor: colors[index].replace('0.8', '1'),
//           borderWidth: 1,
//         }));
//         return { labels, datasets };
//       }
//       if (labelColumns.length === 1) {
//         const labelCol = labelColumns[0];
//         const labels = dataToChart.map(item => item[labelCol]);
//         const data = dataToChart.map(item => parseFloat(item[valueColumn]) || 0);
//         return {
//           labels,
//           datasets: [{ label: formatHeader(valueColumn), data, backgroundColor: generateDynamicColors(labels.length), borderColor: '#fff', borderWidth: 1 }],
//         };
//       }
//     }
//     const statusCounts = dataToChart.reduce((acc, task) => {
//       const status = task.status || 'Unknown';
//       acc[status] = (acc[status] || 0) + 1;
//       return acc;
//     }, {});
//     const labels = Object.keys(statusCounts);
//     const data = Object.values(statusCounts);
//     return {
//       labels,
//       datasets: [{ label: 'Number of Items', data, backgroundColor: generateDynamicColors(labels.length), borderColor: '#fff', borderWidth: 1 }],
//     };
//   }, [filteredAndSearchedTasks, tableColumns]);

//   const handlePrint = useCallback(() => window.print(), []);

//   const handleOpenEmailModal = useCallback(() => {
//     fetchEmailRecipients();
//     setEmailSubject(dynamicTableTitle);
//     setEmailBody(``);
//     const reportFile = generateCSVFile(filteredAndSearchedTasks, tableColumns, `${selectedReport}_report.csv`);
//     if (reportFile) setEmailAttachments([reportFile]);
//     else setEmailAttachments([]);
//     setEmailTo([]);
//     setEmailCc('');
//     setEmailBcc('');
//     setEmailStatus({ message: '', type: '' });
//     setEmailSending(false);
//     setIsEmailModalOpen(true);
//   }, [dynamicTableTitle, filteredAndSearchedTasks, tableColumns, selectedReport, fetchEmailRecipients]);

//   const handleAddAttachment = useCallback((e) => {
//     if (e.target.files) setEmailAttachments(prev => [...prev, ...Array.from(e.target.files)]);
//   }, []);

//   const handleRemoveAttachment = useCallback((indexToRemove) => {
//     setEmailAttachments(prev => prev.filter((_, index) => index !== indexToRemove));
//   }, []);

//   const handleSendEmail = useCallback(async (e) => {
//     e.preventDefault();
//     if (emailTo.length === 0 || !emailSubject || !emailBody) {
//       setEmailStatus({ message: 'Please select at least one recipient and fill in Subject and Body.', type: 'error' });
//       return;
//     }
//     setEmailSending(true);
//     setEmailStatus({ message: '', type: '' });
//     try {
//       const params = new URLSearchParams();
//       emailTo.forEach(option => params.append('to', option.value));
//       const processEmails = (emailString) => emailString.split(',').map(e => e.trim()).filter(e => e && e.includes('@'));
//       processEmails(emailCc).forEach(email => params.append('cc', email));
//       processEmails(emailBcc).forEach(email => params.append('bcc', email));
//       params.append('subject', emailSubject);
//       params.append('body', emailBody);
//       const attachmentFormData = new FormData();
//       emailAttachments.forEach(file => attachmentFormData.append('attachment', file, file.name));
//       const fullUrl = `${MAIL_API_URL}?${params.toString()}`;
//       const response = await fetch(fullUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: attachmentFormData });
//       if (!response.ok) {
//         let errorMsg;
//         try {
//           const errorResult = await response.json();
//           errorMsg = errorResult.error || errorResult.message || JSON.stringify(errorResult);
//         } catch (jsonError) {
//           const textResponse = await response.text();
//           errorMsg = textResponse || `Request failed with status: ${response.status}`;
//         }
//         throw new Error(errorMsg);
//       }
//       const result = await response.json();
//       setEmailStatus({ message: result.message || 'Email sent successfully!', type: 'success' });
//       setTimeout(() => setIsEmailModalOpen(false), 2000);
//     } catch (error) {
//       console.error('Failed to send email:', error);
//       setEmailStatus({ message: error.message || 'An unexpected error occurred.', type: 'error' });
//     } finally {
//       setEmailSending(false);
//     }
//   }, [emailTo, emailSubject, emailBody, emailCc, emailBcc, emailAttachments]);

//   // NEW: Handlers for Pagination
//   const handleFirstPage = () => setCurrentPage(1);
//   const handlePreviousPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));
//   const handleNextPage = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));
//   const handleLastPage = () => setCurrentPage(totalPages);
//   const handlePageInputChange = (e) => {
//     const pageNum = Number(e.target.value);
//     if (pageNum >= 1 && pageNum <= totalPages) {
//       setCurrentPage(pageNum);
//     }
//   };

//   const renderCell = useCallback((task, column) => {
//     let value = task[column];
//     if (value === null || value === undefined) return <span className="cell-na">N/A</span>;
//     if (column === 'status') return <span className={`status-badge status-${String(value).toLowerCase()}`}>{value}</span>;
//     if (column === 'priority') return <span className={`priority-badge priority-${String(value).toLowerCase()}`}>{value}</span>;
//     if (['due_date', 'created_at', 'updated_at', 'completed_at', 'Report Date', 'TASK OPEN DT'].includes(column)) {
//       const date = new Date(value);
//       return !isNaN(date.getTime()) ? date.toLocaleString() : String(value);
//     }
//     if (Array.isArray(value)) {
//       const displayValue = value.filter(item => item != null).join(', ');
//       return displayValue || <span className="cell-na">N/A</span>;
//     }
//     const stringValue = String(value);
//     if (column === 'description' && stringValue.length > 100) {
//       return <span title={stringValue}>{stringValue.substring(0, 100)}...</span>;
//     }
//     return stringValue;
//   }, []);

//   const renderChart = useCallback(() => {
//     if (filteredAndSearchedTasks.length === 0 && selectedReport) {
//       return <p className="status-message">No data matches the current filters.</p>;
//     }
//     if (!selectedReport || !chartData.datasets.length) return null;
//     const chartOptions = {
//       responsive: true,
//       maintainAspectRatio: false,
//       plugins: {
//         legend: { position: 'top' },
//         title: { display: true, text: selectedReport || 'Report', font: { size: 18 } },
//         datalabels: selectedGraphType === 'Pie' ? { formatter: (value) => value, color: '#fff', font: { weight: 'bold', size: 16 } } : { display: false },
//       },
//       ...(selectedGraphType !== 'Pie' && { scales: { y: { beginAtZero: true } } }),
//     };
//     switch (selectedGraphType) {
//       case 'Pie': return <Pie options={chartOptions} data={chartData} />;
//       case 'Line': return <Line options={chartOptions} data={chartData} />;
//       case 'Bar': default: return <Bar options={chartOptions} data={chartData} />;
//     }
//   }, [filteredAndSearchedTasks, selectedReport, chartData, selectedGraphType]);

//   if (error) return <div className="status-message error">Error: {error}</div>;

//   return (
//     <div className="report-container">
//       <div className="non-printable-header">
//         <h1>Reports</h1>
//         <div className="filters-container">
//           <select
//             className="filter-select report-name-select"
//             value={selectedReport}
//             onChange={e => setSelectedReport(e.target.value)}
//             disabled={!bearerToken || allReports.length === 0}
//           >
//             {allReports.map(report => (
//               <option key={report.id} value={report.report_name}>{report.report_name}</option>
//             ))}
//           </select>
//           {isGraphEnabled && (
//             <select
//               className="filter-select"
//               value={selectedGraphType}
//               onChange={e => setSelectedGraphType(e.target.value)}
//               disabled={!selectedReport}
//             >
//               {GRAPH_TYPES.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//             </select>
//           )}
//           <select className="filter-select" value={selectedUser} onChange={e => setSelectedUser(e.target.value)} disabled={!selectedReport || !filterColumnNames.user}>
//             <option value="">All Users</option>
//             {users.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//           </select>
//           <select className="filter-select" value={selectedYear} onChange={e => setSelectedYear(e.target.value)} disabled={!selectedReport || availableYears.length === 0}>
//             <option value="">All Years</option>
//             {availableYears.map(opt => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
//           </select>
//           <select className="filter-select" value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} disabled={!selectedReport || availableMonths.length === 0}>
//             <option value="">All Months</option>
//             {availableMonths.map(opt => <option key={opt.id} value={opt.id}>{opt.value}</option>)}
//           </select>
//           <select className="filter-select" value={selectedProject} onChange={e => setSelectedProject(e.target.value)} disabled={!selectedReport || !filterColumnNames.project}>
//             <option value="">All Projects</option>
//             {projects.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//           </select>
//           <select className="filter-select" value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} disabled={!selectedReport || !filterColumnNames.category}>
//             <option value="">All Categories</option>
//             {categories.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//           </select>
//         </div>
//       </div>

//       {loading && <div className="status-message">Loading Report...</div>}
//       {!loading && !selectedReport && allReports.length > 0 && <div className="status-message">Please select a report to view data.</div>}
//       {!loading && allReports.length === 0 && !error && <div className="status-message">No reports available for this module.</div>}

//       <div ref={printableRef} className="printable-content">
//         {!loading && selectedReport && (
//           <>
//             {isGraphEnabled && (
//               <div className="view-toggle-wrapper non-printable">
//                 <button className={`view-toggle-button ${viewMode === 'graph' ? 'active' : ''}`} onClick={() => setViewMode('graph')}>Graph</button>
//                 <button className={`view-toggle-button ${viewMode === 'list' ? 'active' : ''}`} onClick={() => setViewMode('list')}>List</button>
//                 <button className={`view-toggle-button ${viewMode === 'both' ? 'active' : ''}`} onClick={() => setViewMode('both')}>Both</button>
//               </div>
//             )}
//             {isGraphEnabled && (viewMode === 'graph' || viewMode === 'both') && <div className="chart-container">{renderChart()}</div>}
//             {(viewMode === 'list' || viewMode === 'both' || !isGraphEnabled) && (
//               <div className="table-container">
//                 <div className="table-header-controls non-printable">
//                   <input type="text" placeholder="Search across all columns..." className="search-input" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
//                   <div className="export-buttons">
//                     {reportPermissions.canExport && (
//                       <>
//                         <button className="export-button" onClick={() => exportToCSV(filteredAndSearchedTasks, tableColumns, `${dynamicTableTitle.replace(/\s/g, '_')}_filtered.csv`)}>Export Filtered</button>
//                         <button className="export-button" onClick={() => exportToCSV(allTasks, tableColumns, `${selectedReport.replace(/\s/g, '_')}_all.csv`)}>Export All</button>
//                       </>
//                     )}
//                     <button className="export-button" onClick={handleOpenEmailModal}>Email</button>
//                     {reportPermissions.canPrint && <button className="export-button" onClick={handlePrint}>Print</button>}
//                   </div>
//                 </div>
//                 <div className="printable-area">
//                   <h2>{dynamicTableTitle}</h2>
//                   <div className="table-responsive-wrapper">
//                     <table>
//                       <thead>
//                         <tr>
//                           {tableColumns.map(column => <th key={column}>{formatHeader(column)}</th>)}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {/* MODIFIED: Render paginatedTasks instead of the full list */}
//                         {paginatedTasks.length > 0 ? (
//                           paginatedTasks.map((task, index) => (
//                             <tr key={task.task_id || `row-${index}`}>
//                               {tableColumns.map(column => (
//                                 <td key={`${task.task_id || index}-${column}`}>{renderCell(task, column)}</td>
//                               ))}
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan={tableColumns.length || 1} className="status-message">No items found for the current selection.</td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                   {/* NEW: Pagination Controls */}
//                   {filteredAndSearchedTasks.length > 0 && (
//                     <div className="pagination-controls non-printable">
//                       <button onClick={handleFirstPage} disabled={currentPage === 1} className="pagination-button" title="First Page">{'|<'}</button>
//                       <button onClick={handlePreviousPage} disabled={currentPage === 1} className="pagination-button" title="Previous Page">{'<'}</button>
//                       <span className="pagination-info">
//                         <input type="number" value={currentPage} onChange={handlePageInputChange} className="pagination-input" min="1" max={totalPages}/> of {totalPages}
//                       </span>
//                       <button onClick={handleNextPage} disabled={currentPage === totalPages} className="pagination-button" title="Next Page">{'>'}</button>
//                       <button onClick={handleLastPage} disabled={currentPage === totalPages} className="pagination-button" title="Last Page">{'>|'}</button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       {isEmailModalOpen && (
//         <div className="email-modal-overlay">
//           <div className="email-modal-content">
//             <form onSubmit={handleSendEmail}>
//               <div className="email-modal-header">
//                 <h3>Send Report via Email</h3>
//                 <button type="button" className="close-button" onClick={() => setIsEmailModalOpen(false)}>×</button>
//               </div>
//               <div className="email-modal-body">
//                 <div className="form-group">
//                   <label htmlFor="email-to-select">To *</label>
//                   <Select id="email-to-select" isMulti options={emailRecipients} value={emailTo} onChange={(selectedOptions) => setEmailTo(selectedOptions || [])} isLoading={isFetchingRecipients} placeholder="Search or select recipients..." closeMenuOnSelect={false} hideSelectedOptions={false} components={{ Option: CheckboxOption }} className="email-select-container" classNamePrefix="email-select" styles={customSelectStyles} />
//                 </div>
//                 <div className="form-group"><label htmlFor="email-cc">CC</label><input id="email-cc" type="text" value={emailCc} onChange={(e) => setEmailCc(e.target.value)} placeholder="Comma-separated emails" /></div>
//                 <div className="form-group"><label htmlFor="email-bcc">BCC</label><input id="email-bcc" type="text" value={emailBcc} onChange={(e) => setEmailBcc(e.target.value)} placeholder="Comma-separated emails" /></div>
//                 <div className="form-group"><label htmlFor="email-subject">Subject *</label><input id="email-subject" type="text" value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} required /></div>
//                 <div className="form-group">
//                   <label htmlFor="email-body">Body *</label>
//                   <textarea id="email-body" value={emailBody} onChange={(e) => setEmailBody(e.target.value)} rows="5" required />
//                 </div>
//                 <div className="form-group">
//                   <label>Attachments</label>
//                   <div className="attachment-list">
//                     {emailAttachments.map((file, index) => (
//                       <div key={index} className="attachment-item">
//                         <span>{file.name} ({Math.round(file.size / 1024)} KB)</span>
//                         <button type="button" className="remove-attachment-btn" onClick={() => handleRemoveAttachment(index)}>×</button>
//                       </div>
//                     ))}
//                   </div>
//                   <input type="file" ref={fileInputRef} onChange={handleAddAttachment} style={{ display: 'none' }} multiple />
//                 </div>
//                 {emailStatus.message && <div className={`email-status-message ${emailStatus.type}`}>{emailStatus.message}</div>}
//               </div>
//               <div className="email-modal-footer">
//                 <button type="button" className="cancel-btn" onClick={() => setIsEmailModalOpen(false)}>Cancel</button>
//                 <button type="submit" className="send-btn" disabled={emailSending}>{emailSending ? 'Sending...' : 'Send Email'}</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ReportPage;









// import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
// import Select, { components } from 'react-select';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   LineElement,
//   PointElement,
// } from 'chart.js';
// import { Pie, Bar, Line } from 'react-chartjs-2';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Report.css';

// // Register Chart.js components
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   LineElement,
//   PointElement,
//   ChartDataLabels
// );

// // --- Constants from Environment Variables ---
// const API_BASE_URL = process.env.REACT_APP_REPORTS_API_URL || 'http://localhost:3000'; // Fallback for local dev
// const MAIL_API_URL = process.env.REACT_APP_MAIL_API_URL;
// const NODE_SERVICE_BASE_URL = process.env.REACT_APP_NODE_SERVICE_BASE_URL;
// const COMMON_MASTER_API_URL = `${NODE_SERVICE_BASE_URL}/api/get-column/common_master`;

// // NEW: Constant for pagination
// const ROWS_PER_PAGE = 10;

// const GRAPH_TYPES = [
//   { value: 'Pie', label: 'Pie Chart' },
//   { value: 'Bar', label: 'Bar Chart' },
// ];

// const parseJwt = (token) => {
//   try {
//     return JSON.parse(atob(token.split('.')[1]));
//   } catch (e) {
//     console.error("Failed to parse JWT:", e);
//     return null;
//   }
// };

// const createOptions = (data, key) => {
//   if (!data || data.length === 0 || !key) return [];
//   const uniqueValues = [...new Set(data.map(item => item[key]).filter(Boolean))];
//   return uniqueValues.sort().map(value => ({ value, label: value }));
// };

// const formatHeader = (header) => {
//   if (!header) return '';
//   return header
//     .replace(/_/g, ' ')
//     .replace(/id/g, 'ID')
//     .replace(/\b\w/g, char => char.toUpperCase());
// };

// const findValueColumn = (columns) => {
//   const commonValueNames = ['total', 'count', 'sum', 'amount', 'value'];
//   return columns.find(col =>
//     commonValueNames.some(name => col.toLowerCase().includes(name))
//   ) || null;
// };

// const generateDynamicColors = (numColors) => {
//   const colors = [];
//   for (let i = 0; i < numColors; i++) {
//     const hue = (i * 137.508) % 360;
//     colors.push(`hsla(${hue}, 70%, 60%, 0.8)`);
//   }
//   return colors;
// };

// const exportToCSV = (tasks, columns, filename) => {
//   if (!tasks || tasks.length === 0 || !columns || columns.length === 0) {
//     alert("No data available to export.");
//     return;
//   }

//   const headers = columns.map(formatHeader);
//   const csvRows = [
//     headers.join(','),
//     ...tasks.map(task =>
//       columns.map(column => {
//         let cellData = task[column];
//         if (cellData === null || cellData === undefined) return '""';
//         if (Array.isArray(cellData)) {
//           cellData = cellData.filter(item => item).join('; ');
//         }
//         const stringData = String(cellData).replace(/"/g, '""');
//         return `"${stringData}"`;
//       }).join(',')
//     )
//   ];

//   const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
//   const link = document.createElement('a');
//   const url = URL.createObjectURL(blob);
//   link.setAttribute('href', url);
//   link.setAttribute('download', filename);
//   link.style.visibility = 'hidden';
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };

// const generateCSVFile = (tasks, columns, filename) => {
//   if (!tasks || tasks.length === 0 || !columns || columns.length === 0) {
//     return null;
//   }

//   const headers = columns.map(formatHeader);
//   const csvRows = [
//     headers.join(','),
//     ...tasks.map(task =>
//       columns.map(column => {
//         let cellData = task[column];
//         if (cellData === null || cellData === undefined) return '""';
//         if (Array.isArray(cellData)) {
//           cellData = cellData.filter(item => item).join('; ');
//         }
//         const stringData = String(cellData).replace(/"/g, '""');
//         return `"${stringData}"`;
//       }).join(',')
//     )
//   ];

//   const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
//   return new File([blob], filename, { type: 'text/csv;charset=utf-8;' });
// };


// const CheckboxOption = (props) => {
//   return (
//     <components.Option {...props}>
//       <input
//         type="checkbox"
//         checked={props.isSelected}
//         onChange={() => null}
//         style={{ marginRight: '10px' }}
//       />
//       <label>{props.label}</label>
//     </components.Option>
//   );
// };


// const ReportPage = () => {
//   const [authToken, setAuthToken] = useState(null);
//   const bearerToken = useMemo(() => authToken ? `Bearer ${authToken}` : null, [authToken]);

//   const [allReports, setAllReports] = useState([]);
//   const [selectedReport, setSelectedReport] = useState('');
//   const [allTasks, setAllTasks] = useState([]);
//   const [tableColumns, setTableColumns] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewMode, setViewMode] = useState('list');
//   const [reportPermissions, setReportPermissions] = useState({ canPrint: false, canExport: false });

//   // NEW: Pagination State
//   const [currentPage, setCurrentPage] = useState(1);

//   const [users, setUsers] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedGraphType, setSelectedGraphType] = useState('Pie');
//   const [selectedUser, setSelectedUser] = useState('');
//   const [selectedProject, setSelectedProject] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState('');

//   const [years, setYears] = useState([]);
//   const [months, setMonths] = useState([]);
//   const [selectedYear, setSelectedYear] = useState('');
//   const [selectedMonth, setSelectedMonth] = useState('');

//   const [availableYears, setAvailableYears] = useState([]);
//   const [availableMonths, setAvailableMonths] = useState([]);

//   const [filterColumnNames, setFilterColumnNames] = useState({ user: null, project: null, category: null, date: null });

//   const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
//   const [emailTo, setEmailTo] = useState([]);
//   const [emailCc, setEmailCc] = useState('');
//   const [emailBcc, setEmailBcc] = useState('');
//   const [emailSubject, setEmailSubject] = useState('');
//   const [emailBody, setEmailBody] = useState('');
//   const [emailAttachments, setEmailAttachments] = useState([]);
//   const [emailSending, setEmailSending] = useState(false);
//   const [emailStatus, setEmailStatus] = useState({ message: '', type: '' });
//   const [emailRecipients, setEmailRecipients] = useState([]);
//   const [isFetchingRecipients, setIsFetchingRecipients] = useState(false);

//   const printableRef = useRef();
//   const fileInputRef = useRef(null);
//   const customSelectStyles = {
//     menu: (provided) => ({ ...provided, zIndex: 9999 }),
//   };

//   const currentUserId = useMemo(() => {
//     if (!authToken) return null;
//     const parsedToken = parseJwt(authToken);
//     return parsedToken?.claims?.user_ID;
//   }, [authToken]);

//   const currentReportObject = useMemo(() =>
//     allReports.find(report => report.report_name === selectedReport),
//     [allReports, selectedReport]
//   );

//   const isGraphEnabled = useMemo(() =>
//     currentReportObject?.graph === 'yes',
//     [currentReportObject]
//   );

//   const fetchMonths = useCallback(async () => {
//     if (!bearerToken) return;
//     try {
//       const response = await fetch(`${COMMON_MASTER_API_URL}/month_name`, {
//         headers: { accept: 'application/json', Authorization: bearerToken },
//       });
//       if (response.ok) {
//         const monthData = await response.json();
//         const sortedMonths = monthData.sort((a, b) => a.id - b.id);
//         setMonths(sortedMonths);
//       } else {
//         throw new Error(`Failed to fetch months: ${response.status}`);
//       }
//     } catch (error) {
//       console.error('fetchMonths error:', error);
//       setMonths([]);
//     }
//   }, [bearerToken]);

//   const fetchYears = useCallback(async () => {
//     if (!bearerToken) return;
//     try {
//       const [fromResponse, toResponse] = await Promise.all([
//         fetch(`${COMMON_MASTER_API_URL}/from_date`, { headers: { accept: 'application/json', Authorization: bearerToken } }),
//         fetch(`${COMMON_MASTER_API_URL}/to_date`, { headers: { accept: 'application/json', Authorization: bearerToken } }),
//       ]);

//       if (!fromResponse.ok || !toResponse.ok) throw new Error('Failed to fetch financial years');

//       const fromData = await fromResponse.json();
//       const toData = await toResponse.json();

//       const yearOptions = fromData.map((from) => {
//         const to = toData.find((t) => t.id === from.id);
//         const fromYear = new Date(from.value).getFullYear();
//         const toYear = new Date(to.value).getFullYear();
//         return {
//           id: from.id,
//           label: `${fromYear}-${toYear.toString().slice(-2)}`,
//           from_date: from.value,
//           to_date: to.value,
//         };
//       }).sort((a, b) => b.id - a.id);

//       setYears(yearOptions);
//     } catch (error) {
//       console.error('fetchYears error:', error);
//       setYears([]);
//     }
//   }, [bearerToken]);

//   const fetchReportList = useCallback(async () => {
//     if (!bearerToken) return;
//     setLoading(true);
//     try {
//       const response = await fetch(`${API_BASE_URL}/api/reports`, {
//         method: 'GET',
//         headers: { 'Accept': 'application/json', 'Authorization': bearerToken },
//       });

//       if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

//       const result = await response.json();
//       const allFetchedReports = result || [];
//       // MODIFIED: Filter reports to only show those for the 'ZTask' module
//       const reports = allFetchedReports.filter(report => report.module_name === 'ZTask');
      
//       setAllReports(reports);

//       if (reports.length > 0) {
//         setSelectedReport(reports[0].report_name);
//       } else {
//         setLoading(false);
//       }
//     } catch (err) {
//       console.error("Failed to fetch report list:", err);
//       setError("Could not load report options.");
//       setLoading(false);
//     }
//   }, [bearerToken]);

//   const fetchReportData = useCallback(async (reportName) => {
//     if (!reportName || !bearerToken) {
//       setAllTasks([]);
//       setTableColumns([]);
//       setReportPermissions({ canPrint: false, canExport: false });
//       if (allReports.length > 0) setLoading(false);
//       return;
//     }

//     setLoading(true);
//     setError(null);
//     setSelectedUser('');
//     setSelectedYear('');
//     setSelectedMonth('');
//     setSelectedProject('');
//     setSelectedCategory('');
//     setSearchTerm('');

//     try {
//       const response = await fetch(`${API_BASE_URL}/api/reports/run`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': bearerToken },
//         body: JSON.stringify({ report_name: reportName, module_name: 'ZTask' }),
//       });

//       // --- MODIFICATION START ---
//       // Check for specific HTTP status codes to provide better user feedback.
//       if (!response.ok) {
//         if (response.status === 403) {
//           // If the status is 403 (Forbidden), show the user's custom message.
//           throw new Error("It seems that, there are no reports assigned to you");
//         }
//         // For all other errors, show the generic HTTP error message.
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }
//       // --- MODIFICATION END ---

//       const result = await response.json();
//       const data = result.data || [];
//       const columns = result.columns || [];

//       setTableColumns(columns);
//       setAllTasks(data);

//       const findColumn = (possibleNames) => columns.find(c => possibleNames.includes(c.toLowerCase()));

//       const newFilterColumns = {
//         user: findColumn(['assignee_name', 'user_name', 'user', 'assignee', 'task assignee']),
//         project: findColumn(['project_name', 'project']),
//         category: findColumn(['category', 'task_category']),
//         date: findColumn(['due_date', 'report date', 'report_date', 'created_at', 'task open dt'])
//       };

//       setFilterColumnNames(newFilterColumns);
//       setUsers(createOptions(data, newFilterColumns.user));
//       setProjects(createOptions(data, newFilterColumns.project));
//       setCategories(createOptions(data, newFilterColumns.category));

//     } catch (err) {
//       console.error("Failed to fetch report data:", err);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   }, [allReports.length, bearerToken]);

//   const fetchEmailRecipients = useCallback(async () => {
//     if (!bearerToken) return;
//     setIsFetchingRecipients(true);
//     setEmailStatus({ message: '', type: '' });

//     try {
//       const response = await fetch(`${API_BASE_URL}/api/reports/get-columns`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': bearerToken },
//         body: JSON.stringify({ table_name: "users", column_names: ["email"] }),
//       });

//       if (!response.ok) throw new Error(`Failed to fetch email recipients. Status: ${response.status}`);

//       const result = await response.json();
//       if (result.data && Array.isArray(result.data)) {
//         const formattedRecipients = result.data
//           .map(user => ({ value: user.email, label: user.email }))
//           .sort((a, b) => a.label.localeCompare(b.label));
//         setEmailRecipients(formattedRecipients);
//       } else {
//         throw new Error("Invalid data format for email recipients.");
//       }
//     } catch (err) {
//       console.error(err);
//       setEmailStatus({ message: 'Could not load email recipients.', type: 'error' });
//       setEmailRecipients([]);
//     } finally {
//       setIsFetchingRecipients(false);
//     }
//   }, [bearerToken]);

//   useEffect(() => {
//     const token = localStorage.getItem('zTaskAuthToken');
//     if (token) {
//       setAuthToken(token);
//     } else {
//       console.error("Authentication token not found in local storage.");
//       setError("You are not authenticated. Please log in.");
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     if (bearerToken) {
//       fetchReportList();
//       fetchMonths();
//       fetchYears();
//     }
//   }, [bearerToken, fetchReportList, fetchMonths, fetchYears]);

//   useEffect(() => {
//     if (selectedReport && bearerToken) {
//         fetchReportData(selectedReport);
//     }

//     if (currentReportObject) {
//       setViewMode(isGraphEnabled ? 'both' : 'list');
//       if (currentUserId) {
//         const canPrint = currentReportObject.print?.includes(currentUserId) ?? false;
//         const canExport = currentReportObject.export?.includes(currentUserId) ?? false;
//         setReportPermissions({ canPrint, canExport });
//       } else {
//         setReportPermissions({ canPrint: false, canExport: false });
//       }
//     }
//   }, [selectedReport, bearerToken, fetchReportData, currentReportObject, isGraphEnabled, currentUserId]);

//   useEffect(() => {
//     if (!allTasks.length || !filterColumnNames.date || !months.length || !years.length) {
//       setAvailableMonths([]);
//       setAvailableYears([]);
//       return;
//     }
//     const dateCol = filterColumnNames.date;
//     const presentMonthIds = new Set();
//     const presentYearIds = new Set();
//     allTasks.forEach(task => {
//       const taskDateValue = task[dateCol];
//       if (!taskDateValue) return;
//       const taskDate = new Date(taskDateValue);
//       if (isNaN(taskDate.getTime())) return;
//       const monthId = (taskDate.getMonth() + 1).toString();
//       presentMonthIds.add(monthId);
//       for (const yearOption of years) {
//         const fromDate = new Date(yearOption.from_date);
//         const toDate = new Date(yearOption.to_date);
//         toDate.setHours(23, 59, 59, 999);
//         if (taskDate >= fromDate && taskDate <= toDate) {
//           presentYearIds.add(yearOption.id);
//           break;
//         }
//       }
//     });
//     const filteredMonths = months
//       .filter(month => presentMonthIds.has(month.id.toString()))
//       .sort((a, b) => a.id - b.id);
//     const filteredYears = years
//       .filter(year => presentYearIds.has(year.id))
//       .sort((a, b) => b.id - a.id);
//     setAvailableMonths(filteredMonths);
//     setAvailableYears(filteredYears);
//   }, [allTasks, filterColumnNames.date, months, years]);

//   // NEW: Effect to reset current page to 1 when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [selectedUser, selectedProject, selectedCategory, selectedYear, selectedMonth, searchTerm, selectedReport]);

//   const filteredAndSearchedTasks = useMemo(() => {
//     let tempTasks = [...allTasks];
//     const { user, project, category, date } = filterColumnNames;

//     if (selectedUser && user) tempTasks = tempTasks.filter(t => t[user] === selectedUser);
//     if (selectedProject && project) tempTasks = tempTasks.filter(t => t[project] === selectedProject);
//     if (selectedCategory && category) tempTasks = tempTasks.filter(t => t[category] === selectedCategory);

//     if (date) {
//       if (selectedYear) {
//         const selectedYearData = years.find(y => y.id.toString() === selectedYear);
//         if (selectedYearData) {
//           const fromDate = new Date(selectedYearData.from_date);
//           const toDate = new Date(selectedYearData.to_date);
//           tempTasks = tempTasks.filter(t => {
//             const taskDate = new Date(t[date]);
//             return taskDate >= fromDate && taskDate <= toDate;
//           });
//         }
//       }
//       if (selectedMonth) {
//         tempTasks = tempTasks.filter(t => (new Date(t[date]).getMonth() + 1).toString() === selectedMonth);
//       }
//     }

//     if (searchTerm.trim() !== '') {
//       const lowercasedTerm = searchTerm.toLowerCase();
//       tempTasks = tempTasks.filter(task =>
//         tableColumns.some(col => String(task[col]).toLowerCase().includes(lowercasedTerm))
//       );
//     }
//     return tempTasks;
//   }, [allTasks, tableColumns, selectedUser, selectedProject, selectedCategory, searchTerm, filterColumnNames, selectedYear, selectedMonth, years]);

//   // NEW: Calculate total pages and slice data for the current page
//   const { totalPages, paginatedTasks } = useMemo(() => {
//     const total = Math.ceil(filteredAndSearchedTasks.length / ROWS_PER_PAGE);
//     const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
//     const paginated = filteredAndSearchedTasks.slice(startIndex, startIndex + ROWS_PER_PAGE);
//     return {
//       totalPages: total > 0 ? total : 1, // Ensure totalPages is at least 1
//       paginatedTasks: paginated,
//     };
//   }, [filteredAndSearchedTasks, currentPage]);

//   const dynamicTableTitle = useMemo(() => {
//     const activeFilters = [selectedReport];
//     if (selectedUser) activeFilters.push(selectedUser);
//     if (selectedProject) activeFilters.push(selectedProject);
//     if (selectedCategory) activeFilters.push(selectedCategory);

//     if (selectedYear) {
//       const yearLabel = years.find(y => y.id.toString() === selectedYear)?.label;
//       if (yearLabel) activeFilters.push(`Year: ${yearLabel}`);
//     }
//     if (selectedMonth) {
//       const monthLabel = months.find(m => m.id.toString() === selectedMonth)?.value;
//       if (monthLabel) activeFilters.push(monthLabel);
//     }
//     return activeFilters.length > 1 ? activeFilters.join(' - ') : selectedReport;
//   }, [selectedUser, selectedProject, selectedCategory, selectedYear, selectedMonth, selectedReport, years, months]);

//   const chartData = useMemo(() => {
//     const dataToChart = filteredAndSearchedTasks;
//     if (!dataToChart || dataToChart.length === 0 || tableColumns.length === 0) {
//       return { labels: [], datasets: [] };
//     }
//     const valueColumn = findValueColumn(tableColumns);
//     if (valueColumn) {
//       const labelColumns = tableColumns.filter(c => c !== valueColumn);
//       if (labelColumns.length >= 2) {
//         const primaryLabelCol = labelColumns[0];
//         const seriesCol = labelColumns[1];
//         const labels = [...new Set(dataToChart.map(item => item[primaryLabelCol]))].sort();
//         const seriesNames = [...new Set(dataToChart.map(item => item[seriesCol]))].sort();
//         const colors = generateDynamicColors(seriesNames.length);
//         const datasets = seriesNames.map((seriesName, index) => ({
//           label: seriesName,
//           data: labels.map(label => {
//             const dataPoint = dataToChart.find(item => item[primaryLabelCol] === label && item[seriesCol] === seriesName);
//             return dataPoint ? parseFloat(dataPoint[valueColumn]) || 0 : 0;
//           }),
//           backgroundColor: colors[index],
//           borderColor: colors[index].replace('0.8', '1'),
//           borderWidth: 1,
//         }));
//         return { labels, datasets };
//       }
//       if (labelColumns.length === 1) {
//         const labelCol = labelColumns[0];
//         const labels = dataToChart.map(item => item[labelCol]);
//         const data = dataToChart.map(item => parseFloat(item[valueColumn]) || 0);
//         return {
//           labels,
//           datasets: [{ label: formatHeader(valueColumn), data, backgroundColor: generateDynamicColors(labels.length), borderColor: '#fff', borderWidth: 1 }],
//         };
//       }
//     }
//     const statusCounts = dataToChart.reduce((acc, task) => {
//       const status = task.status || 'Unknown';
//       acc[status] = (acc[status] || 0) + 1;
//       return acc;
//     }, {});
//     const labels = Object.keys(statusCounts);
//     const data = Object.values(statusCounts);
//     return {
//       labels,
//       datasets: [{ label: 'Number of Items', data, backgroundColor: generateDynamicColors(labels.length), borderColor: '#fff', borderWidth: 1 }],
//     };
//   }, [filteredAndSearchedTasks, tableColumns]);

//   const handlePrint = useCallback(() => window.print(), []);

//   const handleOpenEmailModal = useCallback(() => {
//     fetchEmailRecipients();
//     setEmailSubject(dynamicTableTitle);
//     setEmailBody(``);
//     const reportFile = generateCSVFile(filteredAndSearchedTasks, tableColumns, `${selectedReport}_report.csv`);
//     if (reportFile) setEmailAttachments([reportFile]);
//     else setEmailAttachments([]);
//     setEmailTo([]);
//     setEmailCc('');
//     setEmailBcc('');
//     setEmailStatus({ message: '', type: '' });
//     setEmailSending(false);
//     setIsEmailModalOpen(true);
//   }, [dynamicTableTitle, filteredAndSearchedTasks, tableColumns, selectedReport, fetchEmailRecipients]);

//   const handleAddAttachment = useCallback((e) => {
//     if (e.target.files) setEmailAttachments(prev => [...prev, ...Array.from(e.target.files)]);
//   }, []);

//   const handleRemoveAttachment = useCallback((indexToRemove) => {
//     setEmailAttachments(prev => prev.filter((_, index) => index !== indexToRemove));
//   }, []);

//   const handleSendEmail = useCallback(async (e) => {
//     e.preventDefault();
//     if (emailTo.length === 0 || !emailSubject || !emailBody) {
//       setEmailStatus({ message: 'Please select at least one recipient and fill in Subject and Body.', type: 'error' });
//       return;
//     }
//     setEmailSending(true);
//     setEmailStatus({ message: '', type: '' });
//     try {
//       const params = new URLSearchParams();
//       emailTo.forEach(option => params.append('to', option.value));
//       const processEmails = (emailString) => emailString.split(',').map(e => e.trim()).filter(e => e && e.includes('@'));
//       processEmails(emailCc).forEach(email => params.append('cc', email));
//       processEmails(emailBcc).forEach(email => params.append('bcc', email));
//       params.append('subject', emailSubject);
//       params.append('body', emailBody);
//       const attachmentFormData = new FormData();
//       emailAttachments.forEach(file => attachmentFormData.append('attachment', file, file.name));
//       const fullUrl = `${MAIL_API_URL}?${params.toString()}`;
//       const response = await fetch(fullUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: attachmentFormData });
//       if (!response.ok) {
//         let errorMsg;
//         try {
//           const errorResult = await response.json();
//           errorMsg = errorResult.error || errorResult.message || JSON.stringify(errorResult);
//         } catch (jsonError) {
//           const textResponse = await response.text();
//           errorMsg = textResponse || `Request failed with status: ${response.status}`;
//         }
//         throw new Error(errorMsg);
//       }
//       const result = await response.json();
//       setEmailStatus({ message: result.message || 'Email sent successfully!', type: 'success' });
//       setTimeout(() => setIsEmailModalOpen(false), 2000);
//     } catch (error) {
//       console.error('Failed to send email:', error);
//       setEmailStatus({ message: error.message || 'An unexpected error occurred.', type: 'error' });
//     } finally {
//       setEmailSending(false);
//     }
//   }, [emailTo, emailSubject, emailBody, emailCc, emailBcc, emailAttachments]);

//   // NEW: Handlers for Pagination
//   const handleFirstPage = () => setCurrentPage(1);
//   const handlePreviousPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));
//   const handleNextPage = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));
//   const handleLastPage = () => setCurrentPage(totalPages);
//   const handlePageInputChange = (e) => {
//     const pageNum = Number(e.target.value);
//     if (pageNum >= 1 && pageNum <= totalPages) {
//       setCurrentPage(pageNum);
//     }
//   };

//   const renderCell = useCallback((task, column) => {
//     let value = task[column];
//     if (value === null || value === undefined) return <span className="cell-na">N/A</span>;
//     if (column === 'status') return <span className={`status-badge status-${String(value).toLowerCase()}`}>{value}</span>;
//     if (column === 'priority') return <span className={`priority-badge priority-${String(value).toLowerCase()}`}>{value}</span>;
//     if (['due_date', 'created_at', 'updated_at', 'completed_at', 'Report Date', 'TASK OPEN DT'].includes(column)) {
//       const date = new Date(value);
//       return !isNaN(date.getTime()) ? date.toLocaleString() : String(value);
//     }
//     if (Array.isArray(value)) {
//       const displayValue = value.filter(item => item != null).join(', ');
//       return displayValue || <span className="cell-na">N/A</span>;
//     }
//     const stringValue = String(value);
//     if (column === 'description' && stringValue.length > 100) {
//       return <span title={stringValue}>{stringValue.substring(0, 100)}...</span>;
//     }
//     return stringValue;
//   }, []);

//   const renderChart = useCallback(() => {
//     if (filteredAndSearchedTasks.length === 0 && selectedReport) {
//       return <p className="status-message">No data matches the current filters.</p>;
//     }
//     if (!selectedReport || !chartData.datasets.length) return null;
//     const chartOptions = {
//       responsive: true,
//       maintainAspectRatio: false,
//       plugins: {
//         legend: { position: 'top' },
//         title: { display: true, text: selectedReport || 'Report', font: { size: 18 } },
//         datalabels: selectedGraphType === 'Pie' ? { formatter: (value) => value, color: '#fff', font: { weight: 'bold', size: 16 } } : { display: false },
//       },
//       ...(selectedGraphType !== 'Pie' && { scales: { y: { beginAtZero: true } } }),
//     };
//     switch (selectedGraphType) {
//       case 'Pie': return <Pie options={chartOptions} data={chartData} />;
//       case 'Line': return <Line options={chartOptions} data={chartData} />;
//       case 'Bar': default: return <Bar options={chartOptions} data={chartData} />;
//     }
//   }, [filteredAndSearchedTasks, selectedReport, chartData, selectedGraphType]);

//   if (error) return <div className="status-message error"> {error}</div>;

//   return (
//     <div className="report-container">
//       <div className="non-printable-header">
//         <h1>Reports</h1>
//         <div className="filters-container">
//           <select
//             className="filter-select report-name-select"
//             value={selectedReport}
//             onChange={e => setSelectedReport(e.target.value)}
//             disabled={!bearerToken || allReports.length === 0}
//           >
//             {allReports.map(report => (
//               <option key={report.id} value={report.report_name}>{report.report_name}</option>
//             ))}
//           </select>
//           {isGraphEnabled && (
//             <select
//               className="filter-select"
//               value={selectedGraphType}
//               onChange={e => setSelectedGraphType(e.target.value)}
//               disabled={!selectedReport}
//             >
//               {GRAPH_TYPES.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//             </select>
//           )}
//           <select className="filter-select" value={selectedUser} onChange={e => setSelectedUser(e.target.value)} disabled={!selectedReport || !filterColumnNames.user}>
//             <option value="">All Users</option>
//             {users.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//           </select>
//           <select className="filter-select" value={selectedYear} onChange={e => setSelectedYear(e.target.value)} disabled={!selectedReport || availableYears.length === 0}>
//             <option value="">All Years</option>
//             {availableYears.map(opt => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
//           </select>
//           <select className="filter-select" value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} disabled={!selectedReport || availableMonths.length === 0}>
//             <option value="">All Months</option>
//             {availableMonths.map(opt => <option key={opt.id} value={opt.id}>{opt.value}</option>)}
//           </select>
//           <select className="filter-select" value={selectedProject} onChange={e => setSelectedProject(e.target.value)} disabled={!selectedReport || !filterColumnNames.project}>
//             <option value="">All Projects</option>
//             {projects.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//           </select>
//           <select className="filter-select" value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} disabled={!selectedReport || !filterColumnNames.category}>
//             <option value="">All Categories</option>
//             {categories.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//           </select>
//         </div>
//       </div>

//       {loading && <div className="status-message">Loading Report...</div>}
//       {!loading && !selectedReport && allReports.length > 0 && <div className="status-message">Please select a report to view data.</div>}
//       {!loading && allReports.length === 0 && !error && <div className="status-message">No reports available for this module.</div>}

//       <div ref={printableRef} className="printable-content">
//         {!loading && selectedReport && (
//           <>
//             {isGraphEnabled && (
//               <div className="view-toggle-wrapper non-printable">
//                 <button className={`view-toggle-button ${viewMode === 'graph' ? 'active' : ''}`} onClick={() => setViewMode('graph')}>Graph</button>
//                 <button className={`view-toggle-button ${viewMode === 'list' ? 'active' : ''}`} onClick={() => setViewMode('list')}>List</button>
//                 <button className={`view-toggle-button ${viewMode === 'both' ? 'active' : ''}`} onClick={() => setViewMode('both')}>Both</button>
//               </div>
//             )}
//             {isGraphEnabled && (viewMode === 'graph' || viewMode === 'both') && <div className="chart-container">{renderChart()}</div>}
//             {(viewMode === 'list' || viewMode === 'both' || !isGraphEnabled) && (
//               <div className="table-container">
//                 <div className="table-header-controls non-printable">
//                   <input type="text" placeholder="Search across all columns..." className="search-input" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
//                   <div className="export-buttons">
//                     {reportPermissions.canExport && (
//                       <>
//                         <button className="export-button" onClick={() => exportToCSV(filteredAndSearchedTasks, tableColumns, `${dynamicTableTitle.replace(/\s/g, '_')}_filtered.csv`)}>Export Filtered</button>
//                         <button className="export-button" onClick={() => exportToCSV(allTasks, tableColumns, `${selectedReport.replace(/\s/g, '_')}_all.csv`)}>Export All</button>
//                       </>
//                     )}
//                     <button className="export-button" onClick={handleOpenEmailModal}>Email</button>
//                     {reportPermissions.canPrint && <button className="export-button" onClick={handlePrint}>Print</button>}
//                   </div>
//                 </div>
//                 <div className="printable-area">
//                   <h2>{dynamicTableTitle}</h2>
//                   <div className="table-responsive-wrapper">
//                     <table>
//                       <thead>
//                         <tr>
//                           {tableColumns.map(column => <th key={column}>{formatHeader(column)}</th>)}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {/* MODIFIED: Render paginatedTasks instead of the full list */}
//                         {paginatedTasks.length > 0 ? (
//                           paginatedTasks.map((task, index) => (
//                             <tr key={task.task_id || `row-${index}`}>
//                               {tableColumns.map(column => (
//                                 <td key={`${task.task_id || index}-${column}`}>{renderCell(task, column)}</td>
//                               ))}
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan={tableColumns.length || 1} className="status-message">No items found for the current selection.</td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                   {/* NEW: Pagination Controls */}
//                   {filteredAndSearchedTasks.length > 0 && (
//                     <div className="pagination-controls non-printable">
//                       <button onClick={handleFirstPage} disabled={currentPage === 1} className="pagination-button" title="First Page">{'|<'}</button>
//                       <button onClick={handlePreviousPage} disabled={currentPage === 1} className="pagination-button" title="Previous Page">{'<'}</button>
//                       <span className="pagination-info">
//                         <input type="number" value={currentPage} onChange={handlePageInputChange} className="pagination-input" min="1" max={totalPages}/> of {totalPages}
//                       </span>
//                       <button onClick={handleNextPage} disabled={currentPage === totalPages} className="pagination-button" title="Next Page">{'>'}</button>
//                       <button onClick={handleLastPage} disabled={currentPage === totalPages} className="pagination-button" title="Last Page">{'>|'}</button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       {isEmailModalOpen && (
//         <div className="email-modal-overlay">
//           <div className="email-modal-content">
//             <form onSubmit={handleSendEmail}>
//               <div className="email-modal-header">
//                 <h3>Send Report via Email</h3>
//                 <button type="button" className="close-button" onClick={() => setIsEmailModalOpen(false)}>×</button>
//               </div>
//               <div className="email-modal-body">
//                 <div className="form-group">
//                   <label htmlFor="email-to-select">To *</label>
//                   <Select id="email-to-select" isMulti options={emailRecipients} value={emailTo} onChange={(selectedOptions) => setEmailTo(selectedOptions || [])} isLoading={isFetchingRecipients} placeholder="Search or select recipients..." closeMenuOnSelect={false} hideSelectedOptions={false} components={{ Option: CheckboxOption }} className="email-select-container" classNamePrefix="email-select" styles={customSelectStyles} />
//                 </div>
//                 <div className="form-group"><label htmlFor="email-cc">CC</label><input id="email-cc" type="text" value={emailCc} onChange={(e) => setEmailCc(e.target.value)} placeholder="Comma-separated emails" /></div>
//                 <div className="form-group"><label htmlFor="email-bcc">BCC</label><input id="email-bcc" type="text" value={emailBcc} onChange={(e) => setEmailBcc(e.target.value)} placeholder="Comma-separated emails" /></div>
//                 <div className="form-group"><label htmlFor="email-subject">Subject *</label><input id="email-subject" type="text" value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} required /></div>
//                 <div className="form-group">
//                   <label htmlFor="email-body">Body *</label>
//                   <textarea id="email-body" value={emailBody} onChange={(e) => setEmailBody(e.target.value)} rows="5" required />
//                 </div>
//                 <div className="form-group">
//                   <label>Attachments</label>
//                   <div className="attachment-list">
//                     {emailAttachments.map((file, index) => (
//                       <div key={index} className="attachment-item">
//                         <span>{file.name} ({Math.round(file.size / 1024)} KB)</span>
//                         <button type="button" className="remove-attachment-btn" onClick={() => handleRemoveAttachment(index)}>×</button>
//                       </div>
//                     ))}
//                   </div>
//                   <input type="file" ref={fileInputRef} onChange={handleAddAttachment} style={{ display: 'none' }} multiple />
//                 </div>
//                 {emailStatus.message && <div className={`email-status-message ${emailStatus.type}`}>{emailStatus.message}</div>}
//               </div>
//               <div className="email-modal-footer">
//                 <button type="button" className="cancel-btn" onClick={() => setIsEmailModalOpen(false)}>Cancel</button>
//                 <button type="submit" className="send-btn" disabled={emailSending}>{emailSending ? 'Sending...' : 'Send Email'}</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ReportPage;







// import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
// import Select, { components } from 'react-select';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   LineElement,
//   PointElement,
// } from 'chart.js';
// import { Pie, Bar, Line } from 'react-chartjs-2';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import './Report.css';

// // Register Chart.js components
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   LineElement,
//   PointElement,
//   ChartDataLabels
// );

// // --- Constants from Environment Variables ---
// const API_BASE_URL = process.env.REACT_APP_REPORTS_API_URL || 'http://localhost:3000'; // Fallback for local dev
// const MAIL_API_URL = process.env.REACT_APP_MAIL_API_URL;
// const NODE_SERVICE_BASE_URL = process.env.REACT_APP_NODE_SERVICE_BASE_URL;
// const COMMON_MASTER_API_URL = `${NODE_SERVICE_BASE_URL}/api/get-column/common_master`;

// // NEW: Constant for pagination
// const ROWS_PER_PAGE = 10;

// const GRAPH_TYPES = [
//   { value: 'Pie', label: 'Pie Chart' },
//   { value: 'Bar', label: 'Bar Chart' },
// ];

// const parseJwt = (token) => {
//   try {
//     return JSON.parse(atob(token.split('.')[1]));
//   } catch (e) {
//     console.error("Failed to parse JWT:", e);
//     return null;
//   }
// };

// const createOptions = (data, key) => {
//   if (!data || data.length === 0 || !key) return [];
//   const uniqueValues = [...new Set(data.map(item => item[key]).filter(Boolean))];
//   return uniqueValues.sort().map(value => ({ value, label: value }));
// };

// const formatHeader = (header) => {
//   if (!header) return '';
//   return header
//     .replace(/_/g, ' ')
//     .replace(/id/g, 'ID')
//     .replace(/\b\w/g, char => char.toUpperCase());
// };

// const findValueColumn = (columns) => {
//   const commonValueNames = ['total', 'count', 'sum', 'amount', 'value'];
//   return columns.find(col =>
//     commonValueNames.some(name => col.toLowerCase().includes(name))
//   ) || null;
// };

// const generateDynamicColors = (numColors) => {
//   const colors = [];
//   for (let i = 0; i < numColors; i++) {
//     const hue = (i * 137.508) % 360;
//     colors.push(`hsla(${hue}, 70%, 60%, 0.8)`);
//   }
//   return colors;
// };

// const exportToCSV = (tasks, columns, filename) => {
//   if (!tasks || tasks.length === 0 || !columns || columns.length === 0) {
//     alert("No data available to export.");
//     return;
//   }

//   const headers = columns.map(formatHeader);
//   const csvRows = [
//     headers.join(','),
//     ...tasks.map(task =>
//       columns.map(column => {
//         let cellData = task[column];
//         if (cellData === null || cellData === undefined) return '""';
//         if (Array.isArray(cellData)) {
//           cellData = cellData.filter(item => item).join('; ');
//         }
//         const stringData = String(cellData).replace(/"/g, '""');
//         return `"${stringData}"`;
//       }).join(',')
//     )
//   ];

//   const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
//   const link = document.createElement('a');
//   const url = URL.createObjectURL(blob);
//   link.setAttribute('href', url);
//   link.setAttribute('download', filename);
//   link.style.visibility = 'hidden';
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };

// const generateCSVFile = (tasks, columns, filename) => {
//   if (!tasks || tasks.length === 0 || !columns || columns.length === 0) {
//     return null;
//   }

//   const headers = columns.map(formatHeader);
//   const csvRows = [
//     headers.join(','),
//     ...tasks.map(task =>
//       columns.map(column => {
//         let cellData = task[column];
//         if (cellData === null || cellData === undefined) return '""';
//         if (Array.isArray(cellData)) {
//           cellData = cellData.filter(item => item).join('; ');
//         }
//         const stringData = String(cellData).replace(/"/g, '""');
//         return `"${stringData}"`;
//       }).join(',')
//     )
//   ];

//   const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
//   return new File([blob], filename, { type: 'text/csv;charset=utf-8;' });
// };


// const CheckboxOption = (props) => {
//   return (
//     <components.Option {...props}>
//       <input
//         type="checkbox"
//         checked={props.isSelected}
//         onChange={() => null}
//         style={{ marginRight: '10px' }}
//       />
//       <label>{props.label}</label>
//     </components.Option>
//   );
// };


// const ReportPage = () => {
//   const [authToken, setAuthToken] = useState(null);
//   const bearerToken = useMemo(() => authToken ? `Bearer ${authToken}` : null, [authToken]);

//   const [allReports, setAllReports] = useState([]);
//   const [selectedReport, setSelectedReport] = useState('');
//   const [allTasks, setAllTasks] = useState([]);
//   const [tableColumns, setTableColumns] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewMode, setViewMode] = useState('list');
//   const [reportPermissions, setReportPermissions] = useState({ canPrint: false, canExport: false });

//   // Pagination State
//   const [currentPage, setCurrentPage] = useState(1);

//   // Filter States
//   const [users, setUsers] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedGraphType, setSelectedGraphType] = useState('Pie');
//   const [selectedUser, setSelectedUser] = useState('');
//   const [selectedProject, setSelectedProject] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState('');

//   const [years, setYears] = useState([]);
//   const [months, setMonths] = useState([]);
//   const [selectedYear, setSelectedYear] = useState('');
//   const [selectedMonth, setSelectedMonth] = useState('');

//   // State for Tally export date range filter
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');

//   const [availableYears, setAvailableYears] = useState([]);
//   const [availableMonths, setAvailableMonths] = useState([]);

//   const [filterColumnNames, setFilterColumnNames] = useState({ user: null, project: null, category: null, date: null });

//   // Email Modal State
//   const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
//   const [emailTo, setEmailTo] = useState([]);
//   const [emailCc, setEmailCc] = useState('');
//   const [emailBcc, setEmailBcc] = useState('');
//   const [emailSubject, setEmailSubject] = useState('');
//   const [emailBody, setEmailBody] = useState('');
//   const [emailAttachments, setEmailAttachments] = useState([]);
//   const [emailSending, setEmailSending] = useState(false);
//   const [emailStatus, setEmailStatus] = useState({ message: '', type: '' });
//   const [emailRecipients, setEmailRecipients] = useState([]);
//   const [isFetchingRecipients, setIsFetchingRecipients] = useState(false);

//   const printableRef = useRef();
//   const fileInputRef = useRef(null);
//   const customSelectStyles = {
//     menu: (provided) => ({ ...provided, zIndex: 9999 }),
//   };

//   const currentUserId = useMemo(() => {
//     if (!authToken) return null;
//     const parsedToken = parseJwt(authToken);
//     return parsedToken?.claims?.user_ID;
//   }, [authToken]);

//   const currentReportObject = useMemo(() =>
//     allReports.find(report => report.report_name === selectedReport),
//     [allReports, selectedReport]
//   );

//   const isGraphEnabled = useMemo(() =>
//     currentReportObject?.graph === 'yes',
//     [currentReportObject]
//   );

//   const fetchMonths = useCallback(async () => {
//     if (!bearerToken) return;
//     try {
//       const response = await fetch(`${COMMON_MASTER_API_URL}/month_name`, {
//         headers: { accept: 'application/json', Authorization: bearerToken },
//       });
//       if (response.ok) {
//         const monthData = await response.json();
//         const sortedMonths = monthData.sort((a, b) => a.id - b.id);
//         setMonths(sortedMonths);
//       } else {
//         throw new Error(`Failed to fetch months: ${response.status}`);
//       }
//     } catch (error) {
//       console.error('fetchMonths error:', error);
//       setMonths([]);
//     }
//   }, [bearerToken]);

//   const fetchYears = useCallback(async () => {
//     if (!bearerToken) return;
//     try {
//       const [fromResponse, toResponse] = await Promise.all([
//         fetch(`${COMMON_MASTER_API_URL}/from_date`, { headers: { accept: 'application/json', Authorization: bearerToken } }),
//         fetch(`${COMMON_MASTER_API_URL}/to_date`, { headers: { accept: 'application/json', Authorization: bearerToken } }),
//       ]);

//       if (!fromResponse.ok || !toResponse.ok) throw new Error('Failed to fetch financial years');

//       const fromData = await fromResponse.json();
//       const toData = await toResponse.json();

//       const yearOptions = fromData.map((from) => {
//         const to = toData.find((t) => t.id === from.id);
//         const fromYear = new Date(from.value).getFullYear();
//         const toYear = new Date(to.value).getFullYear();
//         return {
//           id: from.id,
//           label: `${fromYear}-${toYear.toString().slice(-2)}`,
//           from_date: from.value,
//           to_date: to.value,
//         };
//       }).sort((a, b) => b.id - a.id);

//       setYears(yearOptions);
//     } catch (error) {
//       console.error('fetchYears error:', error);
//       setYears([]);
//     }
//   }, [bearerToken]);

//   const fetchReportList = useCallback(async () => {
//     if (!bearerToken) return;
//     setLoading(true);
//     try {
//       const response = await fetch(`${API_BASE_URL}/api/reports`, {
//         method: 'GET',
//         headers: { 'Accept': 'application/json', 'Authorization': bearerToken },
//       });

//       if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

//       const result = await response.json();
//       const allFetchedReports = result || [];
//       // MODIFIED: Filter reports to only show those for the 'ZOrder' module
//       const reports = allFetchedReports.filter(report => report.module_name === 'ZOrder');
      
//       setAllReports(reports);

//       if (reports.length > 0) {
//         setSelectedReport(reports[0].report_name);
//       } else {
//         setLoading(false);
//       }
//     } catch (err) {
//       console.error("Failed to fetch report list:", err);
//       setError("Could not load report options.");
//       setLoading(false);
//     }
//   }, [bearerToken]);

//   const fetchReportData = useCallback(async (reportName) => {
//     if (!reportName || !bearerToken) {
//       setAllTasks([]);
//       setTableColumns([]);
//       setReportPermissions({ canPrint: false, canExport: false });
//       if (allReports.length > 0) setLoading(false);
//       return;
//     }

//     setLoading(true);
//     setError(null);
//     setSelectedUser('');
//     setSelectedYear('');
//     setSelectedMonth('');
//     setSelectedProject('');
//     setSelectedCategory('');
//     setSearchTerm('');
//     setFromDate(''); // Reset date range filter
//     setToDate('');   // Reset date range filter

//     try {
//       const response = await fetch(`${API_BASE_URL}/api/reports/run`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': bearerToken },
//         body: JSON.stringify({ report_name: reportName, module_name: 'ZOrder' }),
//       });

//       if (!response.ok) {
//         if (response.status === 403) {
//           throw new Error("It seems that, there are no reports assigned to you");
//         }
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       const result = await response.json();
//       const data = result.data || [];
//       const columns = result.columns || [];

//       setTableColumns(columns);
//       setAllTasks(data);

//       const findColumn = (possibleNames) => columns.find(c => possibleNames.includes(c.toLowerCase()));

//       const newFilterColumns = {
//         user: findColumn(['assignee_name', 'user_name', 'user', 'assignee', 'task assignee']),
//         project: findColumn(['project_name', 'project']),
//         category: findColumn(['category', 'task_category']),
//         date: findColumn(['due_date', 'report date', 'report_date', 'created_at', 'task open dt'])
//       };

//       setFilterColumnNames(newFilterColumns);
//       setUsers(createOptions(data, newFilterColumns.user));
//       setProjects(createOptions(data, newFilterColumns.project));
//       setCategories(createOptions(data, newFilterColumns.category));

//     } catch (err) {
//       console.error("Failed to fetch report data:", err);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   }, [allReports.length, bearerToken]);

//   const fetchEmailRecipients = useCallback(async () => {
//     if (!bearerToken) return;
//     setIsFetchingRecipients(true);
//     setEmailStatus({ message: '', type: '' });

//     try {
//       const response = await fetch(`${API_BASE_URL}/api/reports/get-columns`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': bearerToken },
//         body: JSON.stringify({ table_name: "users", column_names: ["email"] }),
//       });

//       if (!response.ok) throw new Error(`Failed to fetch email recipients. Status: ${response.status}`);

//       const result = await response.json();
//       if (result.data && Array.isArray(result.data)) {
//         const formattedRecipients = result.data
//           .map(user => ({ value: user.email, label: user.email }))
//           .sort((a, b) => a.label.localeCompare(b.label));
//         setEmailRecipients(formattedRecipients);
//       } else {
//         throw new Error("Invalid data format for email recipients.");
//       }
//     } catch (err) {
//       console.error(err);
//       setEmailStatus({ message: 'Could not load email recipients.', type: 'error' });
//       setEmailRecipients([]);
//     } finally {
//       setIsFetchingRecipients(false);
//     }
//   }, [bearerToken]);

//   useEffect(() => {
//     const token = localStorage.getItem('zTaskAuthToken');
//     if (token) {
//       setAuthToken(token);
//     } else {
//       console.error("Authentication token not found in local storage.");
//       setError("You are not authenticated. Please log in.");
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     if (bearerToken) {
//       fetchReportList();
//       fetchMonths();
//       fetchYears();
//     }
//   }, [bearerToken, fetchReportList, fetchMonths, fetchYears]);

//   useEffect(() => {
//     if (selectedReport && bearerToken) {
//         fetchReportData(selectedReport);
//     }

//     if (currentReportObject) {
//       setViewMode(isGraphEnabled ? 'both' : 'list');
//       if (currentUserId) {
//         const canPrint = currentReportObject.print?.includes(currentUserId) ?? false;
//         const canExport = currentReportObject.export?.includes(currentUserId) ?? false;
//         setReportPermissions({ canPrint, canExport });
//       } else {
//         setReportPermissions({ canPrint: false, canExport: false });
//       }
//     }
//   }, [selectedReport, bearerToken, fetchReportData, currentReportObject, isGraphEnabled, currentUserId]);

//   useEffect(() => {
//     if (!allTasks.length || !filterColumnNames.date || !months.length || !years.length) {
//       setAvailableMonths([]);
//       setAvailableYears([]);
//       return;
//     }
//     const dateCol = filterColumnNames.date;
//     const presentMonthIds = new Set();
//     const presentYearIds = new Set();
//     allTasks.forEach(task => {
//       const taskDateValue = task[dateCol];
//       if (!taskDateValue) return;
//       const taskDate = new Date(taskDateValue);
//       if (isNaN(taskDate.getTime())) return;
//       const monthId = (taskDate.getMonth() + 1).toString();
//       presentMonthIds.add(monthId);
//       for (const yearOption of years) {
//         const fromDate = new Date(yearOption.from_date);
//         const toDate = new Date(yearOption.to_date);
//         toDate.setHours(23, 59, 59, 999);
//         if (taskDate >= fromDate && taskDate <= toDate) {
//           presentYearIds.add(yearOption.id);
//           break;
//         }
//       }
//     });
//     const filteredMonths = months
//       .filter(month => presentMonthIds.has(month.id.toString()))
//       .sort((a, b) => a.id - b.id);
//     const filteredYears = years
//       .filter(year => presentYearIds.has(year.id))
//       .sort((a, b) => b.id - a.id);
//     setAvailableMonths(filteredMonths);
//     setAvailableYears(filteredYears);
//   }, [allTasks, filterColumnNames.date, months, years]);

//   // Effect to reset current page to 1 when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [selectedUser, selectedProject, selectedCategory, selectedYear, selectedMonth, searchTerm, selectedReport, fromDate, toDate]);

//   const filteredAndSearchedTasks = useMemo(() => {
//     let tempTasks = [...allTasks];
//     const { user, project, category, date } = filterColumnNames;

//     if (selectedUser && user) tempTasks = tempTasks.filter(t => t[user] === selectedUser);
//     if (selectedProject && project) tempTasks = tempTasks.filter(t => t[project] === selectedProject);
//     if (selectedCategory && category) tempTasks = tempTasks.filter(t => t[category] === selectedCategory);

//     // Date filtering logic: Specific for "Tally export", general for others
//     if (selectedReport === 'Tally export' && fromDate && toDate) {
//       const dateColKey = tableColumns.find(col => col.toLowerCase().replace(/_/g, ' ') === 'inv date');
//       if (dateColKey) {
//         const start = new Date(fromDate);
//         start.setHours(0, 0, 0, 0); // Inclusive start of day
//         const end = new Date(toDate);
//         end.setHours(23, 59, 59, 999); // Inclusive end of day

//         tempTasks = tempTasks.filter(t => {
//           const taskDateValue = t[dateColKey];
//           if (!taskDateValue) return false;
//           const taskDate = new Date(taskDateValue);
//           return !isNaN(taskDate.getTime()) && taskDate >= start && taskDate <= end;
//         });
//       }
//     } else if (date) { // General date filtering for other reports
//       if (selectedYear) {
//         const selectedYearData = years.find(y => y.id.toString() === selectedYear);
//         if (selectedYearData) {
//           const yearFromDate = new Date(selectedYearData.from_date);
//           const yearToDate = new Date(selectedYearData.to_date);
//           tempTasks = tempTasks.filter(t => {
//             const taskDate = new Date(t[date]);
//             return taskDate >= yearFromDate && taskDate <= yearToDate;
//           });
//         }
//       }
//       if (selectedMonth) {
//         tempTasks = tempTasks.filter(t => (new Date(t[date]).getMonth() + 1).toString() === selectedMonth);
//       }
//     }

//     if (searchTerm.trim() !== '') {
//       const lowercasedTerm = searchTerm.toLowerCase();
//       tempTasks = tempTasks.filter(task =>
//         tableColumns.some(col => String(task[col]).toLowerCase().includes(lowercasedTerm))
//       );
//     }
//     return tempTasks;
//   }, [allTasks, tableColumns, selectedUser, selectedProject, selectedCategory, searchTerm, filterColumnNames, selectedYear, selectedMonth, years, selectedReport, fromDate, toDate]);

//   const { totalPages, paginatedTasks } = useMemo(() => {
//     const total = Math.ceil(filteredAndSearchedTasks.length / ROWS_PER_PAGE);
//     const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
//     const paginated = filteredAndSearchedTasks.slice(startIndex, startIndex + ROWS_PER_PAGE);
//     return {
//       totalPages: total > 0 ? total : 1,
//       paginatedTasks: paginated,
//     };
//   }, [filteredAndSearchedTasks, currentPage]);

//   const dynamicTableTitle = useMemo(() => {
//     const activeFilters = [selectedReport];
//     if (selectedUser) activeFilters.push(selectedUser);
//     if (selectedProject) activeFilters.push(selectedProject);
//     if (selectedCategory) activeFilters.push(selectedCategory);

//     if (selectedReport === 'Tally export') {
//         if(fromDate) activeFilters.push(`From: ${fromDate}`);
//         if(toDate) activeFilters.push(`To: ${toDate}`);
//     } else {
//         if (selectedYear) {
//             const yearLabel = years.find(y => y.id.toString() === selectedYear)?.label;
//             if (yearLabel) activeFilters.push(`Year: ${yearLabel}`);
//         }
//         if (selectedMonth) {
//             const monthLabel = months.find(m => m.id.toString() === selectedMonth)?.value;
//             if (monthLabel) activeFilters.push(monthLabel);
//         }
//     }
//     return activeFilters.length > 1 ? activeFilters.join(' - ') : selectedReport;
//   }, [selectedUser, selectedProject, selectedCategory, selectedYear, selectedMonth, selectedReport, years, months, fromDate, toDate]);

//   const chartData = useMemo(() => {
//     const dataToChart = filteredAndSearchedTasks;
//     if (!dataToChart || dataToChart.length === 0 || tableColumns.length === 0) {
//       return { labels: [], datasets: [] };
//     }
//     const valueColumn = findValueColumn(tableColumns);
//     if (valueColumn) {
//       const labelColumns = tableColumns.filter(c => c !== valueColumn);
//       if (labelColumns.length >= 2) {
//         const primaryLabelCol = labelColumns[0];
//         const seriesCol = labelColumns[1];
//         const labels = [...new Set(dataToChart.map(item => item[primaryLabelCol]))].sort();
//         const seriesNames = [...new Set(dataToChart.map(item => item[seriesCol]))].sort();
//         const colors = generateDynamicColors(seriesNames.length);
//         const datasets = seriesNames.map((seriesName, index) => ({
//           label: seriesName,
//           data: labels.map(label => {
//             const dataPoint = dataToChart.find(item => item[primaryLabelCol] === label && item[seriesCol] === seriesName);
//             return dataPoint ? parseFloat(dataPoint[valueColumn]) || 0 : 0;
//           }),
//           backgroundColor: colors[index],
//           borderColor: colors[index].replace('0.8', '1'),
//           borderWidth: 1,
//         }));
//         return { labels, datasets };
//       }
//       if (labelColumns.length === 1) {
//         const labelCol = labelColumns[0];
//         const labels = dataToChart.map(item => item[labelCol]);
//         const data = dataToChart.map(item => parseFloat(item[valueColumn]) || 0);
//         return {
//           labels,
//           datasets: [{ label: formatHeader(valueColumn), data, backgroundColor: generateDynamicColors(labels.length), borderColor: '#fff', borderWidth: 1 }],
//         };
//       }
//     }
//     const statusCounts = dataToChart.reduce((acc, task) => {
//       const status = task.status || 'Unknown';
//       acc[status] = (acc[status] || 0) + 1;
//       return acc;
//     }, {});
//     const labels = Object.keys(statusCounts);
//     const data = Object.values(statusCounts);
//     return {
//       labels,
//       datasets: [{ label: 'Number of Items', data, backgroundColor: generateDynamicColors(labels.length), borderColor: '#fff', borderWidth: 1 }],
//     };
//   }, [filteredAndSearchedTasks, tableColumns]);

//   const handlePrint = useCallback(() => window.print(), []);

//   const handleOpenEmailModal = useCallback(() => {
//     fetchEmailRecipients();
//     setEmailSubject(dynamicTableTitle);
//     setEmailBody(``);
//     const reportFile = generateCSVFile(filteredAndSearchedTasks, tableColumns, `${selectedReport}_report.csv`);
//     if (reportFile) setEmailAttachments([reportFile]);
//     else setEmailAttachments([]);
//     setEmailTo([]);
//     setEmailCc('');
//     setEmailBcc('');
//     setEmailStatus({ message: '', type: '' });
//     setEmailSending(false);
//     setIsEmailModalOpen(true);
//   }, [dynamicTableTitle, filteredAndSearchedTasks, tableColumns, selectedReport, fetchEmailRecipients]);

//   const handleAddAttachment = useCallback((e) => {
//     if (e.target.files) setEmailAttachments(prev => [...prev, ...Array.from(e.target.files)]);
//   }, []);

//   const handleRemoveAttachment = useCallback((indexToRemove) => {
//     setEmailAttachments(prev => prev.filter((_, index) => index !== indexToRemove));
//   }, []);

//   const handleSendEmail = useCallback(async (e) => {
//     e.preventDefault();
//     if (emailTo.length === 0 || !emailSubject || !emailBody) {
//       setEmailStatus({ message: 'Please select at least one recipient and fill in Subject and Body.', type: 'error' });
//       return;
//     }
//     setEmailSending(true);
//     setEmailStatus({ message: '', type: '' });
//     try {
//       const params = new URLSearchParams();
//       emailTo.forEach(option => params.append('to', option.value));
//       const processEmails = (emailString) => emailString.split(',').map(e => e.trim()).filter(e => e && e.includes('@'));
//       processEmails(emailCc).forEach(email => params.append('cc', email));
//       processEmails(emailBcc).forEach(email => params.append('bcc', email));
//       params.append('subject', emailSubject);
//       params.append('body', emailBody);
//       const attachmentFormData = new FormData();
//       emailAttachments.forEach(file => attachmentFormData.append('attachment', file, file.name));
//       const fullUrl = `${MAIL_API_URL}?${params.toString()}`;
//       const response = await fetch(fullUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: attachmentFormData });
//       if (!response.ok) {
//         let errorMsg;
//         try {
//           const errorResult = await response.json();
//           errorMsg = errorResult.error || errorResult.message || JSON.stringify(errorResult);
//         } catch (jsonError) {
//           const textResponse = await response.text();
//           errorMsg = textResponse || `Request failed with status: ${response.status}`;
//         }
//         throw new Error(errorMsg);
//       }
//       const result = await response.json();
//       setEmailStatus({ message: result.message || 'Email sent successfully!', type: 'success' });
//       setTimeout(() => setIsEmailModalOpen(false), 2000);
//     } catch (error) {
//       console.error('Failed to send email:', error);
//       setEmailStatus({ message: error.message || 'An unexpected error occurred.', type: 'error' });
//     } finally {
//       setEmailSending(false);
//     }
//   }, [emailTo, emailSubject, emailBody, emailCc, emailBcc, emailAttachments]);

//   const handleFirstPage = () => setCurrentPage(1);
//   const handlePreviousPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));
//   const handleNextPage = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));
//   const handleLastPage = () => setCurrentPage(totalPages);
//   const handlePageInputChange = (e) => {
//     const pageNum = Number(e.target.value);
//     if (pageNum >= 1 && pageNum <= totalPages) {
//       setCurrentPage(pageNum);
//     }
//   };

//   const renderCell = useCallback((task, column) => {
//     let value = task[column];
//     if (value === null || value === undefined) return <span className="cell-na">N/A</span>;
//     if (column === 'status') return <span className={`status-badge status-${String(value).toLowerCase()}`}>{value}</span>;
//     if (column === 'priority') return <span className={`priority-badge priority-${String(value).toLowerCase()}`}>{value}</span>;
//     if (['due_date', 'created_at', 'updated_at', 'completed_at', 'Report Date', 'TASK OPEN DT', 'Inv Date'].includes(formatHeader(column))) {
//         const date = new Date(value);
//         return !isNaN(date.getTime()) ? date.toLocaleDateString() : String(value);
//     }
//     if (Array.isArray(value)) {
//       const displayValue = value.filter(item => item != null).join(', ');
//       return displayValue || <span className="cell-na">N/A</span>;
//     }
//     const stringValue = String(value);
//     if (column === 'description' && stringValue.length > 100) {
//       return <span title={stringValue}>{stringValue.substring(0, 100)}...</span>;
//     }
//     return stringValue;
//   }, []);

//   const renderChart = useCallback(() => {
//     if (filteredAndSearchedTasks.length === 0 && selectedReport) {
//       return <p className="status-message">No data matches the current filters.</p>;
//     }
//     if (!selectedReport || !chartData.datasets.length) return null;
//     const chartOptions = {
//       responsive: true,
//       maintainAspectRatio: false,
//       plugins: {
//         legend: { position: 'top' },
//         title: { display: true, text: selectedReport || 'Report', font: { size: 18 } },
//         datalabels: selectedGraphType === 'Pie' ? { formatter: (value) => value, color: '#fff', font: { weight: 'bold', size: 16 } } : { display: false },
//       },
//       ...(selectedGraphType !== 'Pie' && { scales: { y: { beginAtZero: true } } }),
//     };
//     switch (selectedGraphType) {
//       case 'Pie': return <Pie options={chartOptions} data={chartData} />;
//       case 'Line': return <Line options={chartOptions} data={chartData} />;
//       case 'Bar': default: return <Bar options={chartOptions} data={chartData} />;
//     }
//   }, [filteredAndSearchedTasks, selectedReport, chartData, selectedGraphType]);

//   if (error) return <div className="status-message error"> {error}</div>;

//   return (
//     <div className="report-container">
//       <div className="non-printable-header">
//         <h1>Reports</h1>
//         <div className="filters-container">
//           <select
//             className="filter-select report-name-select"
//             value={selectedReport}
//             onChange={e => setSelectedReport(e.target.value)}
//             disabled={!bearerToken || allReports.length === 0}
//           >
//             {allReports.map(report => (
//               <option key={report.id} value={report.report_name}>{report.report_name}</option>
//             ))}
//           </select>
//           {isGraphEnabled && (
//             <select
//               className="filter-select"
//               value={selectedGraphType}
//               onChange={e => setSelectedGraphType(e.target.value)}
//               disabled={!selectedReport}
//             >
//               {GRAPH_TYPES.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//             </select>
//           )}
//           <select className="filter-select" value={selectedUser} onChange={e => setSelectedUser(e.target.value)} disabled={!selectedReport || !filterColumnNames.user}>
//             <option value="">All Users</option>
//             {users.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//           </select>
          
//           {/* == CONDITIONAL DATE FILTERS START == */}
//           {selectedReport === 'Tally export' ? (
//             <>
//               <label htmlFor="from-date" style={{ margin: '0 5px 0 10px' }}>From:</label>
//               <input
//                 id="from-date"
//                 type="date"
//                 className="filter-select"
//                 value={fromDate}
//                 onChange={(e) => setFromDate(e.target.value)}
//               />
//               <label htmlFor="to-date" style={{ margin: '0 5px 0 10px' }}>To:</label>
//               <input
//                 id="to-date"
//                 type="date"
//                 className="filter-select"
//                 value={toDate}
//                 onChange={(e) => setToDate(e.target.value)}
//               />
//             </>
//           ) : (
//             <>
//               <select className="filter-select" value={selectedYear} onChange={e => setSelectedYear(e.target.value)} disabled={!selectedReport || availableYears.length === 0}>
//                 <option value="">All Years</option>
//                 {availableYears.map(opt => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
//               </select>
//               <select className="filter-select" value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} disabled={!selectedReport || availableMonths.length === 0}>
//                 <option value="">All Months</option>
//                 {availableMonths.map(opt => <option key={opt.id} value={opt.id}>{opt.value}</option>)}
//               </select>
//             </>
//           )}
//           {/* == CONDITIONAL DATE FILTERS END == */}

//           <select className="filter-select" value={selectedProject} onChange={e => setSelectedProject(e.target.value)} disabled={!selectedReport || !filterColumnNames.project}>
//             <option value="">All Projects</option>
//             {projects.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//           </select>
//           <select className="filter-select" value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} disabled={!selectedReport || !filterColumnNames.category}>
//             <option value="">All Categories</option>
//             {categories.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//           </select>
//         </div>
//       </div>

//       {loading && <div className="status-message">Loading Report...</div>}
//       {!loading && !selectedReport && allReports.length > 0 && <div className="status-message">Please select a report to view data.</div>}
//       {!loading && allReports.length === 0 && !error && <div className="status-message">No reports available for this module.</div>}

//       <div ref={printableRef} className="printable-content">
//         {!loading && selectedReport && (
//           <>
//             {isGraphEnabled && (
//               <div className="view-toggle-wrapper non-printable">
//                 <button className={`view-toggle-button ${viewMode === 'graph' ? 'active' : ''}`} onClick={() => setViewMode('graph')}>Graph</button>
//                 <button className={`view-toggle-button ${viewMode === 'list' ? 'active' : ''}`} onClick={() => setViewMode('list')}>List</button>
//                 <button className={`view-toggle-button ${viewMode === 'both' ? 'active' : ''}`} onClick={() => setViewMode('both')}>Both</button>
//               </div>
//             )}
//             {isGraphEnabled && (viewMode === 'graph' || viewMode === 'both') && <div className="chart-container">{renderChart()}</div>}
//             {(viewMode === 'list' || viewMode === 'both' || !isGraphEnabled) && (
//               <div className="table-container">
//                 <div className="table-header-controls non-printable">
//                   <input type="text" placeholder="Search across all columns..." className="search-input" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
//                   <div className="export-buttons">
//                     {reportPermissions.canExport && (
//                       <>
//                         <button className="export-button" onClick={() => exportToCSV(filteredAndSearchedTasks, tableColumns, `${dynamicTableTitle.replace(/\s/g, '_')}_filtered.csv`)}>Export Filtered</button>
//                         <button className="export-button" onClick={() => exportToCSV(allTasks, tableColumns, `${selectedReport.replace(/\s/g, '_')}_all.csv`)}>Export All</button>
//                       </>
//                     )}
//                     <button className="export-button" onClick={handleOpenEmailModal}>Email</button>
//                     {reportPermissions.canPrint && <button className="export-button" onClick={handlePrint}>Print</button>}
//                   </div>
//                 </div>
//                 <div className="printable-area">
//                   <h2>{dynamicTableTitle}</h2>
//                   <div className="table-responsive-wrapper">
//                     <table>
//                       <thead>
//                         <tr>
//                           {tableColumns.map(column => <th key={column}>{formatHeader(column)}</th>)}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {paginatedTasks.length > 0 ? (
//                           paginatedTasks.map((task, index) => (
//                             <tr key={task.task_id || `row-${index}`}>
//                               {tableColumns.map(column => (
//                                 <td key={`${task.task_id || index}-${column}`}>{renderCell(task, column)}</td>
//                               ))}
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan={tableColumns.length || 1} className="status-message">No items found for the current selection.</td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                   {filteredAndSearchedTasks.length > 0 && (
//                     <div className="pagination-controls non-printable">
//                       <button onClick={handleFirstPage} disabled={currentPage === 1} className="pagination-button" title="First Page">{'|<'}</button>
//                       <button onClick={handlePreviousPage} disabled={currentPage === 1} className="pagination-button" title="Previous Page">{'<'}</button>
//                       <span className="pagination-info">
//                         <input type="number" value={currentPage} onChange={handlePageInputChange} className="pagination-input" min="1" max={totalPages}/> of {totalPages}
//                       </span>
//                       <button onClick={handleNextPage} disabled={currentPage === totalPages} className="pagination-button" title="Next Page">{'>'}</button>
//                       <button onClick={handleLastPage} disabled={currentPage === totalPages} className="pagination-button" title="Last Page">{'>|'}</button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       {isEmailModalOpen && (
//         <div className="email-modal-overlay">
//           <div className="email-modal-content">
//             <form onSubmit={handleSendEmail}>
//               <div className="email-modal-header">
//                 <h3>Send Report via Email</h3>
//                 <button type="button" className="close-button" onClick={() => setIsEmailModalOpen(false)}>×</button>
//               </div>
//               <div className="email-modal-body">
//                 <div className="form-group">
//                   <label htmlFor="email-to-select">To *</label>
//                   <Select id="email-to-select" isMulti options={emailRecipients} value={emailTo} onChange={(selectedOptions) => setEmailTo(selectedOptions || [])} isLoading={isFetchingRecipients} placeholder="Search or select recipients..." closeMenuOnSelect={false} hideSelectedOptions={false} components={{ Option: CheckboxOption }} className="email-select-container" classNamePrefix="email-select" styles={customSelectStyles} />
//                 </div>
//                 <div className="form-group"><label htmlFor="email-cc">CC</label><input id="email-cc" type="text" value={emailCc} onChange={(e) => setEmailCc(e.target.value)} placeholder="Comma-separated emails" /></div>
//                 <div className="form-group"><label htmlFor="email-bcc">BCC</label><input id="email-bcc" type="text" value={emailBcc} onChange={(e) => setEmailBcc(e.target.value)} placeholder="Comma-separated emails" /></div>
//                 <div className="form-group"><label htmlFor="email-subject">Subject *</label><input id="email-subject" type="text" value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} required /></div>
//                 <div className="form-group">
//                   <label htmlFor="email-body">Body *</label>
//                   <textarea id="email-body" value={emailBody} onChange={(e) => setEmailBody(e.target.value)} rows="5" required />
//                 </div>
//                 <div className="form-group">
//                   <label>Attachments</label>
//                   <div className="attachment-list">
//                     {emailAttachments.map((file, index) => (
//                       <div key={index} className="attachment-item">
//                         <span>{file.name} ({Math.round(file.size / 1024)} KB)</span>
//                         <button type="button" className="remove-attachment-btn" onClick={() => handleRemoveAttachment(index)}>×</button>
//                       </div>
//                     ))}
//                   </div>
//                   <input type="file" ref={fileInputRef} onChange={handleAddAttachment} style={{ display: 'none' }} multiple />
//                 </div>
//                 {emailStatus.message && <div className={`email-status-message ${emailStatus.type}`}>{emailStatus.message}</div>}
//               </div>
//               <div className="email-modal-footer">
//                 <button type="button" className="cancel-btn" onClick={() => setIsEmailModalOpen(false)}>Cancel</button>
//                 <button type="submit" className="send-btn" disabled={emailSending}>{emailSending ? 'Sending...' : 'Send Email'}</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ReportPage; // updated code








import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import Select, { components } from 'react-select';
import {
  getReportModuleFilter,
  getDefaultReportModuleName,
} from '../../config/activeModule';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  LineElement,
  PointElement,
} from 'chart.js';
import { Pie, Bar, Line } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import './Report.css';
import arService from '../../services/arService';
import { getReportsApiBaseUrl } from '../../config/reportsApi';
import '../../shared-ui/crane-tokens.css';
import { EmptyState, Skeleton, PageHeader } from '../../shared-ui/States';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  LineElement,
  PointElement,
  ChartDataLabels
);

// --- Constants from Environment Variables ---
const API_BASE_URL = getReportsApiBaseUrl();
const MAIL_API_URL = process.env.REACT_APP_MAIL_API_URL;
const NODE_SERVICE_BASE_URL = process.env.REACT_APP_NODE_SERVICE_BASE_URL;
const COMMON_MASTER_API_URL = `${NODE_SERVICE_BASE_URL}/api/get-column/common_master`;

// Constant for pagination
const ROWS_PER_PAGE = 10;
const CUSTOMER_LEDGER_REPORT = 'Customer Ledger Statement';

const GRAPH_TYPES = [
  { value: 'Pie', label: 'Pie Chart' },
  { value: 'Bar', label: 'Bar Chart' },
];

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    console.error("Failed to parse JWT:", e);
    return null;
  }
};

const createOptions = (data, key) => {
  if (!data || data.length === 0 || !key) return [];
  const uniqueValues = [...new Set(data.map(item => item[key]).filter(Boolean))];
  return uniqueValues.sort().map(value => ({ value, label: value }));
};

const formatHeader = (header) => {
  if (!header) return '';
  return header
    .replace(/_/g, ' ')
    .replace(/id/g, 'ID')
    .replace(/\b\w/g, char => char.toUpperCase());
};

const findValueColumn = (columns) => {
  const commonValueNames = ['total', 'count', 'sum', 'amount', 'value'];
  return columns.find(col =>
    commonValueNames.some(name => col.toLowerCase().includes(name))
  ) || null;
};

const NON_AMOUNT_COLUMN_PATTERN = /date$|days?\s*(outstanding|overdue)|^total\s*invoices?$|approval\s*time|running\s*balance|payment\s*status|invoice\s*no$|document\s*no$|receipt\s*no$|vch\s*no$|reference\s*no$/i;
const AGEING_BUCKET_COLUMN_PATTERN = /^\d+\s*-\s*\d+\s*days?$/i;
const ABOVE_DAYS_COLUMN_PATTERN = /^above\s+\d+\s*days?$/i;
const AMOUNT_COLUMN_PATTERN = /amount|debit|credit|balance|outstanding|paid|received|hold|tds|net|allocated|adjustment|tax|gst|cgst|sgst|igst|receivable|deduction|unallocated/i;

const isAmountColumn = (column) => {
  const name = String(column || '').trim();
  if (!name || NON_AMOUNT_COLUMN_PATTERN.test(name)) return false;
  if (AGEING_BUCKET_COLUMN_PATTERN.test(name) || ABOVE_DAYS_COLUMN_PATTERN.test(name)) return true;
  if (/\bdue\b/i.test(name) && !/\b(due|balance)\s+(amount|date)\b/i.test(name) && !/amount/i.test(name)) {
    return false;
  }
  return AMOUNT_COLUMN_PATTERN.test(name);
};

const isLedgerSummaryRow = (row) => {
  const rowType = String(row?.row_type || '').toUpperCase();
  const particulars = String(row?.Particulars || row?.particulars || '').toLowerCase();
  return (
    rowType === 'OPENING' ||
    rowType === 'CLOSING' ||
    rowType === 'ON_ACCOUNT' ||
    particulars === 'opening balance' ||
    particulars === 'closing balance' ||
    particulars === 'on account balance'
  );
};

// Rows to exclude from the Debit/Credit column totals. We keep the OPENING row
// in the totals so that (Total Debit - Total Credit) reconciles to the closing
// balance; only the CLOSING and ON_ACCOUNT summary rows are excluded.
const isLedgerTotalExcludedRow = (row) => {
  const rowType = String(row?.row_type || '').toUpperCase();
  const particulars = String(row?.Particulars || row?.particulars || '').toLowerCase();
  return (
    rowType === 'CLOSING' ||
    rowType === 'ON_ACCOUNT' ||
    particulars === 'closing balance' ||
    particulars === 'on account balance'
  );
};

const parseReportNumber = (value) => {
  if (value === null || value === undefined || value === '') return 0;
  const cleaned = String(value).replace(/,/g, '').trim();
  const parsed = parseFloat(cleaned);
  return Number.isFinite(parsed) ? parsed : 0;
};

const formatReportTotal = (value) =>
  value.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const computeColumnTotals = (rows, columns, { skipSummaryRows = false } = {}) => {
  const totals = {};
  columns.forEach((column) => {
    if (!isAmountColumn(column)) return;
    totals[column] = rows.reduce((sum, row) => {
      if (skipSummaryRows && isLedgerTotalExcludedRow(row)) return sum;
      return sum + parseReportNumber(row[column]);
    }, 0);
  });
  return totals;
};

const generateDynamicColors = (numColors) => {
  const colors = [];
  for (let i = 0; i < numColors; i++) {
    const hue = (i * 137.508) % 360;
    colors.push(`hsla(${hue}, 70%, 60%, 0.8)`);
  }
  return colors;
};

const exportToCSV = (tasks, columns, filename) => {
  if (!tasks || tasks.length === 0 || !columns || columns.length === 0) {
    alert("No data available to export.");
    return;
  }

  const headers = columns.map(formatHeader);
  const csvRows = [
    headers.join(','),
    ...tasks.map(task =>
      columns.map(column => {
        let cellData = task[column];
        if (cellData === null || cellData === undefined) return '""';
        if (Array.isArray(cellData)) {
          cellData = cellData.filter(item => item).join('; ');
        }
        const stringData = String(cellData).replace(/"/g, '""');
        return `"${stringData}"`;
      }).join(',')
    )
  ];

  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const generateCSVFile = (tasks, columns, filename) => {
  if (!tasks || tasks.length === 0 || !columns || columns.length === 0) {
    return null;
  }

  const headers = columns.map(formatHeader);
  const csvRows = [
    headers.join(','),
    ...tasks.map(task =>
      columns.map(column => {
        let cellData = task[column];
        if (cellData === null || cellData === undefined) return '""';
        if (Array.isArray(cellData)) {
          cellData = cellData.filter(item => item).join('; ');
        }
        const stringData = String(cellData).replace(/"/g, '""');
        return `"${stringData}"`;
      }).join(',')
    )
  ];

  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  return new File([blob], filename, { type: 'text/csv;charset=utf-8;' });
};


const CheckboxOption = (props) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ marginRight: '10px' }}
      />
      <label>{props.label}</label>
    </components.Option>
  );
};

const getDefaultFyDates = () => {
  const now = new Date();
  const fyStartYear = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
  return {
    from: `${fyStartYear}-04-01`,
    to: now.toISOString().split('T')[0],
  };
};

// Helper function to safely parse dates (handles "DD/MM/YYYY" format specifically)
const parseDateValue = (value) => {
    if (!value) return null;
    
    if (typeof value === 'string' && /^\d{1,2}-[A-Za-z]{3}-\d{2}$/.test(value)) {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const [dayStr, monStr, yrStr] = value.split('-');
    const monthIdx = monthNames.findIndex((m) => m.toLowerCase() === monStr.toLowerCase());
    if (monthIdx >= 0) {
      const year = 2000 + parseInt(yrStr, 10);
      return new Date(year, monthIdx, parseInt(dayStr, 10));
    }
  }

  // Check if format is DD/MM/YYYY
    if (typeof value === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
        const [day, month, year] = value.split('/').map(Number);
        return new Date(year, month - 1, day);
    }

    // Fallback to standard Date parsing
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
};


const ReportPage = () => {
  const [authToken, setAuthToken] = useState(null);
  const bearerToken = useMemo(() => authToken ? `Bearer ${authToken}` : null, [authToken]);

  const [allReports, setAllReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState('');
  const [allTasks, setAllTasks] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [viewMode, setViewMode] = useState('list');
  const [reportPermissions, setReportPermissions] = useState({ canPrint: false, canExport: false });

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);

  // Filter States
  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedGraphType, setSelectedGraphType] = useState('Pie');
  const [selectedUser, setSelectedUser] = useState('');
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');

  const [years, setYears] = useState([]);
  const [months, setMonths] = useState([]);
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');

  // State for Tally export date range filter
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  // Customer Ledger Statement filters
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState('');
  const [ledgerMeta, setLedgerMeta] = useState(null);

  const isCustomerLedgerReport = selectedReport === CUSTOMER_LEDGER_REPORT;

  const [availableYears, setAvailableYears] = useState([]);
  const [availableMonths, setAvailableMonths] = useState([]);

  const [filterColumnNames, setFilterColumnNames] = useState({ user: null, project: null, category: null, date: null });

  // Email Modal State
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [emailTo, setEmailTo] = useState([]);
  const [emailCc, setEmailCc] = useState('');
  const [emailBcc, setEmailBcc] = useState('');
  const [emailSubject, setEmailSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [emailAttachments, setEmailAttachments] = useState([]);
  const [emailSending, setEmailSending] = useState(false);
  const [emailStatus, setEmailStatus] = useState({ message: '', type: '' });
  const [emailRecipients, setEmailRecipients] = useState([]);
  const [isFetchingRecipients, setIsFetchingRecipients] = useState(false);

  const printableRef = useRef();
  const fileInputRef = useRef(null);
  const customSelectStyles = {
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  const currentUserId = useMemo(() => {
    if (!authToken) return null;
    const parsedToken = parseJwt(authToken);
    return parsedToken?.claims?.user_ID;
  }, [authToken]);

  const currentReportObject = useMemo(() =>
    allReports.find(report => report.report_name === selectedReport),
    [allReports, selectedReport]
  );

  const isGraphEnabled = useMemo(() =>
    currentReportObject?.graph === 'yes',
    [currentReportObject]
  );

  const fetchMonths = useCallback(async () => {
    if (!bearerToken) return;
    try {
      const response = await fetch(`${COMMON_MASTER_API_URL}/month_name`, {
        headers: { accept: 'application/json', Authorization: bearerToken },
      });
      if (response.ok) {
        const monthData = await response.json();
        const sortedMonths = monthData.sort((a, b) => a.id - b.id);
        setMonths(sortedMonths);
      } else {
        throw new Error(`Failed to fetch months: ${response.status}`);
      }
    } catch (error) {
      console.error('fetchMonths error:', error);
      setMonths([]);
    }
  }, [bearerToken]);

  const fetchYears = useCallback(async () => {
    if (!bearerToken) return;
    try {
      const [fromResponse, toResponse] = await Promise.all([
        fetch(`${COMMON_MASTER_API_URL}/from_date`, { headers: { accept: 'application/json', Authorization: bearerToken } }),
        fetch(`${COMMON_MASTER_API_URL}/to_date`, { headers: { accept: 'application/json', Authorization: bearerToken } }),
      ]);

      if (!fromResponse.ok || !toResponse.ok) throw new Error('Failed to fetch financial years');

      const fromData = await fromResponse.json();
      const toData = await toResponse.json();

      const yearOptions = fromData.map((from) => {
        const to = toData.find((t) => t.id === from.id);
        const fromYear = new Date(from.value).getFullYear();
        const toYear = new Date(to.value).getFullYear();
        return {
          id: from.id,
          label: `${fromYear}-${toYear.toString().slice(-2)}`,
          from_date: from.value,
          to_date: to.value,
        };
      }).sort((a, b) => b.id - a.id);

      setYears(yearOptions);
    } catch (error) {
      console.error('fetchYears error:', error);
      setYears([]);
    }
  }, [bearerToken]);

  const fetchReportList = useCallback(async () => {
    if (!bearerToken) return;
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/reports`, {
        method: 'GET',
        headers: { 'Accept': 'application/json', 'Authorization': bearerToken },
      });

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      const result = await response.json();
      const allFetchedReports = result || [];
      const reports = allFetchedReports
        .filter((report) => {
          const moduleName = (report.module_name || '').toLowerCase();
          const allowed = getReportModuleFilter();
          return allowed.includes(moduleName);
        })
        .filter((report) => report.active === 'yes')
        .sort((a, b) => (a.report_name || '').localeCompare(b.report_name || ''));
      
      setAllReports(reports);

      if (reports.length > 0) {
        setSelectedReport(reports[0].report_name);
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.error("Failed to fetch report list:", err);
      setError("Could not load report options.");
      setLoading(false);
    }
  }, [bearerToken]);

  const fetchReportData = useCallback(async (reportName, options = {}) => {
    if (!reportName || !bearerToken) {
      setAllTasks([]);
      setTableColumns([]);
      setReportPermissions({ canPrint: false, canExport: false });
      setLedgerMeta(null);
      if (allReports.length > 0) setLoading(false);
      return;
    }

    const isLedger = reportName === CUSTOMER_LEDGER_REPORT;
    const customerId = options.customer_id ?? selectedCustomerId;
    const ledgerFrom = options.from_date ?? fromDate;
    const ledgerTo = options.to_date ?? toDate;

    if (isLedger && (!ledgerFrom || !ledgerTo)) {
      setAllTasks([]);
      setTableColumns([]);
      setLedgerMeta(null);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    setSelectedUser('');
    setSelectedYear('');
    setSelectedMonth('');
    setSelectedProject('');
    setSelectedCategory('');
    setSearchTerm('');
    if (!isLedger) {
      setFromDate('');
      setToDate('');
      setLedgerMeta(null);
    }

    try {
      const selectedReportMeta = allReports.find(
        (report) => report.report_name === reportName
      );
      const requestBody = {
        report_name: reportName,
        module_name: selectedReportMeta?.module_name || getDefaultReportModuleName(),
      };
      if (isLedger) {
        const parsedCustomerId = parseInt(customerId, 10);
        if (!Number.isNaN(parsedCustomerId)) {
          requestBody.customer_id = parsedCustomerId;
        }
        requestBody.from_date = ledgerFrom;
        requestBody.to_date = ledgerTo;
      }

      const response = await fetch(`${API_BASE_URL}/api/reports/run`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': bearerToken },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        if (response.status === 403) {
          throw new Error("It seems that, there are no reports assigned to you");
        }
        let errorMessage = `HTTP error! Status: ${response.status}`;
        try {
          const errorBody = await response.json();
          if (errorBody?.message) errorMessage = errorBody.message;
        } catch {
          // ignore JSON parse errors
        }
        throw new Error(errorMessage);
      }

      const result = await response.json();
      const data = result.data || [];
      const columns = (result.columns || []).filter((c) => c !== 'row_type' && c !== 'customer_id');

      setTableColumns(columns);
      setAllTasks(data);
      setLedgerMeta(isLedger ? (result.meta || null) : null);

      const findColumn = (possibleNames) => columns.find(c => possibleNames.includes(c.toLowerCase()));

      const newFilterColumns = {
        user: findColumn(['assignee_name', 'user_name', 'user', 'assignee', 'task assignee', 'entered by']),
        project: findColumn(['project_name', 'project']),
        category: findColumn(['category', 'task_category']),
        date: findColumn(['date', 'due_date', 'report date', 'report_date', 'created_at', 'task open dt', 'transaction date'])
      };

      setFilterColumnNames(newFilterColumns);
      setUsers(createOptions(data, newFilterColumns.user));
      setProjects(createOptions(data, newFilterColumns.project));
      setCategories(createOptions(data, newFilterColumns.category));

    } catch (err) {
      console.error("Failed to fetch report data:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [allReports, bearerToken, selectedCustomerId, fromDate, toDate]);

  const fetchEmailRecipients = useCallback(async () => {
    if (!bearerToken) return;
    setIsFetchingRecipients(true);
    setEmailStatus({ message: '', type: '' });

    try {
      const response = await fetch(`${API_BASE_URL}/api/reports/get-columns`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': bearerToken },
        body: JSON.stringify({ table_name: "users", column_names: ["email"] }),
      });

      if (!response.ok) throw new Error(`Failed to fetch email recipients. Status: ${response.status}`);

      const result = await response.json();
      if (result.data && Array.isArray(result.data)) {
        const formattedRecipients = result.data
          .map(user => ({ value: user.email, label: user.email }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setEmailRecipients(formattedRecipients);
      } else {
        throw new Error("Invalid data format for email recipients.");
      }
    } catch (err) {
      console.error(err);
      setEmailStatus({ message: 'Could not load email recipients.', type: 'error' });
      setEmailRecipients([]);
    } finally {
      setIsFetchingRecipients(false);
    }
  }, [bearerToken]);

  useEffect(() => {
    const token = localStorage.getItem('zTaskAuthToken');
    if (token) {
      setAuthToken(token);
    } else {
      console.error("Authentication token not found in local storage.");
      setError("You are not authenticated. Please log in.");
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (bearerToken) {
      fetchReportList();
      fetchMonths();
      fetchYears();
      arService.getCustomers()
        .then((data) => {
          const list = Array.isArray(data) ? data : (data?.customers || data?.data || []);
          setCustomers(
            list
              .map((c) => ({ value: String(c.id), label: c.name || c.customer_name || `Customer #${c.id}` }))
              .sort((a, b) => a.label.localeCompare(b.label))
          );
        })
        .catch((err) => console.error('Failed to load customers for ledger report:', err));
    }
  }, [bearerToken, fetchReportList, fetchMonths, fetchYears]);

  const handleReportChange = useCallback((e) => {
    const name = e.target.value;
    setSelectedReport(name);
    setAllTasks([]);
    setTableColumns([]);
    setLedgerMeta(null);
    setError(null);
    if (name === CUSTOMER_LEDGER_REPORT) {
      const { from, to } = getDefaultFyDates();
      setFromDate(from);
      setToDate(to);
      setSelectedCustomerId('');
      fetchReportData(CUSTOMER_LEDGER_REPORT, { from_date: from, to_date: to });
    } else {
      setFromDate('');
      setToDate('');
      setSelectedCustomerId('');
    }
  }, [fetchReportData]);

  const handleGenerateCustomerLedger = useCallback((customerIdOverride) => {
    if (!fromDate || !toDate) {
      setError('Please select from and to dates.');
      return;
    }
    const resolvedCustomerId =
      typeof customerIdOverride === 'string' || typeof customerIdOverride === 'number'
        ? String(customerIdOverride)
        : selectedCustomerId;
    const options = { from_date: fromDate, to_date: toDate };
    if (resolvedCustomerId) {
      options.customer_id = resolvedCustomerId;
    }
    fetchReportData(CUSTOMER_LEDGER_REPORT, options);
  }, [selectedCustomerId, fromDate, toDate, fetchReportData]);

  const handleCustomerLedgerCustomerChange = useCallback((e) => {
    const nextCustomerId = e.target.value;
    setSelectedCustomerId(nextCustomerId);
    if (fromDate && toDate) {
      handleGenerateCustomerLedger(nextCustomerId);
    }
  }, [fromDate, toDate, handleGenerateCustomerLedger]);

  useEffect(() => {
    if (selectedReport && bearerToken && selectedReport !== CUSTOMER_LEDGER_REPORT) {
        fetchReportData(selectedReport);
    } else if (selectedReport === CUSTOMER_LEDGER_REPORT) {
      setLoading(false);
    }

    if (currentReportObject) {
      setViewMode(isGraphEnabled ? 'both' : 'list');
      if (currentUserId) {
        const canPrint = currentReportObject.print?.includes(currentUserId) ?? false;
        const canExport = currentReportObject.export?.includes(currentUserId) ?? false;
        setReportPermissions({ canPrint, canExport });
      } else {
        setReportPermissions({ canPrint: false, canExport: false });
      }
    }
  }, [selectedReport, bearerToken, fetchReportData, currentReportObject, isGraphEnabled, currentUserId]);

  useEffect(() => {
    if (!allTasks.length || !filterColumnNames.date || !months.length || !years.length) {
      setAvailableMonths([]);
      setAvailableYears([]);
      return;
    }
    const dateCol = filterColumnNames.date;
    const presentMonthIds = new Set();
    const presentYearIds = new Set();
    allTasks.forEach(task => {
      const taskDate = parseDateValue(task[dateCol]);
      if (!taskDate) return;
      const monthId = (taskDate.getMonth() + 1).toString();
      presentMonthIds.add(monthId);
      for (const yearOption of years) {
        const fromDate = new Date(yearOption.from_date);
        const toDate = new Date(yearOption.to_date);
        toDate.setHours(23, 59, 59, 999);
        if (taskDate >= fromDate && taskDate <= toDate) {
          presentYearIds.add(yearOption.id);
          break;
        }
      }
    });
    const filteredMonths = months
      .filter(month => presentMonthIds.has(month.id.toString()))
      .sort((a, b) => a.id - b.id);
    const filteredYears = years
      .filter(year => presentYearIds.has(year.id))
      .sort((a, b) => b.id - a.id);
    setAvailableMonths(filteredMonths);
    setAvailableYears(filteredYears);
  }, [allTasks, filterColumnNames.date, months, years]);

  // Effect to reset current page to 1 when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedUser, selectedProject, selectedCategory, selectedYear, selectedMonth, searchTerm, selectedReport, fromDate, toDate]);

  const filteredAndSearchedTasks = useMemo(() => {
    let tempTasks = [...allTasks];
    const { user, project, category, date } = filterColumnNames;

    if (!isCustomerLedgerReport) {
      if (selectedUser && user) tempTasks = tempTasks.filter(t => t[user] === selectedUser);
      if (selectedProject && project) tempTasks = tempTasks.filter(t => t[project] === selectedProject);
      if (selectedCategory && category) tempTasks = tempTasks.filter(t => t[category] === selectedCategory);
    }

    // Date filtering logic
    if (selectedReport === 'Tally export' && fromDate && toDate) {
      
      const dateColKey = tableColumns.find(col => {
        const cleanName = col.toLowerCase().replace(/_/g, ' ');
        return cleanName === 'bill date' || cleanName === 'inv date';
      });

      if (dateColKey) {
        const start = new Date(fromDate);
        start.setHours(0, 0, 0, 0); 
        const end = new Date(toDate);
        end.setHours(23, 59, 59, 999); 

        tempTasks = tempTasks.filter(t => {
          // Use the custom parser here to handle DD/MM/YYYY
          const taskDate = parseDateValue(t[dateColKey]);
          if (!taskDate) return false;
          return taskDate >= start && taskDate <= end;
        });
      }
    } else if (date && !isCustomerLedgerReport) { // General date filtering for other reports
      if (selectedYear) {
        const selectedYearData = years.find(y => y.id.toString() === selectedYear);
        if (selectedYearData) {
          const yearFromDate = new Date(selectedYearData.from_date);
          const yearToDate = new Date(selectedYearData.to_date);
          tempTasks = tempTasks.filter(t => {
            const taskDate = parseDateValue(t[date]);
            return taskDate && taskDate >= yearFromDate && taskDate <= yearToDate;
          });
        }
      }
      if (selectedMonth) {
        tempTasks = tempTasks.filter(t => {
            const taskDate = parseDateValue(t[date]);
            return taskDate && (taskDate.getMonth() + 1).toString() === selectedMonth;
        });
      }
    }

    if (searchTerm.trim() !== '') {
      const lowercasedTerm = searchTerm.toLowerCase();
      tempTasks = tempTasks.filter(task =>
        tableColumns.some(col => String(task[col]).toLowerCase().includes(lowercasedTerm))
      );
    }

    if (isCustomerLedgerReport && selectedCustomerId && ledgerMeta?.all_customers) {
      const selectedCustomer = customers.find((c) => c.value === String(selectedCustomerId));
      tempTasks = tempTasks.filter((task) => {
        if (task.customer_id != null && task.customer_id !== '') {
          return String(task.customer_id) === String(selectedCustomerId);
        }
        if (selectedCustomer?.label && task.Customer) {
          return task.Customer === selectedCustomer.label;
        }
        return false;
      });
    }

    return tempTasks;
  }, [allTasks, tableColumns, selectedUser, selectedProject, selectedCategory, searchTerm, filterColumnNames, selectedYear, selectedMonth, years, selectedReport, fromDate, toDate, isCustomerLedgerReport, selectedCustomerId, ledgerMeta, customers]);

  const columnTotals = useMemo(
    () => computeColumnTotals(filteredAndSearchedTasks, tableColumns, {
      skipSummaryRows: isCustomerLedgerReport,
    }),
    [filteredAndSearchedTasks, tableColumns, isCustomerLedgerReport]
  );

  const hasColumnTotals = useMemo(
    () => Object.values(columnTotals).some((value) => Math.abs(value) > 0.001),
    [columnTotals]
  );

  const totalLabelColumnIndex = useMemo(
    () => tableColumns.findIndex((column) => !isAmountColumn(column)),
    [tableColumns]
  );

  const { totalPages, paginatedTasks } = useMemo(() => {
    const rowsPerPage = isCustomerLedgerReport ? Math.max(filteredAndSearchedTasks.length, 1) : ROWS_PER_PAGE;
    const total = Math.ceil(filteredAndSearchedTasks.length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const paginated = filteredAndSearchedTasks.slice(startIndex, startIndex + rowsPerPage);
    return {
      totalPages: total > 0 ? total : 1,
      paginatedTasks: paginated,
    };
  }, [filteredAndSearchedTasks, currentPage, isCustomerLedgerReport]);

  const dynamicTableTitle = useMemo(() => {
    const activeFilters = [selectedReport];
    if (selectedUser) activeFilters.push(selectedUser);
    if (selectedProject) activeFilters.push(selectedProject);
    if (selectedCategory) activeFilters.push(selectedCategory);

    if (selectedReport === 'Tally export' || isCustomerLedgerReport) {
        if(fromDate) activeFilters.push(`From: ${fromDate}`);
        if(toDate) activeFilters.push(`To: ${toDate}`);
        if (isCustomerLedgerReport && ledgerMeta?.customer_name) {
          activeFilters.push(ledgerMeta.customer_name);
        } else if (isCustomerLedgerReport && selectedCustomerId) {
          const cust = customers.find((c) => c.value === selectedCustomerId);
          if (cust) activeFilters.push(cust.label);
        } else if (isCustomerLedgerReport && ledgerMeta?.all_customers) {
          activeFilters.push('All Customers');
        }
    } else {
        if (selectedYear) {
            const yearLabel = years.find(y => y.id.toString() === selectedYear)?.label;
            if (yearLabel) activeFilters.push(`Year: ${yearLabel}`);
        }
        if (selectedMonth) {
            const monthLabel = months.find(m => m.id.toString() === selectedMonth)?.value;
            if (monthLabel) activeFilters.push(monthLabel);
        }
    }
    return activeFilters.length > 1 ? activeFilters.join(' - ') : selectedReport;
  }, [selectedUser, selectedProject, selectedCategory, selectedYear, selectedMonth, selectedReport, years, months, fromDate, toDate, isCustomerLedgerReport, ledgerMeta, selectedCustomerId, customers]);

  const chartData = useMemo(() => {
    const dataToChart = filteredAndSearchedTasks;
    if (!dataToChart || dataToChart.length === 0 || tableColumns.length === 0) {
      return { labels: [], datasets: [] };
    }
    const valueColumn = findValueColumn(tableColumns);
    if (valueColumn) {
      const labelColumns = tableColumns.filter(c => c !== valueColumn);
      if (labelColumns.length >= 2) {
        const primaryLabelCol = labelColumns[0];
        const seriesCol = labelColumns[1];
        const labels = [...new Set(dataToChart.map(item => item[primaryLabelCol]))].sort();
        const seriesNames = [...new Set(dataToChart.map(item => item[seriesCol]))].sort();
        const colors = generateDynamicColors(seriesNames.length);
        const datasets = seriesNames.map((seriesName, index) => ({
          label: seriesName,
          data: labels.map(label => {
            const dataPoint = dataToChart.find(item => item[primaryLabelCol] === label && item[seriesCol] === seriesName);
            return dataPoint ? parseFloat(dataPoint[valueColumn]) || 0 : 0;
          }),
          backgroundColor: colors[index],
          borderColor: colors[index].replace('0.8', '1'),
          borderWidth: 1,
        }));
        return { labels, datasets };
      }
      if (labelColumns.length === 1) {
        const labelCol = labelColumns[0];
        const labels = dataToChart.map(item => item[labelCol]);
        const data = dataToChart.map(item => parseFloat(item[valueColumn]) || 0);
        return {
          labels,
          datasets: [{ label: formatHeader(valueColumn), data, backgroundColor: generateDynamicColors(labels.length), borderColor: '#fff', borderWidth: 1 }],
        };
      }
    }
    const statusCounts = dataToChart.reduce((acc, task) => {
      const status = task.status || 'Unknown';
      acc[status] = (acc[status] || 0) + 1;
      return acc;
    }, {});
    const labels = Object.keys(statusCounts);
    const data = Object.values(statusCounts);
    return {
      labels,
      datasets: [{ label: 'Number of Items', data, backgroundColor: generateDynamicColors(labels.length), borderColor: '#fff', borderWidth: 1 }],
    };
  }, [filteredAndSearchedTasks, tableColumns]);

  const handlePrint = useCallback(() => window.print(), []);

  const handleOpenEmailModal = useCallback(() => {
    fetchEmailRecipients();
    setEmailSubject(dynamicTableTitle);
    setEmailBody(``);
    const reportFile = generateCSVFile(filteredAndSearchedTasks, tableColumns, `${selectedReport}_report.csv`);
    if (reportFile) setEmailAttachments([reportFile]);
    else setEmailAttachments([]);
    setEmailTo([]);
    setEmailCc('');
    setEmailBcc('');
    setEmailStatus({ message: '', type: '' });
    setEmailSending(false);
    setIsEmailModalOpen(true);
  }, [dynamicTableTitle, filteredAndSearchedTasks, tableColumns, selectedReport, fetchEmailRecipients]);

  const handleAddAttachment = useCallback((e) => {
    if (e.target.files) setEmailAttachments(prev => [...prev, ...Array.from(e.target.files)]);
  }, []);

  const handleRemoveAttachment = useCallback((indexToRemove) => {
    setEmailAttachments(prev => prev.filter((_, index) => index !== indexToRemove));
  }, []);

  const handleSendEmail = useCallback(async (e) => {
    e.preventDefault();
    if (emailTo.length === 0 || !emailSubject || !emailBody) {
      setEmailStatus({ message: 'Please select at least one recipient and fill in Subject and Body.', type: 'error' });
      return;
    }
    setEmailSending(true);
    setEmailStatus({ message: '', type: '' });
    try {
      const params = new URLSearchParams();
      emailTo.forEach(option => params.append('to', option.value));
      const processEmails = (emailString) => emailString.split(',').map(e => e.trim()).filter(e => e && e.includes('@'));
      processEmails(emailCc).forEach(email => params.append('cc', email));
      processEmails(emailBcc).forEach(email => params.append('bcc', email));
      params.append('subject', emailSubject);
      params.append('body', emailBody);
      const attachmentFormData = new FormData();
      emailAttachments.forEach(file => attachmentFormData.append('attachment', file, file.name));
      const fullUrl = `${MAIL_API_URL}?${params.toString()}`;
      const response = await fetch(fullUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: attachmentFormData });
      if (!response.ok) {
        let errorMsg;
        try {
          const errorResult = await response.json();
          errorMsg = errorResult.error || errorResult.message || JSON.stringify(errorResult);
        } catch (jsonError) {
          const textResponse = await response.text();
          errorMsg = textResponse || `Request failed with status: ${response.status}`;
        }
        throw new Error(errorMsg);
      }
      const result = await response.json();
      setEmailStatus({ message: result.message || 'Email sent successfully!', type: 'success' });
      setTimeout(() => setIsEmailModalOpen(false), 2000);
    } catch (error) {
      console.error('Failed to send email:', error);
      setEmailStatus({ message: error.message || 'An unexpected error occurred.', type: 'error' });
    } finally {
      setEmailSending(false);
    }
  }, [emailTo, emailSubject, emailBody, emailCc, emailBcc, emailAttachments]);

  const handleFirstPage = () => setCurrentPage(1);
  const handlePreviousPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));
  const handleNextPage = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));
  const handleLastPage = () => setCurrentPage(totalPages);
  const handlePageInputChange = (e) => {
    const pageNum = Number(e.target.value);
    if (pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  };

  const renderCell = useCallback((task, column) => {
    let value = task[column];
    if (value === null || value === undefined || value === '') return '';
    if (column === 'status') return <span className={`status-badge status-${String(value).toLowerCase()}`}>{value}</span>;
    if (column === 'priority') return <span className={`priority-badge priority-${String(value).toLowerCase()}`}>{value}</span>;
    if (column === 'Reference Details') {
      return (
        <div style={{ whiteSpace: 'pre-line', fontSize: '0.85em', maxWidth: '420px' }}>
          {String(value)}
        </div>
      );
    }
    
    // UPDATED RENDER LOGIC: Using custom parser for display as well if needed, 
    // though usually string display is fine. For sorting/filtering ensuring date obj is key.
    if (['due_date', 'created_at', 'updated_at', 'completed_at', 'Report Date', 'TASK OPEN DT', 'Inv Date', 'Bill Date', 'Date'].includes(formatHeader(column)) || column === 'Date') {
         // Attempt to parse to see if it is a valid date for formatting, otherwise return string
        const date = parseDateValue(value);
        return date ? date.toLocaleDateString() : String(value);
    }
    if (Array.isArray(value)) {
      const displayValue = value.filter(item => item != null).join(', ');
      return displayValue || <span className="cell-na">N/A</span>;
    }
    const stringValue = String(value);
    if (column === 'description' && stringValue.length > 100) {
      return <span title={stringValue}>{stringValue.substring(0, 100)}...</span>;
    }
    return stringValue;
  }, []);

  const renderChart = useCallback(() => {
    if (filteredAndSearchedTasks.length === 0 && selectedReport) {
      return <p className="status-message">No data matches the current filters.</p>;
    }
    if (!selectedReport || !chartData.datasets.length) return null;
    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { position: 'top' },
        title: { display: true, text: selectedReport || 'Report', font: { size: 18 } },
        datalabels: selectedGraphType === 'Pie' ? { formatter: (value) => value, color: '#fff', font: { weight: 'bold', size: 16 } } : { display: false },
      },
      ...(selectedGraphType !== 'Pie' && { scales: { y: { beginAtZero: true } } }),
    };
    switch (selectedGraphType) {
      case 'Pie': return <Pie options={chartOptions} data={chartData} />;
      case 'Line': return <Line options={chartOptions} data={chartData} />;
      case 'Bar': default: return <Bar options={chartOptions} data={chartData} />;
    }
  }, [filteredAndSearchedTasks, selectedReport, chartData, selectedGraphType]);

  if (error && !isCustomerLedgerReport) {
    return (
      <div className="crane-page report-container">
        <PageHeader
          crumbs={['Operations', 'Reports', 'Executive Reports']}
          title="Executive reports"
        />
        <div className="status-message error">{error}</div>
      </div>
    );
  }

  return (
    <div className="crane-page report-container">
      <PageHeader
        crumbs={['Operations', 'Reports', 'Executive Reports']}
        title="Executive reports"
        description="Run configured reports from live APIs."
      />
      {error && isCustomerLedgerReport && <div className="status-message error">{error}</div>}
      <div className="non-printable-header">
        <div className="filters-container">
          <select
            className="filter-select report-name-select"
            value={selectedReport}
            onChange={handleReportChange}
            disabled={!bearerToken || allReports.length === 0}
          >
            {allReports.map(report => (
              <option key={report.id} value={report.report_name}>{report.report_name}</option>
            ))}
          </select>
          {isGraphEnabled && (
            <select
              className="filter-select"
              value={selectedGraphType}
              onChange={e => setSelectedGraphType(e.target.value)}
              disabled={!selectedReport}
            >
              {GRAPH_TYPES.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
            </select>
          )}
          {!isCustomerLedgerReport && (
            <select className="filter-select" value={selectedUser} onChange={e => setSelectedUser(e.target.value)} disabled={!selectedReport || !filterColumnNames.user}>
              <option value="">All Users</option>
              {users.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
            </select>
          )}
          
          {/* == CONDITIONAL DATE FILTERS START == */}
          {isCustomerLedgerReport ? (
            <>
              <select
                className="filter-select"
                value={selectedCustomerId}
                onChange={handleCustomerLedgerCustomerChange}
                disabled={!selectedReport || loading}
              >
                <option value="">All Customers</option>
                {customers.map((opt) => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
              <label htmlFor="ledger-from-date" style={{ margin: '0 5px 0 10px' }}>From:</label>
              <input
                id="ledger-from-date"
                type="date"
                className="filter-select"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
              <label htmlFor="ledger-to-date" style={{ margin: '0 5px 0 10px' }}>To:</label>
              <input
                id="ledger-to-date"
                type="date"
                className="filter-select"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
              <button
                type="button"
                className="export-button"
                onClick={() => handleGenerateCustomerLedger()}
                disabled={!fromDate || !toDate || loading}
              >
                Generate Ledger
              </button>
            </>
          ) : selectedReport === 'Tally export' ? (
            <>
              <label htmlFor="from-date" style={{ margin: '0 5px 0 10px' }}>From:</label>
              <input
                id="from-date"
                type="date"
                className="filter-select"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
              <label htmlFor="to-date" style={{ margin: '0 5px 0 10px' }}>To:</label>
              <input
                id="to-date"
                type="date"
                className="filter-select"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </>
          ) : (
            <>
              <select className="filter-select" value={selectedYear} onChange={e => setSelectedYear(e.target.value)} disabled={!selectedReport || availableYears.length === 0}>
                <option value="">All Years</option>
                {availableYears.map(opt => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
              </select>
              <select className="filter-select" value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} disabled={!selectedReport || availableMonths.length === 0}>
                <option value="">All Months</option>
                {availableMonths.map(opt => <option key={opt.id} value={opt.id}>{opt.value}</option>)}
              </select>
            </>
          )}
          {/* == CONDITIONAL DATE FILTERS END == */}

          {!isCustomerLedgerReport && (
            <>
              <select className="filter-select" value={selectedProject} onChange={e => setSelectedProject(e.target.value)} disabled={!selectedReport || !filterColumnNames.project}>
                <option value="">All Projects</option>
                {projects.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
              </select>
              <select className="filter-select" value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} disabled={!selectedReport || !filterColumnNames.category}>
                <option value="">All Categories</option>
                {categories.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
              </select>
            </>
          )}
        </div>
      </div>

      {loading && <Skeleton rows={5} height={32} />}
      {!loading && !selectedReport && allReports.length > 0 && <div className="status-message">Please select a report to view data.</div>}
      {!loading && isCustomerLedgerReport && allTasks.length === 0 && !error && (
        <div className="status-message">Set a date range and click Generate Ledger to load all customers. Use the customer filter to narrow results.</div>
      )}
      {!loading && allReports.length === 0 && !error && (
        <EmptyState title="No reports configured" description="No reports are available for this module in the database." />
      )}

      <div ref={printableRef} className="printable-content">
        {!loading && selectedReport && (
          <>
            {isGraphEnabled && (
              <div className="view-toggle-wrapper non-printable">
                <button className={`view-toggle-button ${viewMode === 'graph' ? 'active' : ''}`} onClick={() => setViewMode('graph')}>Graph</button>
                <button className={`view-toggle-button ${viewMode === 'list' ? 'active' : ''}`} onClick={() => setViewMode('list')}>List</button>
                <button className={`view-toggle-button ${viewMode === 'both' ? 'active' : ''}`} onClick={() => setViewMode('both')}>Both</button>
              </div>
            )}
            {isGraphEnabled && (viewMode === 'graph' || viewMode === 'both') && <div className="chart-container">{renderChart()}</div>}
            {(viewMode === 'list' || viewMode === 'both' || !isGraphEnabled) && (
              <div className="table-container">
                <div className="table-header-controls non-printable">
                  <input type="text" placeholder="Search across all columns..." className="search-input" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                  <div className="export-buttons">
                    {reportPermissions.canExport && (
                      <>
                        <button className="export-button" onClick={() => exportToCSV(filteredAndSearchedTasks, tableColumns, `${dynamicTableTitle.replace(/\s/g, '_')}_filtered.csv`)}>Export Filtered</button>
                        <button className="export-button" onClick={() => exportToCSV(allTasks, tableColumns, `${selectedReport.replace(/\s/g, '_')}_all.csv`)}>Export All</button>
                      </>
                    )}
                    <button className="export-button" onClick={handleOpenEmailModal}>Email</button>
                    {reportPermissions.canPrint && <button className="export-button" onClick={handlePrint}>Print</button>}
                  </div>
                </div>
                <div className="printable-area">
                  <h2>{dynamicTableTitle}</h2>
                  {isCustomerLedgerReport && ledgerMeta && (
                    <div className="ledger-summary" style={{ marginBottom: '12px', fontSize: '0.95em' }}>
                      {ledgerMeta.all_customers ? (
                        <>
                          <strong>All Customers</strong>
                          {' | '}
                          {ledgerMeta.customer_count || 0} customer(s)
                        </>
                      ) : (
                        <strong>{ledgerMeta.customer_name}</strong>
                      )}
                      {' | '}
                      Period: {ledgerMeta.from_date} to {ledgerMeta.to_date}
                      {!ledgerMeta.all_customers && (
                        <>
                          {' | '}
                          Opening: {Number(ledgerMeta.opening_balance || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                          {' | '}
                          Closing: {Number(ledgerMeta.closing_balance || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                        </>
                      )}
                    </div>
                  )}
                  <div className="report-table-scroll">
                    <div className="table-responsive-wrapper">
                      <table>
                        <thead>
                          <tr>
                            {tableColumns.map(column => (
                              <th
                                key={column}
                                className={isAmountColumn(column) ? 'report-amount-header' : ''}
                              >
                                {formatHeader(column)}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedTasks.length > 0 ? (
                            paginatedTasks.map((task, index) => (
                              <tr
                                key={task.task_id || `${task.customer_id || 'row'}-${task['Vch No'] || index}-${index}`}
                                className={isLedgerSummaryRow(task) ? 'ledger-summary-row' : ''}
                              >
                                {tableColumns.map(column => (
                                  <td
                                    key={`${task.task_id || index}-${column}`}
                                    className={isAmountColumn(column) ? 'report-amount-cell' : ''}
                                  >
                                    {renderCell(task, column)}
                                  </td>
                                ))}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={tableColumns.length || 1} className="status-message">No items found for the current selection.</td>
                            </tr>
                          )}
                        </tbody>
                        {hasColumnTotals && filteredAndSearchedTasks.length > 0 && (
                          <tfoot>
                            <tr className="report-total-row">
                              {tableColumns.map((column, index) => (
                                <td
                                  key={`total-${column}`}
                                  className={columnTotals[column] !== undefined ? 'report-total-amount' : ''}
                                >
                                  {index === totalLabelColumnIndex
                                    ? 'Total'
                                    : columnTotals[column] !== undefined
                                      ? formatReportTotal(columnTotals[column])
                                      : ''}
                                </td>
                              ))}
                            </tr>
                          </tfoot>
                        )}
                      </table>
                    </div>
                  </div>
                  {filteredAndSearchedTasks.length > 0 && (
                    <div className="pagination-controls non-printable">
                      <button onClick={handleFirstPage} disabled={currentPage === 1} className="pagination-button" title="First Page">{'|<'}</button>
                      <button onClick={handlePreviousPage} disabled={currentPage === 1} className="pagination-button" title="Previous Page">{'<'}</button>
                      <span className="pagination-info">
                        <input type="number" value={currentPage} onChange={handlePageInputChange} className="pagination-input" min="1" max={totalPages}/> of {totalPages}
                      </span>
                      <button onClick={handleNextPage} disabled={currentPage === totalPages} className="pagination-button" title="Next Page">{'>'}</button>
                      <button onClick={handleLastPage} disabled={currentPage === totalPages} className="pagination-button" title="Last Page">{'>|'}</button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {isEmailModalOpen && (
        <div className="email-modal-overlay">
          <div className="email-modal-content">
            <form onSubmit={handleSendEmail}>
              <div className="email-modal-header">
                <h3>Send Report via Email</h3>
                <button type="button" className="close-button" onClick={() => setIsEmailModalOpen(false)}>×</button>
              </div>
              <div className="email-modal-body">
                <div className="form-group">
                  <label htmlFor="email-to-select">To *</label>
                  <Select id="email-to-select" isMulti options={emailRecipients} value={emailTo} onChange={(selectedOptions) => setEmailTo(selectedOptions || [])} isLoading={isFetchingRecipients} placeholder="Search or select recipients..." closeMenuOnSelect={false} hideSelectedOptions={false} components={{ Option: CheckboxOption }} className="email-select-container" classNamePrefix="email-select" styles={customSelectStyles} />
                </div>
                <div className="form-group"><label htmlFor="email-cc">CC</label><input id="email-cc" type="text" value={emailCc} onChange={(e) => setEmailCc(e.target.value)} placeholder="Comma-separated emails" /></div>
                <div className="form-group"><label htmlFor="email-bcc">BCC</label><input id="email-bcc" type="text" value={emailBcc} onChange={(e) => setEmailBcc(e.target.value)} placeholder="Comma-separated emails" /></div>
                <div className="form-group"><label htmlFor="email-subject">Subject *</label><input id="email-subject" type="text" value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} required /></div>
                <div className="form-group">
                  <label htmlFor="email-body">Body *</label>
                  <textarea id="email-body" value={emailBody} onChange={(e) => setEmailBody(e.target.value)} rows="5" required />
                </div>
                <div className="form-group">
                  <label>Attachments</label>
                  <div className="attachment-list">
                    {emailAttachments.map((file, index) => (
                      <div key={index} className="attachment-item">
                        <span>{file.name} ({Math.round(file.size / 1024)} KB)</span>
                        <button type="button" className="remove-attachment-btn" onClick={() => handleRemoveAttachment(index)}>×</button>
                      </div>
                    ))}
                  </div>
                  <input type="file" ref={fileInputRef} onChange={handleAddAttachment} style={{ display: 'none' }} multiple />
                </div>
                {emailStatus.message && <div className={`email-status-message ${emailStatus.type}`}>{emailStatus.message}</div>}
              </div>
              <div className="email-modal-footer">
                <button type="button" className="cancel-btn" onClick={() => setIsEmailModalOpen(false)}>Cancel</button>
                <button type="submit" className="send-btn" disabled={emailSending}>{emailSending ? 'Sending...' : 'Send Email'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportPage;